(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirec560"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirec560"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("2l5av", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $1b418d46aafa0962$export$71511d61b312f219; });

var $lU9k7 = parcelRequire("lU9k7");

var $b7zoR = parcelRequire("b7zoR");

var $hgWCA = parcelRequire("hgWCA");

var $hb0L4 = parcelRequire("hb0L4");
function $1b418d46aafa0962$export$71511d61b312f219(arr) {
    return (0, $lU9k7._)(arr) || (0, $b7zoR._)(arr) || (0, $hb0L4._)(arr) || (0, $hgWCA._)();
}

});
parcelRegister("lU9k7", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $ff260f652f2fcf52$export$71511d61b312f219; });

var $IM26N = parcelRequire("IM26N");
function $ff260f652f2fcf52$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $IM26N._)(arr);
}

});
parcelRegister("IM26N", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $08695e87d0b74b63$export$71511d61b312f219; });
function $08695e87d0b74b63$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});


parcelRegister("b7zoR", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $818bcedd0892ef18$export$71511d61b312f219; });
function $818bcedd0892ef18$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("hgWCA", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $033ebb78eb0c991c$export$71511d61b312f219; });
function $033ebb78eb0c991c$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRegister("hb0L4", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $c8140d49fd6310ae$export$71511d61b312f219; });

var $IM26N = parcelRequire("IM26N");
function $c8140d49fd6310ae$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $IM26N._)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $IM26N._)(o, minLen);
}

});


parcelRegister("aqUTs", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $798876f3dcb43993$export$71511d61b312f219; });
function $798876f3dcb43993$export$71511d61b312f219(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});

var $443abc400d22a160$exports = {};
/**
 * Import Bootstrap JS
 */ 
var $2l5av = parcelRequire("2l5av");
/*!
  * Bootstrap v5.3.8 (https://getbootstrap.com/)
  * Copyright 2011-2025 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ function $bf96ff342948c5d5$export$71511d61b312f219(o) {
    $bf96ff342948c5d5$export$71511d61b312f219 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $bf96ff342948c5d5$export$71511d61b312f219(o);
}


function $040ec9c1dba9a444$export$71511d61b312f219() {
    // Since Reflect.construct can't be properly polyfilled, some
    // implementations (e.g. core-js@2) don't set the correct internal slots.
    // Those polyfills don't allow us to subclass built-ins, so we need to
    // use our fallback implementation.
    try {
        // If the internal slots aren't set, this throws an error similar to
        //   TypeError: this is not a Boolean object.
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return ($040ec9c1dba9a444$export$71511d61b312f219 = function() {
        return !!result;
    })();
}


function $62e5387b8bf3eb21$export$71511d61b312f219(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}



var $aqUTs = parcelRequire("aqUTs");
function $f42b3052967027bf$export$71511d61b312f219(self, call) {
    if (call && ((0, $aqUTs._)(call) === "object" || typeof call === "function")) return call;
    return (0, $62e5387b8bf3eb21$export$71511d61b312f219)(self);
}


function $ffc84c232c16c006$export$71511d61b312f219(_this, derived, args) {
    // Super
    derived = (0, $bf96ff342948c5d5$export$71511d61b312f219)(derived);
    return (0, $f42b3052967027bf$export$71511d61b312f219)(_this, (0, $040ec9c1dba9a444$export$71511d61b312f219)() ? Reflect.construct(derived, args || [], (0, $bf96ff342948c5d5$export$71511d61b312f219)(_this).constructor) : derived.apply(_this, args));
}


function $86c0177781495fc1$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $c2914329721d6e2b$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $c2914329721d6e2b$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $c2914329721d6e2b$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $c2914329721d6e2b$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


function $eac6a0488bea45ee$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}



function $5c417447a98e8fee$export$71511d61b312f219(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = (0, $bf96ff342948c5d5$export$71511d61b312f219)(object);
        if (object === null) break;
    }
    return object;
}


function $63451875c32f6bcb$export$71511d61b312f219(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) $63451875c32f6bcb$export$71511d61b312f219 = Reflect.get;
    else $63451875c32f6bcb$export$71511d61b312f219 = function get(target, property, receiver) {
        var base = (0, $5c417447a98e8fee$export$71511d61b312f219)(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(receiver || target);
        return desc.value;
    };
    return $63451875c32f6bcb$export$71511d61b312f219(target, property, receiver || target);
}



function $76a5c0ba84af77cd$export$71511d61b312f219(o, p) {
    $76a5c0ba84af77cd$export$71511d61b312f219 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $76a5c0ba84af77cd$export$71511d61b312f219(o, p);
}


function $b4d46f07ff8e4522$export$71511d61b312f219(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $76a5c0ba84af77cd$export$71511d61b312f219)(subClass, superClass);
}



function $54f510fc1e3f8947$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $eac6a0488bea45ee$export$71511d61b312f219)(target, key, source[key]);
        });
    }
    return target;
}


function $b436c975fcff02ae$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $b436c975fcff02ae$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $b436c975fcff02ae$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}



function $db06d1f3d39f890b$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}


function $d6dc237ff3cf1003$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}


function $df53f515b350a556$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



var $hb0L4 = parcelRequire("hb0L4");
function $6557624075f14dc6$export$71511d61b312f219(arr, i) {
    return (0, $db06d1f3d39f890b$export$71511d61b312f219)(arr) || (0, $d6dc237ff3cf1003$export$71511d61b312f219)(arr, i) || (0, $hb0L4._)(arr, i) || (0, $df53f515b350a556$export$71511d61b312f219)();
}



var $2l5av = parcelRequire("2l5av");

var $aqUTs = parcelRequire("aqUTs");
var $d924a49372bb56ad$exports = {};

$parcel$export($d924a49372bb56ad$exports, "popperGenerator", function () { return $b49c39ebb908ca07$export$ed5e13716264f202; });
$parcel$export($d924a49372bb56ad$exports, "detectOverflow", function () { return $773f729d6efca0a6$export$2e2bcd8739ae039; });
$parcel$export($d924a49372bb56ad$exports, "createPopperBase", function () { return $b49c39ebb908ca07$export$8f7491d57c8f97a9; });
$parcel$export($d924a49372bb56ad$exports, "createPopper", function () { return $9a4cf20a973fb40b$export$8f7491d57c8f97a9; });
$parcel$export($d924a49372bb56ad$exports, "createPopperLite", function () { return $870343167bc7408a$export$8f7491d57c8f97a9; });
var $8529515e022b495d$exports = {};

$parcel$export($8529515e022b495d$exports, "top", function () { return $8529515e022b495d$export$1e95b668f3b82d; });
$parcel$export($8529515e022b495d$exports, "bottom", function () { return $8529515e022b495d$export$40e543e69a8b3fbb; });
$parcel$export($8529515e022b495d$exports, "right", function () { return $8529515e022b495d$export$79ffe56a765070d2; });
$parcel$export($8529515e022b495d$exports, "left", function () { return $8529515e022b495d$export$eabcd2c8791e7bf4; });
$parcel$export($8529515e022b495d$exports, "auto", function () { return $8529515e022b495d$export$dfb5619354ba860; });
$parcel$export($8529515e022b495d$exports, "basePlacements", function () { return $8529515e022b495d$export$aec2ce47c367b8c3; });
$parcel$export($8529515e022b495d$exports, "start", function () { return $8529515e022b495d$export$b3571188c770cc5a; });
$parcel$export($8529515e022b495d$exports, "end", function () { return $8529515e022b495d$export$bd5df0f255a350f8; });
$parcel$export($8529515e022b495d$exports, "clippingParents", function () { return $8529515e022b495d$export$390fd549c5303b4d; });
$parcel$export($8529515e022b495d$exports, "viewport", function () { return $8529515e022b495d$export$d7b7311ec04a3e8f; });
$parcel$export($8529515e022b495d$exports, "popper", function () { return $8529515e022b495d$export$ae5ab1c730825774; });
$parcel$export($8529515e022b495d$exports, "reference", function () { return $8529515e022b495d$export$ca50aac9f3ba507f; });
$parcel$export($8529515e022b495d$exports, "variationPlacements", function () { return $8529515e022b495d$export$368f9a87e87fa4e1; });
$parcel$export($8529515e022b495d$exports, "placements", function () { return $8529515e022b495d$export$803cd8101b6c182b; });
$parcel$export($8529515e022b495d$exports, "beforeRead", function () { return $8529515e022b495d$export$421679a7c3d56e; });
$parcel$export($8529515e022b495d$exports, "read", function () { return $8529515e022b495d$export$aafa59e2e03f2942; });
$parcel$export($8529515e022b495d$exports, "afterRead", function () { return $8529515e022b495d$export$6964f6c886723980; });
$parcel$export($8529515e022b495d$exports, "beforeMain", function () { return $8529515e022b495d$export$c65e99957a05207c; });
$parcel$export($8529515e022b495d$exports, "main", function () { return $8529515e022b495d$export$f22da7240b7add18; });
$parcel$export($8529515e022b495d$exports, "afterMain", function () { return $8529515e022b495d$export$bab79516f2d662fe; });
$parcel$export($8529515e022b495d$exports, "beforeWrite", function () { return $8529515e022b495d$export$8d4d2d70e7d46032; });
$parcel$export($8529515e022b495d$exports, "write", function () { return $8529515e022b495d$export$68d8715fc104d294; });
$parcel$export($8529515e022b495d$exports, "afterWrite", function () { return $8529515e022b495d$export$70a6e5159acce2e6; });
$parcel$export($8529515e022b495d$exports, "modifierPhases", function () { return $8529515e022b495d$export$d087d3878fdf71d5; });
var $8529515e022b495d$export$1e95b668f3b82d = 'top';
var $8529515e022b495d$export$40e543e69a8b3fbb = 'bottom';
var $8529515e022b495d$export$79ffe56a765070d2 = 'right';
var $8529515e022b495d$export$eabcd2c8791e7bf4 = 'left';
var $8529515e022b495d$export$dfb5619354ba860 = 'auto';
var $8529515e022b495d$export$aec2ce47c367b8c3 = [
    $8529515e022b495d$export$1e95b668f3b82d,
    $8529515e022b495d$export$40e543e69a8b3fbb,
    $8529515e022b495d$export$79ffe56a765070d2,
    $8529515e022b495d$export$eabcd2c8791e7bf4
];
var $8529515e022b495d$export$b3571188c770cc5a = 'start';
var $8529515e022b495d$export$bd5df0f255a350f8 = 'end';
var $8529515e022b495d$export$390fd549c5303b4d = 'clippingParents';
var $8529515e022b495d$export$d7b7311ec04a3e8f = 'viewport';
var $8529515e022b495d$export$ae5ab1c730825774 = 'popper';
var $8529515e022b495d$export$ca50aac9f3ba507f = 'reference';
var $8529515e022b495d$export$368f9a87e87fa4e1 = /*#__PURE__*/ $8529515e022b495d$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $8529515e022b495d$export$b3571188c770cc5a,
        placement + "-" + $8529515e022b495d$export$bd5df0f255a350f8
    ]);
}, []);
var $8529515e022b495d$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($8529515e022b495d$export$aec2ce47c367b8c3, [
    $8529515e022b495d$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $8529515e022b495d$export$b3571188c770cc5a,
        placement + "-" + $8529515e022b495d$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $8529515e022b495d$export$421679a7c3d56e = 'beforeRead';
var $8529515e022b495d$export$aafa59e2e03f2942 = 'read';
var $8529515e022b495d$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $8529515e022b495d$export$c65e99957a05207c = 'beforeMain';
var $8529515e022b495d$export$f22da7240b7add18 = 'main';
var $8529515e022b495d$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $8529515e022b495d$export$8d4d2d70e7d46032 = 'beforeWrite';
var $8529515e022b495d$export$68d8715fc104d294 = 'write';
var $8529515e022b495d$export$70a6e5159acce2e6 = 'afterWrite';
var $8529515e022b495d$export$d087d3878fdf71d5 = [
    $8529515e022b495d$export$421679a7c3d56e,
    $8529515e022b495d$export$aafa59e2e03f2942,
    $8529515e022b495d$export$6964f6c886723980,
    $8529515e022b495d$export$c65e99957a05207c,
    $8529515e022b495d$export$f22da7240b7add18,
    $8529515e022b495d$export$bab79516f2d662fe,
    $8529515e022b495d$export$8d4d2d70e7d46032,
    $8529515e022b495d$export$68d8715fc104d294,
    $8529515e022b495d$export$70a6e5159acce2e6
];


var $29d5e77dcf02b106$exports = {};

$parcel$export($29d5e77dcf02b106$exports, "applyStyles", function () { return $85451304914bce3e$export$2e2bcd8739ae039; });
$parcel$export($29d5e77dcf02b106$exports, "arrow", function () { return $32657e909b53d261$export$2e2bcd8739ae039; });
$parcel$export($29d5e77dcf02b106$exports, "computeStyles", function () { return $83019ac9e89efea0$export$2e2bcd8739ae039; });
$parcel$export($29d5e77dcf02b106$exports, "eventListeners", function () { return $1108034b03a863ef$export$2e2bcd8739ae039; });
$parcel$export($29d5e77dcf02b106$exports, "flip", function () { return $f7435670868c870d$export$2e2bcd8739ae039; });
$parcel$export($29d5e77dcf02b106$exports, "hide", function () { return $10b24608c01c3a0e$export$2e2bcd8739ae039; });
$parcel$export($29d5e77dcf02b106$exports, "offset", function () { return $432a12c859797b4f$export$2e2bcd8739ae039; });
$parcel$export($29d5e77dcf02b106$exports, "popperOffsets", function () { return $405a730ee853d618$export$2e2bcd8739ae039; });
$parcel$export($29d5e77dcf02b106$exports, "preventOverflow", function () { return $247669d716ada14a$export$2e2bcd8739ae039; });
function $2036ec6895004373$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}


function $7e4cbf2e2765da00$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $bc8bacf85cbc0fa8$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $7e4cbf2e2765da00$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $bc8bacf85cbc0fa8$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $7e4cbf2e2765da00$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $bc8bacf85cbc0fa8$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $7e4cbf2e2765da00$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


// and applies them to the HTMLElements such as popper and arrow
function $85451304914bce3e$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $bc8bacf85cbc0fa8$export$1b3bfaa9684536aa)(element) || !(0, $2036ec6895004373$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $85451304914bce3e$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $bc8bacf85cbc0fa8$export$1b3bfaa9684536aa)(element) || !(0, $2036ec6895004373$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $85451304914bce3e$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $85451304914bce3e$var$applyStyles,
    effect: $85451304914bce3e$var$effect,
    requires: [
        'computeStyles'
    ]
};



function $943abd9eb78839e5$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}



var $b2b7f02e2c150eaf$export$8960430cfd85939f = Math.max;
var $b2b7f02e2c150eaf$export$96ec731ed4dcb222 = Math.min;
var $b2b7f02e2c150eaf$export$2077e0241d6afd3c = Math.round;



function $44cf277465645239$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}


function $03431533064564ed$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $44cf277465645239$export$2e2bcd8739ae039)());
}


function $4735247725d08e00$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $bc8bacf85cbc0fa8$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $b2b7f02e2c150eaf$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $b2b7f02e2c150eaf$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $bc8bacf85cbc0fa8$export$45a5e7f76e0caa8d)(element) ? (0, $7e4cbf2e2765da00$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $03431533064564ed$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}


function $033d2ee56cf0832c$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $4735247725d08e00$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}



function $98a49ba0593f90e3$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $bc8bacf85cbc0fa8$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}





function $d669dbcba25de459$export$2e2bcd8739ae039(element) {
    return (0, $7e4cbf2e2765da00$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}




function $1b892e13ec18f02a$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $2036ec6895004373$export$2e2bcd8739ae039)(element)) >= 0;
}




function $fe173f3a2d7d51bd$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $bc8bacf85cbc0fa8$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $0aed65697cbb2e10$export$2e2bcd8739ae039(element) {
    if ((0, $2036ec6895004373$export$2e2bcd8739ae039)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $bc8bacf85cbc0fa8$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $fe173f3a2d7d51bd$export$2e2bcd8739ae039)(element) // fallback
    );
}



function $1f6a8f99f4cf6232$var$getTrueOffsetParent(element) {
    if (!(0, $bc8bacf85cbc0fa8$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $d669dbcba25de459$export$2e2bcd8739ae039)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $1f6a8f99f4cf6232$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $44cf277465645239$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $44cf277465645239$export$2e2bcd8739ae039)());
    if (isIE && (0, $bc8bacf85cbc0fa8$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $d669dbcba25de459$export$2e2bcd8739ae039)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $0aed65697cbb2e10$export$2e2bcd8739ae039)(element);
    if ((0, $bc8bacf85cbc0fa8$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $bc8bacf85cbc0fa8$export$1b3bfaa9684536aa)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $2036ec6895004373$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $d669dbcba25de459$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $1f6a8f99f4cf6232$export$2e2bcd8739ae039(element) {
    var window = (0, $7e4cbf2e2765da00$export$2e2bcd8739ae039)(element);
    var offsetParent = $1f6a8f99f4cf6232$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $1b892e13ec18f02a$export$2e2bcd8739ae039)(offsetParent) && (0, $d669dbcba25de459$export$2e2bcd8739ae039)(offsetParent).position === 'static')offsetParent = $1f6a8f99f4cf6232$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $2036ec6895004373$export$2e2bcd8739ae039)(offsetParent) === 'html' || (0, $2036ec6895004373$export$2e2bcd8739ae039)(offsetParent) === 'body' && (0, $d669dbcba25de459$export$2e2bcd8739ae039)(offsetParent).position === 'static')) return window;
    return offsetParent || $1f6a8f99f4cf6232$var$getContainingBlock(element) || window;
}


function $30c898face844a89$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}



function $83954d8ead2572d4$export$f28d906d67a997f3(min, value, max) {
    return (0, $b2b7f02e2c150eaf$export$8960430cfd85939f)(min, (0, $b2b7f02e2c150eaf$export$96ec731ed4dcb222)(value, max));
}
function $83954d8ead2572d4$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $83954d8ead2572d4$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}


function $f5dc9a5f83f3e9a9$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $21af64c6a7e83e2c$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $f5dc9a5f83f3e9a9$export$2e2bcd8739ae039)(), paddingObject);
}


function $6a7c911b2e8834ef$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}



var $32657e909b53d261$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $21af64c6a7e83e2c$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $6a7c911b2e8834ef$export$2e2bcd8739ae039)(padding, (0, $8529515e022b495d$export$aec2ce47c367b8c3)));
};
function $32657e909b53d261$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $943abd9eb78839e5$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $30c898face844a89$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $8529515e022b495d$export$eabcd2c8791e7bf4),
        (0, $8529515e022b495d$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $32657e909b53d261$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $033d2ee56cf0832c$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === 'y' ? (0, $8529515e022b495d$export$1e95b668f3b82d) : (0, $8529515e022b495d$export$eabcd2c8791e7bf4);
    var maxProp = axis === 'y' ? (0, $8529515e022b495d$export$40e543e69a8b3fbb) : (0, $8529515e022b495d$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $1f6a8f99f4cf6232$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $83954d8ead2572d4$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $32657e909b53d261$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $98a49ba0593f90e3$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $32657e909b53d261$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $32657e909b53d261$var$arrow,
    effect: $32657e909b53d261$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};








function $7d5f455b796693cd$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}



var $83019ac9e89efea0$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $83019ac9e89efea0$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $b2b7f02e2c150eaf$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $b2b7f02e2c150eaf$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $83019ac9e89efea0$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $8529515e022b495d$export$eabcd2c8791e7bf4);
    var sideY = (0, $8529515e022b495d$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $1f6a8f99f4cf6232$export$2e2bcd8739ae039)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $7e4cbf2e2765da00$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $fe173f3a2d7d51bd$export$2e2bcd8739ae039)(popper);
            if ((0, $d669dbcba25de459$export$2e2bcd8739ae039)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $8529515e022b495d$export$1e95b668f3b82d) || (placement === (0, $8529515e022b495d$export$eabcd2c8791e7bf4) || placement === (0, $8529515e022b495d$export$79ffe56a765070d2)) && variation === (0, $8529515e022b495d$export$bd5df0f255a350f8)) {
            sideY = (0, $8529515e022b495d$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $8529515e022b495d$export$eabcd2c8791e7bf4) || (placement === (0, $8529515e022b495d$export$1e95b668f3b82d) || placement === (0, $8529515e022b495d$export$40e543e69a8b3fbb)) && variation === (0, $8529515e022b495d$export$bd5df0f255a350f8)) {
            sideX = (0, $8529515e022b495d$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $83019ac9e89efea0$var$unsetSides);
    var _ref4 = roundOffsets === true ? $83019ac9e89efea0$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $7e4cbf2e2765da00$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $83019ac9e89efea0$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $943abd9eb78839e5$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $7d5f455b796693cd$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $83019ac9e89efea0$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $83019ac9e89efea0$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $83019ac9e89efea0$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $83019ac9e89efea0$var$computeStyles,
    data: {}
};



var $1108034b03a863ef$var$passive = {
    passive: true
};
function $1108034b03a863ef$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $7e4cbf2e2765da00$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $1108034b03a863ef$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $1108034b03a863ef$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $1108034b03a863ef$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $1108034b03a863ef$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $1108034b03a863ef$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $1108034b03a863ef$var$effect,
    data: {}
};


var $e72922093cfb36ce$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $e72922093cfb36ce$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $e72922093cfb36ce$var$hash[matched];
    });
}



var $2eee196127ea7ffa$var$hash = {
    start: 'end',
    end: 'start'
};
function $2eee196127ea7ffa$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $2eee196127ea7ffa$var$hash[matched];
    });
}








function $baef4a8eded12194$export$2e2bcd8739ae039(node) {
    var win = (0, $7e4cbf2e2765da00$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}


function $e2776bbd16ea3263$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $4735247725d08e00$export$2e2bcd8739ae039)((0, $fe173f3a2d7d51bd$export$2e2bcd8739ae039)(element)).left + (0, $baef4a8eded12194$export$2e2bcd8739ae039)(element).scrollLeft;
}



function $6115f1f327bc63b4$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $7e4cbf2e2765da00$export$2e2bcd8739ae039)(element);
    var html = (0, $fe173f3a2d7d51bd$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $03431533064564ed$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $e2776bbd16ea3263$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $7b972b4385b158f6$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $fe173f3a2d7d51bd$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $baef4a8eded12194$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $b2b7f02e2c150eaf$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $b2b7f02e2c150eaf$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $e2776bbd16ea3263$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $d669dbcba25de459$export$2e2bcd8739ae039)(body || html).direction === 'rtl') x += (0, $b2b7f02e2c150eaf$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}




function $4cbd86a2c56f3e8c$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $d669dbcba25de459$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}




function $9459878d8e7305d9$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $2036ec6895004373$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $bc8bacf85cbc0fa8$export$1b3bfaa9684536aa)(node) && (0, $4cbd86a2c56f3e8c$export$2e2bcd8739ae039)(node)) return node;
    return $9459878d8e7305d9$export$2e2bcd8739ae039((0, $0aed65697cbb2e10$export$2e2bcd8739ae039)(node));
}





function $1eada9b84bc7e080$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $9459878d8e7305d9$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $7e4cbf2e2765da00$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $4cbd86a2c56f3e8c$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($1eada9b84bc7e080$export$2e2bcd8739ae039((0, $0aed65697cbb2e10$export$2e2bcd8739ae039)(target)));
}










function $ea5828c73deff4ef$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $0861b03af8c3c702$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $4735247725d08e00$export$2e2bcd8739ae039)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $0861b03af8c3c702$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $8529515e022b495d$export$d7b7311ec04a3e8f) ? (0, $ea5828c73deff4ef$export$2e2bcd8739ae039)((0, $6115f1f327bc63b4$export$2e2bcd8739ae039)(element, strategy)) : (0, $bc8bacf85cbc0fa8$export$45a5e7f76e0caa8d)(clippingParent) ? $0861b03af8c3c702$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $ea5828c73deff4ef$export$2e2bcd8739ae039)((0, $7b972b4385b158f6$export$2e2bcd8739ae039)((0, $fe173f3a2d7d51bd$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $0861b03af8c3c702$var$getClippingParents(element) {
    var clippingParents = (0, $1eada9b84bc7e080$export$2e2bcd8739ae039)((0, $0aed65697cbb2e10$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $d669dbcba25de459$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $bc8bacf85cbc0fa8$export$1b3bfaa9684536aa)(element) ? (0, $1f6a8f99f4cf6232$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $bc8bacf85cbc0fa8$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $bc8bacf85cbc0fa8$export$45a5e7f76e0caa8d)(clippingParent) && (0, $98a49ba0593f90e3$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $2036ec6895004373$export$2e2bcd8739ae039)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $0861b03af8c3c702$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $0861b03af8c3c702$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $0861b03af8c3c702$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $b2b7f02e2c150eaf$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $b2b7f02e2c150eaf$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $b2b7f02e2c150eaf$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $b2b7f02e2c150eaf$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $0861b03af8c3c702$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $0907bb9adf02bcfb$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $943abd9eb78839e5$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $7d5f455b796693cd$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $8529515e022b495d$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $8529515e022b495d$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $8529515e022b495d$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $8529515e022b495d$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $30c898face844a89$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $8529515e022b495d$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $8529515e022b495d$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}







function $773f729d6efca0a6$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $8529515e022b495d$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $8529515e022b495d$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $8529515e022b495d$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $21af64c6a7e83e2c$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $6a7c911b2e8834ef$export$2e2bcd8739ae039)(padding, (0, $8529515e022b495d$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $8529515e022b495d$export$ae5ab1c730825774) ? (0, $8529515e022b495d$export$ca50aac9f3ba507f) : (0, $8529515e022b495d$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $0861b03af8c3c702$export$2e2bcd8739ae039)((0, $bc8bacf85cbc0fa8$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $fe173f3a2d7d51bd$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $4735247725d08e00$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $0907bb9adf02bcfb$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $ea5828c73deff4ef$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $8529515e022b495d$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $8529515e022b495d$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $8529515e022b495d$export$79ffe56a765070d2),
                (0, $8529515e022b495d$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $8529515e022b495d$export$1e95b668f3b82d),
                (0, $8529515e022b495d$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $7da52b1fec4c3a77$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $8529515e022b495d$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $7d5f455b796693cd$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $8529515e022b495d$export$368f9a87e87fa4e1) : (0, $8529515e022b495d$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $7d5f455b796693cd$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $8529515e022b495d$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $773f729d6efca0a6$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $943abd9eb78839e5$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $f7435670868c870d$var$getExpandedFallbackPlacements(placement) {
    if ((0, $943abd9eb78839e5$export$2e2bcd8739ae039)(placement) === (0, $8529515e022b495d$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $e72922093cfb36ce$export$2e2bcd8739ae039)(placement);
    return [
        (0, $2eee196127ea7ffa$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $2eee196127ea7ffa$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $f7435670868c870d$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $943abd9eb78839e5$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $e72922093cfb36ce$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $f7435670868c870d$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $943abd9eb78839e5$export$2e2bcd8739ae039)(placement) === (0, $8529515e022b495d$export$dfb5619354ba860) ? (0, $7da52b1fec4c3a77$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $943abd9eb78839e5$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $7d5f455b796693cd$export$2e2bcd8739ae039)(placement) === (0, $8529515e022b495d$export$b3571188c770cc5a);
        var isVertical = [
            (0, $8529515e022b495d$export$1e95b668f3b82d),
            (0, $8529515e022b495d$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $773f729d6efca0a6$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $8529515e022b495d$export$79ffe56a765070d2) : (0, $8529515e022b495d$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $8529515e022b495d$export$40e543e69a8b3fbb) : (0, $8529515e022b495d$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $e72922093cfb36ce$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $e72922093cfb36ce$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $f7435670868c870d$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $f7435670868c870d$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};




function $10b24608c01c3a0e$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $10b24608c01c3a0e$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $8529515e022b495d$export$1e95b668f3b82d),
        (0, $8529515e022b495d$export$79ffe56a765070d2),
        (0, $8529515e022b495d$export$40e543e69a8b3fbb),
        (0, $8529515e022b495d$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $10b24608c01c3a0e$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $773f729d6efca0a6$export$2e2bcd8739ae039)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $773f729d6efca0a6$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $10b24608c01c3a0e$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $10b24608c01c3a0e$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $10b24608c01c3a0e$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $10b24608c01c3a0e$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $10b24608c01c3a0e$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $10b24608c01c3a0e$var$hide
};




function $432a12c859797b4f$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $943abd9eb78839e5$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $8529515e022b495d$export$eabcd2c8791e7bf4),
        (0, $8529515e022b495d$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $8529515e022b495d$export$eabcd2c8791e7bf4),
        (0, $8529515e022b495d$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $432a12c859797b4f$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, _$offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $8529515e022b495d$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $432a12c859797b4f$export$7fa02d8595b015ed(placement, state.rects, _$offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $432a12c859797b4f$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $432a12c859797b4f$var$offset
};



function $405a730ee853d618$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $0907bb9adf02bcfb$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $405a730ee853d618$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $405a730ee853d618$var$popperOffsets,
    data: {}
};





function $bdb2b8d160e8625b$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}









function $247669d716ada14a$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $773f729d6efca0a6$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $943abd9eb78839e5$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $7d5f455b796693cd$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $30c898face844a89$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $bdb2b8d160e8625b$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $8529515e022b495d$export$1e95b668f3b82d) : (0, $8529515e022b495d$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === 'y' ? (0, $8529515e022b495d$export$40e543e69a8b3fbb) : (0, $8529515e022b495d$export$79ffe56a765070d2);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $8529515e022b495d$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $8529515e022b495d$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $033d2ee56cf0832c$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $f5dc9a5f83f3e9a9$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $83954d8ead2572d4$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $1f6a8f99f4cf6232$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $83954d8ead2572d4$export$f28d906d67a997f3)(tether ? (0, $b2b7f02e2c150eaf$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $b2b7f02e2c150eaf$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $8529515e022b495d$export$1e95b668f3b82d) : (0, $8529515e022b495d$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === 'x' ? (0, $8529515e022b495d$export$40e543e69a8b3fbb) : (0, $8529515e022b495d$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $8529515e022b495d$export$1e95b668f3b82d),
            (0, $8529515e022b495d$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $83954d8ead2572d4$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $83954d8ead2572d4$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $247669d716ada14a$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $247669d716ada14a$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};








function $3c430fb1c2804b4b$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $55bfba2552e47610$export$2e2bcd8739ae039(node) {
    if (node === (0, $7e4cbf2e2765da00$export$2e2bcd8739ae039)(node) || !(0, $bc8bacf85cbc0fa8$export$1b3bfaa9684536aa)(node)) return (0, $baef4a8eded12194$export$2e2bcd8739ae039)(node);
    else return (0, $3c430fb1c2804b4b$export$2e2bcd8739ae039)(node);
}








function $d0bd2b844046a825$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $b2b7f02e2c150eaf$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $b2b7f02e2c150eaf$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $d0bd2b844046a825$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $bc8bacf85cbc0fa8$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $bc8bacf85cbc0fa8$export$1b3bfaa9684536aa)(offsetParent) && $d0bd2b844046a825$var$isElementScaled(offsetParent);
    var documentElement = (0, $fe173f3a2d7d51bd$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $4735247725d08e00$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $2036ec6895004373$export$2e2bcd8739ae039)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $4cbd86a2c56f3e8c$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $55bfba2552e47610$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $bc8bacf85cbc0fa8$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $4735247725d08e00$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $e2776bbd16ea3263$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}






function $bd3c49393d159db7$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $bd3c49393d159db7$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $bd3c49393d159db7$var$order(modifiers); // order based on phase
    return (0, $8529515e022b495d$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $c0e728b75c6ca26c$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $7ea5301b44a7563a$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $b49c39ebb908ca07$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $b49c39ebb908ca07$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $b49c39ebb908ca07$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $b49c39ebb908ca07$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $b49c39ebb908ca07$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var _$options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, _$options);
                state.scrollParents = {
                    reference: (0, $bc8bacf85cbc0fa8$export$45a5e7f76e0caa8d)(reference) ? (0, $1eada9b84bc7e080$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $1eada9b84bc7e080$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $1eada9b84bc7e080$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $bd3c49393d159db7$export$2e2bcd8739ae039)((0, $7ea5301b44a7563a$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, _$reference = _state$elements.reference, _$popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$b49c39ebb908ca07$var$areValidElements(_$reference, _$popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $d0bd2b844046a825$export$2e2bcd8739ae039)(_$reference, (0, $1f6a8f99f4cf6232$export$2e2bcd8739ae039)(_$popper), state.options.strategy === 'fixed'),
                    popper: (0, $033d2ee56cf0832c$export$2e2bcd8739ae039)(_$popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $c0e728b75c6ca26c$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$b49c39ebb908ca07$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, _$options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: _$options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $b49c39ebb908ca07$export$8f7491d57c8f97a9 = /*#__PURE__*/ $b49c39ebb908ca07$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules














var $9a4cf20a973fb40b$export$d34966752335dd47 = [
    (0, $1108034b03a863ef$export$2e2bcd8739ae039),
    (0, $405a730ee853d618$export$2e2bcd8739ae039),
    (0, $83019ac9e89efea0$export$2e2bcd8739ae039),
    (0, $85451304914bce3e$export$2e2bcd8739ae039),
    (0, $432a12c859797b4f$export$2e2bcd8739ae039),
    (0, $f7435670868c870d$export$2e2bcd8739ae039),
    (0, $247669d716ada14a$export$2e2bcd8739ae039),
    (0, $32657e909b53d261$export$2e2bcd8739ae039),
    (0, $10b24608c01c3a0e$export$2e2bcd8739ae039)
];
var $9a4cf20a973fb40b$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $b49c39ebb908ca07$export$ed5e13716264f202)({
    defaultModifiers: $9a4cf20a973fb40b$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules







var $870343167bc7408a$export$d34966752335dd47 = [
    (0, $1108034b03a863ef$export$2e2bcd8739ae039),
    (0, $405a730ee853d618$export$2e2bcd8739ae039),
    (0, $83019ac9e89efea0$export$2e2bcd8739ae039),
    (0, $85451304914bce3e$export$2e2bcd8739ae039)
];
var $870343167bc7408a$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $b49c39ebb908ca07$export$ed5e13716264f202)({
    defaultModifiers: $870343167bc7408a$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules


$parcel$exportWildcard($d924a49372bb56ad$exports, $8529515e022b495d$exports);
$parcel$exportWildcard($d924a49372bb56ad$exports, $29d5e77dcf02b106$exports);


/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/data.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $fb0d70065cb9c259$var$elementMap = new Map();
var $fb0d70065cb9c259$var$Data = {
    set: function(element, key, instance) {
        if (!$fb0d70065cb9c259$var$elementMap.has(element)) $fb0d70065cb9c259$var$elementMap.set(element, new Map());
        var instanceMap = $fb0d70065cb9c259$var$elementMap.get(element);
        // make it clear we only want one instance per element
        // can be removed later when multiple key/instances are fine to be used
        if (!instanceMap.has(key) && instanceMap.size !== 0) {
            // eslint-disable-next-line no-console
            console.error("Bootstrap doesn't allow more than one instance per element. Bound instance: ".concat(Array.from(instanceMap.keys())[0], "."));
            return;
        }
        instanceMap.set(key, instance);
    },
    get: function(element, key) {
        if ($fb0d70065cb9c259$var$elementMap.has(element)) return $fb0d70065cb9c259$var$elementMap.get(element).get(key) || null;
        return null;
    },
    remove: function(element, key) {
        if (!$fb0d70065cb9c259$var$elementMap.has(element)) return;
        var instanceMap = $fb0d70065cb9c259$var$elementMap.get(element);
        instanceMap.delete(key);
        // free up element references if there are no instances left for an element
        if (instanceMap.size === 0) $fb0d70065cb9c259$var$elementMap.delete(element);
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/index.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ var $fb0d70065cb9c259$var$MAX_UID = 1000000;
var $fb0d70065cb9c259$var$MILLISECONDS_MULTIPLIER = 1000;
var $fb0d70065cb9c259$var$TRANSITION_END = 'transitionend';
/**
 * Properly escape IDs selectors to handle weird IDs
 * @param {string} selector
 * @returns {string}
 */ var $fb0d70065cb9c259$var$parseSelector = function(selector) {
    if (selector && window.CSS && window.CSS.escape) // document.querySelector needs escaping to handle IDs (html5+) containing for instance /
    selector = selector.replace(/#([^\s"#']+)/g, function(match, id) {
        return "#".concat(CSS.escape(id));
    });
    return selector;
};
// Shout-out Angus Croll (https://goo.gl/pxwQGp)
var $fb0d70065cb9c259$var$toType = function(object) {
    if (object === null || object === undefined) return "".concat(object);
    return Object.prototype.toString.call(object).match(/\s([a-z]+)/i)[1].toLowerCase();
};
/**
 * Public Util API
 */ var $fb0d70065cb9c259$var$getUID = function(prefix) {
    do prefix += Math.floor(Math.random() * $fb0d70065cb9c259$var$MAX_UID);
    while (document.getElementById(prefix));
    return prefix;
};
var $fb0d70065cb9c259$var$getTransitionDurationFromElement = function(element) {
    if (!element) return 0;
    // Get transition-duration of the element
    var _window_getComputedStyle = window.getComputedStyle(element), transitionDuration = _window_getComputedStyle.transitionDuration, transitionDelay = _window_getComputedStyle.transitionDelay;
    var floatTransitionDuration = Number.parseFloat(transitionDuration);
    var floatTransitionDelay = Number.parseFloat(transitionDelay);
    // Return 0 if element or transition duration is not found
    if (!floatTransitionDuration && !floatTransitionDelay) return 0;
    // If multiple durations are defined, take the first
    transitionDuration = transitionDuration.split(',')[0];
    transitionDelay = transitionDelay.split(',')[0];
    return (Number.parseFloat(transitionDuration) + Number.parseFloat(transitionDelay)) * $fb0d70065cb9c259$var$MILLISECONDS_MULTIPLIER;
};
var $fb0d70065cb9c259$var$triggerTransitionEnd = function(element) {
    element.dispatchEvent(new Event($fb0d70065cb9c259$var$TRANSITION_END));
};
var $fb0d70065cb9c259$var$isElement = function(object) {
    if (!object || (typeof object === "undefined" ? "undefined" : (0, $aqUTs._)(object)) !== 'object') return false;
    if (typeof object.jquery !== 'undefined') object = object[0];
    return typeof object.nodeType !== 'undefined';
};
var $fb0d70065cb9c259$var$getElement = function(object) {
    // it's a jQuery object or a node element
    if ($fb0d70065cb9c259$var$isElement(object)) return object.jquery ? object[0] : object;
    if (typeof object === 'string' && object.length > 0) return document.querySelector($fb0d70065cb9c259$var$parseSelector(object));
    return null;
};
var $fb0d70065cb9c259$var$isVisible = function(element) {
    if (!$fb0d70065cb9c259$var$isElement(element) || element.getClientRects().length === 0) return false;
    var elementIsVisible = getComputedStyle(element).getPropertyValue('visibility') === 'visible';
    // Handle `details` element as its content may falsie appear visible when it is closed
    var closedDetails = element.closest('details:not([open])');
    if (!closedDetails) return elementIsVisible;
    if (closedDetails !== element) {
        var summary = element.closest('summary');
        if (summary && summary.parentNode !== closedDetails) return false;
        if (summary === null) return false;
    }
    return elementIsVisible;
};
var $fb0d70065cb9c259$var$isDisabled = function(element) {
    if (!element || element.nodeType !== Node.ELEMENT_NODE) return true;
    if (element.classList.contains('disabled')) return true;
    if (typeof element.disabled !== 'undefined') return element.disabled;
    return element.hasAttribute('disabled') && element.getAttribute('disabled') !== 'false';
};
var $fb0d70065cb9c259$var$findShadowRoot = function(element) {
    if (!document.documentElement.attachShadow) return null;
    // Can find the shadow root otherwise it'll return the document
    if (typeof element.getRootNode === 'function') {
        var root = element.getRootNode();
        return root instanceof ShadowRoot ? root : null;
    }
    if (element instanceof ShadowRoot) return element;
    // when we don't find a shadow root
    if (!element.parentNode) return null;
    return $fb0d70065cb9c259$var$findShadowRoot(element.parentNode);
};
var $fb0d70065cb9c259$var$noop = function() {};
/**
 * Trick to restart an element's animation
 *
 * @param {HTMLElement} element
 * @return void
 *
 * @see https://www.harrytheo.com/blog/2021/02/restart-a-css-animation-with-javascript/#restarting-a-css-animation
 */ var $fb0d70065cb9c259$var$reflow = function(element) {
    element.offsetHeight; // eslint-disable-line no-unused-expressions
};
var $fb0d70065cb9c259$var$getjQuery = function() {
    if (window.jQuery && !document.body.hasAttribute('data-bs-no-jquery')) return window.jQuery;
    return null;
};
var $fb0d70065cb9c259$var$DOMContentLoadedCallbacks = [];
var $fb0d70065cb9c259$var$onDOMContentLoaded = function(callback) {
    if (document.readyState === 'loading') {
        // add listener on the first call when the document is in loading state
        if (!$fb0d70065cb9c259$var$DOMContentLoadedCallbacks.length) document.addEventListener('DOMContentLoaded', function() {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = $fb0d70065cb9c259$var$DOMContentLoadedCallbacks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _$callback = _step.value;
                    _$callback();
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        });
        $fb0d70065cb9c259$var$DOMContentLoadedCallbacks.push(callback);
    } else callback();
};
var $fb0d70065cb9c259$var$isRTL = function() {
    return document.documentElement.dir === 'rtl';
};
var $fb0d70065cb9c259$var$defineJQueryPlugin = function(plugin) {
    $fb0d70065cb9c259$var$onDOMContentLoaded(function() {
        var $ = $fb0d70065cb9c259$var$getjQuery();
        /* istanbul ignore if */ if ($) {
            var name = plugin.NAME;
            var JQUERY_NO_CONFLICT = $.fn[name];
            $.fn[name] = plugin.jQueryInterface;
            $.fn[name].Constructor = plugin;
            $.fn[name].noConflict = function() {
                $.fn[name] = JQUERY_NO_CONFLICT;
                return plugin.jQueryInterface;
            };
        }
    });
};
var $fb0d70065cb9c259$var$execute = function(possibleCallback) {
    var args = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], defaultValue = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : possibleCallback;
    var _possibleCallback;
    return typeof possibleCallback === 'function' ? (_possibleCallback = possibleCallback).call.apply(_possibleCallback, (0, $2l5av._)(args)) : defaultValue;
};
var $fb0d70065cb9c259$var$executeAfterTransition = function(callback, transitionElement) {
    var waitForTransition = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    if (!waitForTransition) {
        $fb0d70065cb9c259$var$execute(callback);
        return;
    }
    var durationPadding = 5;
    var emulatedDuration = $fb0d70065cb9c259$var$getTransitionDurationFromElement(transitionElement) + durationPadding;
    var called = false;
    var handler = function(param) {
        var target = param.target;
        if (target !== transitionElement) return;
        called = true;
        transitionElement.removeEventListener($fb0d70065cb9c259$var$TRANSITION_END, handler);
        $fb0d70065cb9c259$var$execute(callback);
    };
    transitionElement.addEventListener($fb0d70065cb9c259$var$TRANSITION_END, handler);
    setTimeout(function() {
        if (!called) $fb0d70065cb9c259$var$triggerTransitionEnd(transitionElement);
    }, emulatedDuration);
};
/**
 * Return the previous/next element of a list.
 *
 * @param {array} list    The list of elements
 * @param activeElement   The active element
 * @param shouldGetNext   Choose to get next or previous element
 * @param isCycleAllowed
 * @return {Element|elem} The proper element
 */ var $fb0d70065cb9c259$var$getNextActiveElement = function(list, activeElement, shouldGetNext, isCycleAllowed) {
    var listLength = list.length;
    var index = list.indexOf(activeElement);
    // if the element does not exist in the list return an element
    // depending on the direction and if cycle is allowed
    if (index === -1) return !shouldGetNext && isCycleAllowed ? list[listLength - 1] : list[0];
    index += shouldGetNext ? 1 : -1;
    if (isCycleAllowed) index = (index + listLength) % listLength;
    return list[Math.max(0, Math.min(index, listLength - 1))];
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/event-handler.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $fb0d70065cb9c259$var$namespaceRegex = /[^.]*(?=\..*)\.|.*/;
var $fb0d70065cb9c259$var$stripNameRegex = /\..*/;
var $fb0d70065cb9c259$var$stripUidRegex = /::\d+$/;
var $fb0d70065cb9c259$var$eventRegistry = {}; // Events storage
var $fb0d70065cb9c259$var$uidEvent = 1;
var $fb0d70065cb9c259$var$customEvents = {
    mouseenter: 'mouseover',
    mouseleave: 'mouseout'
};
var $fb0d70065cb9c259$var$nativeEvents = new Set([
    'click',
    'dblclick',
    'mouseup',
    'mousedown',
    'contextmenu',
    'mousewheel',
    'DOMMouseScroll',
    'mouseover',
    'mouseout',
    'mousemove',
    'selectstart',
    'selectend',
    'keydown',
    'keypress',
    'keyup',
    'orientationchange',
    'touchstart',
    'touchmove',
    'touchend',
    'touchcancel',
    'pointerdown',
    'pointermove',
    'pointerup',
    'pointerleave',
    'pointercancel',
    'gesturestart',
    'gesturechange',
    'gestureend',
    'focus',
    'blur',
    'change',
    'reset',
    'select',
    'submit',
    'focusin',
    'focusout',
    'load',
    'unload',
    'beforeunload',
    'resize',
    'move',
    'DOMContentLoaded',
    'readystatechange',
    'error',
    'abort',
    'scroll'
]);
/**
 * Private methods
 */ function $fb0d70065cb9c259$var$makeEventUid(element, uid) {
    return uid && "".concat(uid, "::").concat($fb0d70065cb9c259$var$uidEvent++) || element.uidEvent || $fb0d70065cb9c259$var$uidEvent++;
}
function $fb0d70065cb9c259$var$getElementEvents(element) {
    var uid = $fb0d70065cb9c259$var$makeEventUid(element);
    element.uidEvent = uid;
    $fb0d70065cb9c259$var$eventRegistry[uid] = $fb0d70065cb9c259$var$eventRegistry[uid] || {};
    return $fb0d70065cb9c259$var$eventRegistry[uid];
}
function $fb0d70065cb9c259$var$bootstrapHandler(element, fn) {
    return function handler(event) {
        $fb0d70065cb9c259$var$hydrateObj(event, {
            delegateTarget: element
        });
        if (handler.oneOff) $fb0d70065cb9c259$var$EventHandler.off(element, event.type, fn);
        return fn.apply(element, [
            event
        ]);
    };
}
function $fb0d70065cb9c259$var$bootstrapDelegationHandler(element, selector, fn) {
    return function handler(event) {
        var domElements = element.querySelectorAll(selector);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        for(var target = event.target; target && target !== this; target = target.parentNode)try {
            for(var _iterator = domElements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var domElement = _step.value;
                if (domElement !== target) continue;
                $fb0d70065cb9c259$var$hydrateObj(event, {
                    delegateTarget: target
                });
                if (handler.oneOff) $fb0d70065cb9c259$var$EventHandler.off(element, event.type, selector, fn);
                return fn.apply(target, [
                    event
                ]);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    };
}
function $fb0d70065cb9c259$var$findHandler(events, callable) {
    var delegationSelector = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    return Object.values(events).find(function(event) {
        return event.callable === callable && event.delegationSelector === delegationSelector;
    });
}
function $fb0d70065cb9c259$var$normalizeParameters(originalTypeEvent, handler, delegationFunction) {
    var isDelegated = typeof handler === 'string';
    // TODO: tooltip passes `false` instead of selector, so we need to check
    var callable = isDelegated ? delegationFunction : handler || delegationFunction;
    var typeEvent = $fb0d70065cb9c259$var$getTypeEvent(originalTypeEvent);
    if (!$fb0d70065cb9c259$var$nativeEvents.has(typeEvent)) typeEvent = originalTypeEvent;
    return [
        isDelegated,
        callable,
        typeEvent
    ];
}
function $fb0d70065cb9c259$var$addHandler(element, originalTypeEvent, handler, delegationFunction, oneOff) {
    if (typeof originalTypeEvent !== 'string' || !element) return;
    var _normalizeParameters = (0, $6557624075f14dc6$export$71511d61b312f219)($fb0d70065cb9c259$var$normalizeParameters(originalTypeEvent, handler, delegationFunction), 3), isDelegated = _normalizeParameters[0], callable = _normalizeParameters[1], typeEvent = _normalizeParameters[2];
    // in case of mouseenter or mouseleave wrap the handler within a function that checks for its DOM position
    // this prevents the handler from being dispatched the same way as mouseover or mouseout does
    if (originalTypeEvent in $fb0d70065cb9c259$var$customEvents) {
        var wrapFunction = function(fn) {
            return function wrapFunction(event) {
                if (!event.relatedTarget || event.relatedTarget !== event.delegateTarget && !event.delegateTarget.contains(event.relatedTarget)) return fn.call(this, event);
            };
        };
        callable = wrapFunction(callable);
    }
    var events = $fb0d70065cb9c259$var$getElementEvents(element);
    var handlers = events[typeEvent] || (events[typeEvent] = {});
    var previousFunction = $fb0d70065cb9c259$var$findHandler(handlers, callable, isDelegated ? handler : null);
    if (previousFunction) {
        previousFunction.oneOff = previousFunction.oneOff && oneOff;
        return;
    }
    var uid = $fb0d70065cb9c259$var$makeEventUid(callable, originalTypeEvent.replace($fb0d70065cb9c259$var$namespaceRegex, ''));
    var fn = isDelegated ? $fb0d70065cb9c259$var$bootstrapDelegationHandler(element, handler, callable) : $fb0d70065cb9c259$var$bootstrapHandler(element, callable);
    fn.delegationSelector = isDelegated ? handler : null;
    fn.callable = callable;
    fn.oneOff = oneOff;
    fn.uidEvent = uid;
    handlers[uid] = fn;
    element.addEventListener(typeEvent, fn, isDelegated);
}
function $fb0d70065cb9c259$var$removeHandler(element, events, typeEvent, handler, delegationSelector) {
    var fn = $fb0d70065cb9c259$var$findHandler(events[typeEvent], handler, delegationSelector);
    if (!fn) return;
    element.removeEventListener(typeEvent, fn, Boolean(delegationSelector));
    delete events[typeEvent][fn.uidEvent];
}
function $fb0d70065cb9c259$var$removeNamespacedHandlers(element, events, typeEvent, namespace) {
    var storeElementEvent = events[typeEvent] || {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.entries(storeElementEvent)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $6557624075f14dc6$export$71511d61b312f219)(_step.value, 2), handlerKey = _step_value[0], event = _step_value[1];
            if (handlerKey.includes(namespace)) $fb0d70065cb9c259$var$removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
function $fb0d70065cb9c259$var$getTypeEvent(event) {
    // allow to get the native events from namespaced events ('click.bs.button' --> 'click')
    event = event.replace($fb0d70065cb9c259$var$stripNameRegex, '');
    return $fb0d70065cb9c259$var$customEvents[event] || event;
}
var $fb0d70065cb9c259$var$EventHandler = {
    on: function(element, event, handler, delegationFunction) {
        $fb0d70065cb9c259$var$addHandler(element, event, handler, delegationFunction, false);
    },
    one: function(element, event, handler, delegationFunction) {
        $fb0d70065cb9c259$var$addHandler(element, event, handler, delegationFunction, true);
    },
    off: function(element, originalTypeEvent, handler, delegationFunction) {
        if (typeof originalTypeEvent !== 'string' || !element) return;
        var _normalizeParameters = (0, $6557624075f14dc6$export$71511d61b312f219)($fb0d70065cb9c259$var$normalizeParameters(originalTypeEvent, handler, delegationFunction), 3), isDelegated = _normalizeParameters[0], callable = _normalizeParameters[1], typeEvent = _normalizeParameters[2];
        var inNamespace = typeEvent !== originalTypeEvent;
        var events = $fb0d70065cb9c259$var$getElementEvents(element);
        var storeElementEvent = events[typeEvent] || {};
        var isNamespace = originalTypeEvent.startsWith('.');
        if (typeof callable !== 'undefined') {
            // Simplest case: handler is passed, remove that listener ONLY.
            if (!Object.keys(storeElementEvent).length) return;
            $fb0d70065cb9c259$var$removeHandler(element, events, typeEvent, callable, isDelegated ? handler : null);
            return;
        }
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        if (isNamespace) try {
            for(var _iterator = Object.keys(events)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var elementEvent = _step.value;
                $fb0d70065cb9c259$var$removeNamespacedHandlers(element, events, elementEvent, originalTypeEvent.slice(1));
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = Object.entries(storeElementEvent)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var _step_value = (0, $6557624075f14dc6$export$71511d61b312f219)(_step1.value, 2), keyHandlers = _step_value[0], event = _step_value[1];
                var handlerKey = keyHandlers.replace($fb0d70065cb9c259$var$stripUidRegex, '');
                if (!inNamespace || originalTypeEvent.includes(handlerKey)) $fb0d70065cb9c259$var$removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
    },
    trigger: function(element, event, args) {
        if (typeof event !== 'string' || !element) return null;
        var $ = $fb0d70065cb9c259$var$getjQuery();
        var typeEvent = $fb0d70065cb9c259$var$getTypeEvent(event);
        var inNamespace = event !== typeEvent;
        var jQueryEvent = null;
        var bubbles = true;
        var nativeDispatch = true;
        var defaultPrevented = false;
        if (inNamespace && $) {
            jQueryEvent = $.Event(event, args);
            $(element).trigger(jQueryEvent);
            bubbles = !jQueryEvent.isPropagationStopped();
            nativeDispatch = !jQueryEvent.isImmediatePropagationStopped();
            defaultPrevented = jQueryEvent.isDefaultPrevented();
        }
        var evt = $fb0d70065cb9c259$var$hydrateObj(new Event(event, {
            bubbles: bubbles,
            cancelable: true
        }), args);
        if (defaultPrevented) evt.preventDefault();
        if (nativeDispatch) element.dispatchEvent(evt);
        if (evt.defaultPrevented && jQueryEvent) jQueryEvent.preventDefault();
        return evt;
    }
};
function $fb0d70065cb9c259$var$hydrateObj(obj) {
    var meta = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var _step_value = (0, $6557624075f14dc6$export$71511d61b312f219)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            try {
                obj[key] = value;
            } catch (_unused) {
                Object.defineProperty(obj, key, {
                    configurable: true,
                    get: function() {
                        return value;
                    }
                });
            }
        };
        for(var _iterator = Object.entries(meta)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return obj;
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/manipulator.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ function $fb0d70065cb9c259$var$normalizeData(value) {
    if (value === 'true') return true;
    if (value === 'false') return false;
    if (value === Number(value).toString()) return Number(value);
    if (value === '' || value === 'null') return null;
    if (typeof value !== 'string') return value;
    try {
        return JSON.parse(decodeURIComponent(value));
    } catch (_unused) {
        return value;
    }
}
function $fb0d70065cb9c259$var$normalizeDataKey(key) {
    return key.replace(/[A-Z]/g, function(chr) {
        return "-".concat(chr.toLowerCase());
    });
}
var $fb0d70065cb9c259$var$Manipulator = {
    setDataAttribute: function(element, key, value) {
        element.setAttribute("data-bs-".concat($fb0d70065cb9c259$var$normalizeDataKey(key)), value);
    },
    removeDataAttribute: function(element, key) {
        element.removeAttribute("data-bs-".concat($fb0d70065cb9c259$var$normalizeDataKey(key)));
    },
    getDataAttributes: function(element) {
        if (!element) return {};
        var attributes = {};
        var bsKeys = Object.keys(element.dataset).filter(function(key) {
            return key.startsWith('bs') && !key.startsWith('bsConfig');
        });
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = bsKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                var pureKey = key.replace(/^bs/, '');
                pureKey = pureKey.charAt(0).toLowerCase() + pureKey.slice(1);
                attributes[pureKey] = $fb0d70065cb9c259$var$normalizeData(element.dataset[key]);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return attributes;
    },
    getDataAttribute: function(element, key) {
        return $fb0d70065cb9c259$var$normalizeData(element.getAttribute("data-bs-".concat($fb0d70065cb9c259$var$normalizeDataKey(key))));
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/config.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Class definition
 */ var $fb0d70065cb9c259$var$Config = /*#__PURE__*/ function() {
    "use strict";
    function Config() {
        (0, $86c0177781495fc1$export$71511d61b312f219)(this, Config);
    }
    (0, $c2914329721d6e2b$export$71511d61b312f219)(Config, [
        {
            key: "_getConfig",
            value: function _getConfig(config) {
                config = this._mergeConfigObj(config);
                config = this._configAfterMerge(config);
                this._typeCheckConfig(config);
                return config;
            }
        },
        {
            key: "_configAfterMerge",
            value: function _configAfterMerge(config) {
                return config;
            }
        },
        {
            key: "_mergeConfigObj",
            value: function _mergeConfigObj(config, element) {
                var jsonConfig = $fb0d70065cb9c259$var$isElement(element) ? $fb0d70065cb9c259$var$Manipulator.getDataAttribute(element, 'config') : {}; // try to parse
                return (0, $54f510fc1e3f8947$export$71511d61b312f219)({}, this.constructor.Default, (typeof jsonConfig === "undefined" ? "undefined" : (0, $aqUTs._)(jsonConfig)) === 'object' ? jsonConfig : {}, $fb0d70065cb9c259$var$isElement(element) ? $fb0d70065cb9c259$var$Manipulator.getDataAttributes(element) : {}, (typeof config === "undefined" ? "undefined" : (0, $aqUTs._)(config)) === 'object' ? config : {});
            }
        },
        {
            key: "_typeCheckConfig",
            value: function _typeCheckConfig(config) {
                var configTypes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.constructor.DefaultType;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.entries(configTypes)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $6557624075f14dc6$export$71511d61b312f219)(_step.value, 2), property = _step_value[0], expectedTypes = _step_value[1];
                        var value = config[property];
                        var valueType = $fb0d70065cb9c259$var$isElement(value) ? 'element' : $fb0d70065cb9c259$var$toType(value);
                        if (!new RegExp(expectedTypes).test(valueType)) throw new TypeError("".concat(this.constructor.NAME.toUpperCase(), ': Option "').concat(property, '" provided type "').concat(valueType, '" but expected type "').concat(expectedTypes, '".'));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return {};
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return {};
            }
        },
        {
            key: "NAME",
            get: function get() {
                throw new Error('You have to implement the static method "NAME", for each component!');
            }
        }
    ]);
    return Config;
}();
/**
 * --------------------------------------------------------------------------
 * Bootstrap base-component.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $fb0d70065cb9c259$var$VERSION = '5.3.8';
/**
 * Class definition
 */ var $fb0d70065cb9c259$var$BaseComponent = /*#__PURE__*/ function(Config) {
    "use strict";
    (0, $b4d46f07ff8e4522$export$71511d61b312f219)(BaseComponent, Config);
    function BaseComponent(element, config) {
        (0, $86c0177781495fc1$export$71511d61b312f219)(this, BaseComponent);
        var _this;
        _this = (0, $ffc84c232c16c006$export$71511d61b312f219)(this, BaseComponent);
        element = $fb0d70065cb9c259$var$getElement(element);
        if (!element) return (0, $f42b3052967027bf$export$71511d61b312f219)(_this);
        _this._element = element;
        _this._config = _this._getConfig(config);
        $fb0d70065cb9c259$var$Data.set(_this._element, _this.constructor.DATA_KEY, _this);
        return _this;
    }
    (0, $c2914329721d6e2b$export$71511d61b312f219)(BaseComponent, [
        {
            // Public
            key: "dispose",
            value: function dispose() {
                $fb0d70065cb9c259$var$Data.remove(this._element, this.constructor.DATA_KEY);
                $fb0d70065cb9c259$var$EventHandler.off(this._element, this.constructor.EVENT_KEY);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.getOwnPropertyNames(this)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var propertyName = _step.value;
                        this[propertyName] = null;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            // Private
            key: "_queueCallback",
            value: function _queueCallback(callback, element) {
                var isAnimated = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
                $fb0d70065cb9c259$var$executeAfterTransition(callback, element, isAnimated);
            }
        },
        {
            key: "_getConfig",
            value: function _getConfig(config) {
                config = this._mergeConfigObj(config, this._element);
                config = this._configAfterMerge(config);
                this._typeCheckConfig(config);
                return config;
            }
        }
    ], [
        {
            key: "getInstance",
            value: // Static
            function getInstance(element) {
                return $fb0d70065cb9c259$var$Data.get($fb0d70065cb9c259$var$getElement(element), this.DATA_KEY);
            }
        },
        {
            key: "getOrCreateInstance",
            value: function getOrCreateInstance(element) {
                var config = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                return this.getInstance(element) || new this(element, (typeof config === "undefined" ? "undefined" : (0, $aqUTs._)(config)) === 'object' ? config : null);
            }
        },
        {
            key: "VERSION",
            get: function get() {
                return $fb0d70065cb9c259$var$VERSION;
            }
        },
        {
            key: "DATA_KEY",
            get: function get() {
                return "bs.".concat(this.NAME);
            }
        },
        {
            key: "EVENT_KEY",
            get: function get() {
                return ".".concat(this.DATA_KEY);
            }
        },
        {
            key: "eventName",
            value: function eventName(name) {
                return "".concat(name).concat(this.EVENT_KEY);
            }
        }
    ]);
    return BaseComponent;
}($fb0d70065cb9c259$var$Config);
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/selector-engine.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ var $fb0d70065cb9c259$var$getSelector = function(element) {
    var selector = element.getAttribute('data-bs-target');
    if (!selector || selector === '#') {
        var hrefAttribute = element.getAttribute('href');
        // The only valid content that could double as a selector are IDs or classes,
        // so everything starting with `#` or `.`. If a "real" URL is used as the selector,
        // `document.querySelector` will rightfully complain it is invalid.
        // See https://github.com/twbs/bootstrap/issues/32273
        if (!hrefAttribute || !hrefAttribute.includes('#') && !hrefAttribute.startsWith('.')) return null;
        // Just in case some CMS puts out a full URL with the anchor appended
        if (hrefAttribute.includes('#') && !hrefAttribute.startsWith('#')) hrefAttribute = "#".concat(hrefAttribute.split('#')[1]);
        selector = hrefAttribute && hrefAttribute !== '#' ? hrefAttribute.trim() : null;
    }
    return selector ? selector.split(',').map(function(sel) {
        return $fb0d70065cb9c259$var$parseSelector(sel);
    }).join(',') : null;
};
var $fb0d70065cb9c259$var$SelectorEngine = {
    find: function(selector) {
        var element = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : document.documentElement;
        var _instance;
        return (_instance = []).concat.apply(_instance, (0, $2l5av._)(Element.prototype.querySelectorAll.call(element, selector)));
    },
    findOne: function(selector) {
        var element = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : document.documentElement;
        return Element.prototype.querySelector.call(element, selector);
    },
    children: function(element, selector) {
        var _instance;
        return (_instance = []).concat.apply(_instance, (0, $2l5av._)(element.children)).filter(function(child) {
            return child.matches(selector);
        });
    },
    parents: function(element, selector) {
        var parents = [];
        var ancestor = element.parentNode.closest(selector);
        while(ancestor){
            parents.push(ancestor);
            ancestor = ancestor.parentNode.closest(selector);
        }
        return parents;
    },
    prev: function(element, selector) {
        var previous = element.previousElementSibling;
        while(previous){
            if (previous.matches(selector)) return [
                previous
            ];
            previous = previous.previousElementSibling;
        }
        return [];
    },
    // TODO: this is now unused; remove later along with prev()
    next: function(element, selector) {
        var next = element.nextElementSibling;
        while(next){
            if (next.matches(selector)) return [
                next
            ];
            next = next.nextElementSibling;
        }
        return [];
    },
    focusableChildren: function(element) {
        var focusables = [
            'a',
            'button',
            'input',
            'textarea',
            'select',
            'details',
            '[tabindex]',
            '[contenteditable="true"]'
        ].map(function(selector) {
            return "".concat(selector, ':not([tabindex^="-"])');
        }).join(',');
        return this.find(focusables, element).filter(function(el) {
            return !$fb0d70065cb9c259$var$isDisabled(el) && $fb0d70065cb9c259$var$isVisible(el);
        });
    },
    getSelectorFromElement: function(element) {
        var selector = $fb0d70065cb9c259$var$getSelector(element);
        if (selector) return $fb0d70065cb9c259$var$SelectorEngine.findOne(selector) ? selector : null;
        return null;
    },
    getElementFromSelector: function(element) {
        var selector = $fb0d70065cb9c259$var$getSelector(element);
        return selector ? $fb0d70065cb9c259$var$SelectorEngine.findOne(selector) : null;
    },
    getMultipleElementsFromSelector: function(element) {
        var selector = $fb0d70065cb9c259$var$getSelector(element);
        return selector ? $fb0d70065cb9c259$var$SelectorEngine.find(selector) : [];
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/component-functions.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ var $fb0d70065cb9c259$var$enableDismissTrigger = function(component) {
    var method = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'hide';
    var clickEvent = "click.dismiss".concat(component.EVENT_KEY);
    var name = component.NAME;
    $fb0d70065cb9c259$var$EventHandler.on(document, clickEvent, '[data-bs-dismiss="'.concat(name, '"]'), function(event) {
        if ([
            'A',
            'AREA'
        ].includes(this.tagName)) event.preventDefault();
        if ($fb0d70065cb9c259$var$isDisabled(this)) return;
        var target = $fb0d70065cb9c259$var$SelectorEngine.getElementFromSelector(this) || this.closest(".".concat(name));
        var instance = component.getOrCreateInstance(target);
        // Method argument is left, for Alert and only, as it doesn't implement the 'hide' method
        instance[method]();
    });
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap alert.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $fb0d70065cb9c259$var$NAME$f = 'alert';
var $fb0d70065cb9c259$var$DATA_KEY$a = 'bs.alert';
var $fb0d70065cb9c259$var$EVENT_KEY$b = ".".concat($fb0d70065cb9c259$var$DATA_KEY$a);
var $fb0d70065cb9c259$var$EVENT_CLOSE = "close".concat($fb0d70065cb9c259$var$EVENT_KEY$b);
var $fb0d70065cb9c259$var$EVENT_CLOSED = "closed".concat($fb0d70065cb9c259$var$EVENT_KEY$b);
var $fb0d70065cb9c259$var$CLASS_NAME_FADE$5 = 'fade';
var $fb0d70065cb9c259$var$CLASS_NAME_SHOW$8 = 'show';
/**
 * Class definition
 */ var $fb0d70065cb9c259$export$caec2af78bcc877f = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $b4d46f07ff8e4522$export$71511d61b312f219)(Alert, BaseComponent);
    function Alert() {
        (0, $86c0177781495fc1$export$71511d61b312f219)(this, Alert);
        return (0, $ffc84c232c16c006$export$71511d61b312f219)(this, Alert, arguments);
    }
    (0, $c2914329721d6e2b$export$71511d61b312f219)(Alert, [
        {
            // Public
            key: "close",
            value: function close() {
                var _this = this;
                var closeEvent = $fb0d70065cb9c259$var$EventHandler.trigger(this._element, $fb0d70065cb9c259$var$EVENT_CLOSE);
                if (closeEvent.defaultPrevented) return;
                this._element.classList.remove($fb0d70065cb9c259$var$CLASS_NAME_SHOW$8);
                var isAnimated = this._element.classList.contains($fb0d70065cb9c259$var$CLASS_NAME_FADE$5);
                this._queueCallback(function() {
                    return _this._destroyElement();
                }, this._element, isAnimated);
            }
        },
        {
            // Private
            key: "_destroyElement",
            value: function _destroyElement() {
                this._element.remove();
                $fb0d70065cb9c259$var$EventHandler.trigger(this._element, $fb0d70065cb9c259$var$EVENT_CLOSED);
                this.dispose();
            }
        }
    ], [
        {
            key: "NAME",
            get: // Getters
            function get() {
                return $fb0d70065cb9c259$var$NAME$f;
            }
        },
        {
            key: "jQueryInterface",
            value: // Static
            function jQueryInterface(config) {
                return this.each(function() {
                    var data = Alert.getOrCreateInstance(this);
                    if (typeof config !== 'string') return;
                    if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError('No method named "'.concat(config, '"'));
                    data[config](this);
                });
            }
        }
    ]);
    return Alert;
}($fb0d70065cb9c259$var$BaseComponent);
/**
 * Data API implementation
 */ $fb0d70065cb9c259$var$enableDismissTrigger($fb0d70065cb9c259$export$caec2af78bcc877f, 'close');
/**
 * jQuery
 */ $fb0d70065cb9c259$var$defineJQueryPlugin($fb0d70065cb9c259$export$caec2af78bcc877f);
/**
 * --------------------------------------------------------------------------
 * Bootstrap button.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $fb0d70065cb9c259$var$NAME$e = 'button';
var $fb0d70065cb9c259$var$DATA_KEY$9 = 'bs.button';
var $fb0d70065cb9c259$var$EVENT_KEY$a = ".".concat($fb0d70065cb9c259$var$DATA_KEY$9);
var $fb0d70065cb9c259$var$DATA_API_KEY$6 = '.data-api';
var $fb0d70065cb9c259$var$CLASS_NAME_ACTIVE$3 = 'active';
var $fb0d70065cb9c259$var$SELECTOR_DATA_TOGGLE$5 = '[data-bs-toggle="button"]';
var $fb0d70065cb9c259$var$EVENT_CLICK_DATA_API$6 = "click".concat($fb0d70065cb9c259$var$EVENT_KEY$a).concat($fb0d70065cb9c259$var$DATA_API_KEY$6);
/**
 * Class definition
 */ var $fb0d70065cb9c259$export$353f5b6fc5456de1 = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $b4d46f07ff8e4522$export$71511d61b312f219)(Button, BaseComponent);
    function Button() {
        (0, $86c0177781495fc1$export$71511d61b312f219)(this, Button);
        return (0, $ffc84c232c16c006$export$71511d61b312f219)(this, Button, arguments);
    }
    (0, $c2914329721d6e2b$export$71511d61b312f219)(Button, [
        {
            // Public
            key: "toggle",
            value: function toggle() {
                // Toggle class and sync the `aria-pressed` attribute with the return value of the `.toggle()` method
                this._element.setAttribute('aria-pressed', this._element.classList.toggle($fb0d70065cb9c259$var$CLASS_NAME_ACTIVE$3));
            }
        }
    ], [
        {
            key: "NAME",
            get: // Getters
            function get() {
                return $fb0d70065cb9c259$var$NAME$e;
            }
        },
        {
            key: "jQueryInterface",
            value: // Static
            function jQueryInterface(config) {
                return this.each(function() {
                    var data = Button.getOrCreateInstance(this);
                    if (config === 'toggle') data[config]();
                });
            }
        }
    ]);
    return Button;
}($fb0d70065cb9c259$var$BaseComponent);
/**
 * Data API implementation
 */ $fb0d70065cb9c259$var$EventHandler.on(document, $fb0d70065cb9c259$var$EVENT_CLICK_DATA_API$6, $fb0d70065cb9c259$var$SELECTOR_DATA_TOGGLE$5, function(event) {
    event.preventDefault();
    var button = event.target.closest($fb0d70065cb9c259$var$SELECTOR_DATA_TOGGLE$5);
    var data = $fb0d70065cb9c259$export$353f5b6fc5456de1.getOrCreateInstance(button);
    data.toggle();
});
/**
 * jQuery
 */ $fb0d70065cb9c259$var$defineJQueryPlugin($fb0d70065cb9c259$export$353f5b6fc5456de1);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/swipe.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $fb0d70065cb9c259$var$NAME$d = 'swipe';
var $fb0d70065cb9c259$var$EVENT_KEY$9 = '.bs.swipe';
var $fb0d70065cb9c259$var$EVENT_TOUCHSTART = "touchstart".concat($fb0d70065cb9c259$var$EVENT_KEY$9);
var $fb0d70065cb9c259$var$EVENT_TOUCHMOVE = "touchmove".concat($fb0d70065cb9c259$var$EVENT_KEY$9);
var $fb0d70065cb9c259$var$EVENT_TOUCHEND = "touchend".concat($fb0d70065cb9c259$var$EVENT_KEY$9);
var $fb0d70065cb9c259$var$EVENT_POINTERDOWN = "pointerdown".concat($fb0d70065cb9c259$var$EVENT_KEY$9);
var $fb0d70065cb9c259$var$EVENT_POINTERUP = "pointerup".concat($fb0d70065cb9c259$var$EVENT_KEY$9);
var $fb0d70065cb9c259$var$POINTER_TYPE_TOUCH = 'touch';
var $fb0d70065cb9c259$var$POINTER_TYPE_PEN = 'pen';
var $fb0d70065cb9c259$var$CLASS_NAME_POINTER_EVENT = 'pointer-event';
var $fb0d70065cb9c259$var$SWIPE_THRESHOLD = 40;
var $fb0d70065cb9c259$var$Default$c = {
    endCallback: null,
    leftCallback: null,
    rightCallback: null
};
var $fb0d70065cb9c259$var$DefaultType$c = {
    endCallback: '(function|null)',
    leftCallback: '(function|null)',
    rightCallback: '(function|null)'
};
/**
 * Class definition
 */ var $fb0d70065cb9c259$var$Swipe = /*#__PURE__*/ function(Config) {
    "use strict";
    (0, $b4d46f07ff8e4522$export$71511d61b312f219)(Swipe, Config);
    function Swipe(element, config) {
        (0, $86c0177781495fc1$export$71511d61b312f219)(this, Swipe);
        var _this;
        _this = (0, $ffc84c232c16c006$export$71511d61b312f219)(this, Swipe);
        _this._element = element;
        if (!element || !Swipe.isSupported()) return (0, $f42b3052967027bf$export$71511d61b312f219)(_this);
        _this._config = _this._getConfig(config);
        _this._deltaX = 0;
        _this._supportPointerEvents = Boolean(window.PointerEvent);
        _this._initEvents();
        return _this;
    }
    (0, $c2914329721d6e2b$export$71511d61b312f219)(Swipe, [
        {
            // Public
            key: "dispose",
            value: function dispose() {
                $fb0d70065cb9c259$var$EventHandler.off(this._element, $fb0d70065cb9c259$var$EVENT_KEY$9);
            }
        },
        {
            // Private
            key: "_start",
            value: function _start(event) {
                if (!this._supportPointerEvents) {
                    this._deltaX = event.touches[0].clientX;
                    return;
                }
                if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX;
            }
        },
        {
            key: "_end",
            value: function _end(event) {
                if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX - this._deltaX;
                this._handleSwipe();
                $fb0d70065cb9c259$var$execute(this._config.endCallback);
            }
        },
        {
            key: "_move",
            value: function _move(event) {
                this._deltaX = event.touches && event.touches.length > 1 ? 0 : event.touches[0].clientX - this._deltaX;
            }
        },
        {
            key: "_handleSwipe",
            value: function _handleSwipe() {
                var absDeltaX = Math.abs(this._deltaX);
                if (absDeltaX <= $fb0d70065cb9c259$var$SWIPE_THRESHOLD) return;
                var direction = absDeltaX / this._deltaX;
                this._deltaX = 0;
                if (!direction) return;
                $fb0d70065cb9c259$var$execute(direction > 0 ? this._config.rightCallback : this._config.leftCallback);
            }
        },
        {
            key: "_initEvents",
            value: function _initEvents() {
                var _this = this;
                if (this._supportPointerEvents) {
                    $fb0d70065cb9c259$var$EventHandler.on(this._element, $fb0d70065cb9c259$var$EVENT_POINTERDOWN, function(event) {
                        return _this._start(event);
                    });
                    $fb0d70065cb9c259$var$EventHandler.on(this._element, $fb0d70065cb9c259$var$EVENT_POINTERUP, function(event) {
                        return _this._end(event);
                    });
                    this._element.classList.add($fb0d70065cb9c259$var$CLASS_NAME_POINTER_EVENT);
                } else {
                    $fb0d70065cb9c259$var$EventHandler.on(this._element, $fb0d70065cb9c259$var$EVENT_TOUCHSTART, function(event) {
                        return _this._start(event);
                    });
                    $fb0d70065cb9c259$var$EventHandler.on(this._element, $fb0d70065cb9c259$var$EVENT_TOUCHMOVE, function(event) {
                        return _this._move(event);
                    });
                    $fb0d70065cb9c259$var$EventHandler.on(this._element, $fb0d70065cb9c259$var$EVENT_TOUCHEND, function(event) {
                        return _this._end(event);
                    });
                }
            }
        },
        {
            key: "_eventIsPointerPenTouch",
            value: function _eventIsPointerPenTouch(event) {
                return this._supportPointerEvents && (event.pointerType === $fb0d70065cb9c259$var$POINTER_TYPE_PEN || event.pointerType === $fb0d70065cb9c259$var$POINTER_TYPE_TOUCH);
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return $fb0d70065cb9c259$var$Default$c;
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return $fb0d70065cb9c259$var$DefaultType$c;
            }
        },
        {
            key: "NAME",
            get: function get() {
                return $fb0d70065cb9c259$var$NAME$d;
            }
        },
        {
            key: "isSupported",
            value: // Static
            function isSupported() {
                return 'ontouchstart' in document.documentElement || navigator.maxTouchPoints > 0;
            }
        }
    ]);
    return Swipe;
}($fb0d70065cb9c259$var$Config);
/**
 * --------------------------------------------------------------------------
 * Bootstrap carousel.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $fb0d70065cb9c259$var$NAME$c = 'carousel';
var $fb0d70065cb9c259$var$DATA_KEY$8 = 'bs.carousel';
var $fb0d70065cb9c259$var$EVENT_KEY$8 = ".".concat($fb0d70065cb9c259$var$DATA_KEY$8);
var $fb0d70065cb9c259$var$DATA_API_KEY$5 = '.data-api';
var $fb0d70065cb9c259$var$ARROW_LEFT_KEY$1 = 'ArrowLeft';
var $fb0d70065cb9c259$var$ARROW_RIGHT_KEY$1 = 'ArrowRight';
var $fb0d70065cb9c259$var$TOUCHEVENT_COMPAT_WAIT = 500; // Time for mouse compat events to fire after touch
var $fb0d70065cb9c259$var$ORDER_NEXT = 'next';
var $fb0d70065cb9c259$var$ORDER_PREV = 'prev';
var $fb0d70065cb9c259$var$DIRECTION_LEFT = 'left';
var $fb0d70065cb9c259$var$DIRECTION_RIGHT = 'right';
var $fb0d70065cb9c259$var$EVENT_SLIDE = "slide".concat($fb0d70065cb9c259$var$EVENT_KEY$8);
var $fb0d70065cb9c259$var$EVENT_SLID = "slid".concat($fb0d70065cb9c259$var$EVENT_KEY$8);
var $fb0d70065cb9c259$var$EVENT_KEYDOWN$1 = "keydown".concat($fb0d70065cb9c259$var$EVENT_KEY$8);
var $fb0d70065cb9c259$var$EVENT_MOUSEENTER$1 = "mouseenter".concat($fb0d70065cb9c259$var$EVENT_KEY$8);
var $fb0d70065cb9c259$var$EVENT_MOUSELEAVE$1 = "mouseleave".concat($fb0d70065cb9c259$var$EVENT_KEY$8);
var $fb0d70065cb9c259$var$EVENT_DRAG_START = "dragstart".concat($fb0d70065cb9c259$var$EVENT_KEY$8);
var $fb0d70065cb9c259$var$EVENT_LOAD_DATA_API$3 = "load".concat($fb0d70065cb9c259$var$EVENT_KEY$8).concat($fb0d70065cb9c259$var$DATA_API_KEY$5);
var $fb0d70065cb9c259$var$EVENT_CLICK_DATA_API$5 = "click".concat($fb0d70065cb9c259$var$EVENT_KEY$8).concat($fb0d70065cb9c259$var$DATA_API_KEY$5);
var $fb0d70065cb9c259$var$CLASS_NAME_CAROUSEL = 'carousel';
var $fb0d70065cb9c259$var$CLASS_NAME_ACTIVE$2 = 'active';
var $fb0d70065cb9c259$var$CLASS_NAME_SLIDE = 'slide';
var $fb0d70065cb9c259$var$CLASS_NAME_END = 'carousel-item-end';
var $fb0d70065cb9c259$var$CLASS_NAME_START = 'carousel-item-start';
var $fb0d70065cb9c259$var$CLASS_NAME_NEXT = 'carousel-item-next';
var $fb0d70065cb9c259$var$CLASS_NAME_PREV = 'carousel-item-prev';
var $fb0d70065cb9c259$var$SELECTOR_ACTIVE = '.active';
var $fb0d70065cb9c259$var$SELECTOR_ITEM = '.carousel-item';
var $fb0d70065cb9c259$var$SELECTOR_ACTIVE_ITEM = $fb0d70065cb9c259$var$SELECTOR_ACTIVE + $fb0d70065cb9c259$var$SELECTOR_ITEM;
var $fb0d70065cb9c259$var$SELECTOR_ITEM_IMG = '.carousel-item img';
var $fb0d70065cb9c259$var$SELECTOR_INDICATORS = '.carousel-indicators';
var $fb0d70065cb9c259$var$SELECTOR_DATA_SLIDE = '[data-bs-slide], [data-bs-slide-to]';
var $fb0d70065cb9c259$var$SELECTOR_DATA_RIDE = '[data-bs-ride="carousel"]';
var $fb0d70065cb9c259$var$_obj;
var $fb0d70065cb9c259$var$KEY_TO_DIRECTION = ($fb0d70065cb9c259$var$_obj = {}, (0, $eac6a0488bea45ee$export$71511d61b312f219)($fb0d70065cb9c259$var$_obj, $fb0d70065cb9c259$var$ARROW_LEFT_KEY$1, $fb0d70065cb9c259$var$DIRECTION_RIGHT), (0, $eac6a0488bea45ee$export$71511d61b312f219)($fb0d70065cb9c259$var$_obj, $fb0d70065cb9c259$var$ARROW_RIGHT_KEY$1, $fb0d70065cb9c259$var$DIRECTION_LEFT), $fb0d70065cb9c259$var$_obj);
var $fb0d70065cb9c259$var$Default$b = {
    interval: 5000,
    keyboard: true,
    pause: 'hover',
    ride: false,
    touch: true,
    wrap: true
};
var $fb0d70065cb9c259$var$DefaultType$b = {
    interval: '(number|boolean)',
    // TODO:v6 remove boolean support
    keyboard: 'boolean',
    pause: '(string|boolean)',
    ride: '(boolean|string)',
    touch: 'boolean',
    wrap: 'boolean'
};
/**
 * Class definition
 */ var $fb0d70065cb9c259$export$144901db2ea8e967 = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $b4d46f07ff8e4522$export$71511d61b312f219)(Carousel, BaseComponent);
    function Carousel(element, config) {
        (0, $86c0177781495fc1$export$71511d61b312f219)(this, Carousel);
        var _this;
        _this = (0, $ffc84c232c16c006$export$71511d61b312f219)(this, Carousel, [
            element,
            config
        ]);
        _this._interval = null;
        _this._activeElement = null;
        _this._isSliding = false;
        _this.touchTimeout = null;
        _this._swipeHelper = null;
        _this._indicatorsElement = $fb0d70065cb9c259$var$SelectorEngine.findOne($fb0d70065cb9c259$var$SELECTOR_INDICATORS, _this._element);
        _this._addEventListeners();
        if (_this._config.ride === $fb0d70065cb9c259$var$CLASS_NAME_CAROUSEL) _this.cycle();
        return _this;
    }
    (0, $c2914329721d6e2b$export$71511d61b312f219)(Carousel, [
        {
            // Public
            key: "next",
            value: function next() {
                this._slide($fb0d70065cb9c259$var$ORDER_NEXT);
            }
        },
        {
            key: "nextWhenVisible",
            value: function nextWhenVisible() {
                // FIXME TODO use `document.visibilityState`
                // Don't call next when the page isn't visible
                // or the carousel or its parent isn't visible
                if (!document.hidden && $fb0d70065cb9c259$var$isVisible(this._element)) this.next();
            }
        },
        {
            key: "prev",
            value: function prev() {
                this._slide($fb0d70065cb9c259$var$ORDER_PREV);
            }
        },
        {
            key: "pause",
            value: function pause() {
                if (this._isSliding) $fb0d70065cb9c259$var$triggerTransitionEnd(this._element);
                this._clearInterval();
            }
        },
        {
            key: "cycle",
            value: function cycle() {
                var _this = this;
                this._clearInterval();
                this._updateInterval();
                this._interval = setInterval(function() {
                    return _this.nextWhenVisible();
                }, this._config.interval);
            }
        },
        {
            key: "_maybeEnableCycle",
            value: function _maybeEnableCycle() {
                var _this = this;
                if (!this._config.ride) return;
                if (this._isSliding) {
                    $fb0d70065cb9c259$var$EventHandler.one(this._element, $fb0d70065cb9c259$var$EVENT_SLID, function() {
                        return _this.cycle();
                    });
                    return;
                }
                this.cycle();
            }
        },
        {
            key: "to",
            value: function to(index) {
                var _this = this;
                var items = this._getItems();
                if (index > items.length - 1 || index < 0) return;
                if (this._isSliding) {
                    $fb0d70065cb9c259$var$EventHandler.one(this._element, $fb0d70065cb9c259$var$EVENT_SLID, function() {
                        return _this.to(index);
                    });
                    return;
                }
                var activeIndex = this._getItemIndex(this._getActive());
                if (activeIndex === index) return;
                var order = index > activeIndex ? $fb0d70065cb9c259$var$ORDER_NEXT : $fb0d70065cb9c259$var$ORDER_PREV;
                this._slide(order, items[index]);
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                if (this._swipeHelper) this._swipeHelper.dispose();
                (0, $63451875c32f6bcb$export$71511d61b312f219)((0, $bf96ff342948c5d5$export$71511d61b312f219)(Carousel.prototype), "dispose", this).call(this);
            }
        },
        {
            // Private
            key: "_configAfterMerge",
            value: function _configAfterMerge(config) {
                config.defaultInterval = config.interval;
                return config;
            }
        },
        {
            key: "_addEventListeners",
            value: function _addEventListeners() {
                var _this = this;
                if (this._config.keyboard) $fb0d70065cb9c259$var$EventHandler.on(this._element, $fb0d70065cb9c259$var$EVENT_KEYDOWN$1, function(event) {
                    return _this._keydown(event);
                });
                if (this._config.pause === 'hover') {
                    $fb0d70065cb9c259$var$EventHandler.on(this._element, $fb0d70065cb9c259$var$EVENT_MOUSEENTER$1, function() {
                        return _this.pause();
                    });
                    $fb0d70065cb9c259$var$EventHandler.on(this._element, $fb0d70065cb9c259$var$EVENT_MOUSELEAVE$1, function() {
                        return _this._maybeEnableCycle();
                    });
                }
                if (this._config.touch && $fb0d70065cb9c259$var$Swipe.isSupported()) this._addTouchEventListeners();
            }
        },
        {
            key: "_addTouchEventListeners",
            value: function _addTouchEventListeners() {
                var _this = this;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = $fb0d70065cb9c259$var$SelectorEngine.find($fb0d70065cb9c259$var$SELECTOR_ITEM_IMG, this._element)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var img = _step.value;
                        $fb0d70065cb9c259$var$EventHandler.on(img, $fb0d70065cb9c259$var$EVENT_DRAG_START, function(event) {
                            return event.preventDefault();
                        });
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var endCallBack = function() {
                    if (_this._config.pause !== 'hover') return;
                    // If it's a touch-enabled device, mouseenter/leave are fired as
                    // part of the mouse compatibility events on first tap - the carousel
                    // would stop cycling until user tapped out of it;
                    // here, we listen for touchend, explicitly pause the carousel
                    // (as if it's the second time we tap on it, mouseenter compat event
                    // is NOT fired) and after a timeout (to allow for mouse compatibility
                    // events to fire) we explicitly restart cycling
                    _this.pause();
                    if (_this.touchTimeout) clearTimeout(_this.touchTimeout);
                    _this.touchTimeout = setTimeout(function() {
                        return _this._maybeEnableCycle();
                    }, $fb0d70065cb9c259$var$TOUCHEVENT_COMPAT_WAIT + _this._config.interval);
                };
                var swipeConfig = {
                    leftCallback: function() {
                        return _this._slide(_this._directionToOrder($fb0d70065cb9c259$var$DIRECTION_LEFT));
                    },
                    rightCallback: function() {
                        return _this._slide(_this._directionToOrder($fb0d70065cb9c259$var$DIRECTION_RIGHT));
                    },
                    endCallback: endCallBack
                };
                this._swipeHelper = new $fb0d70065cb9c259$var$Swipe(this._element, swipeConfig);
            }
        },
        {
            key: "_keydown",
            value: function _keydown(event) {
                if (/input|textarea/i.test(event.target.tagName)) return;
                var direction = $fb0d70065cb9c259$var$KEY_TO_DIRECTION[event.key];
                if (direction) {
                    event.preventDefault();
                    this._slide(this._directionToOrder(direction));
                }
            }
        },
        {
            key: "_getItemIndex",
            value: function _getItemIndex(element) {
                return this._getItems().indexOf(element);
            }
        },
        {
            key: "_setActiveIndicatorElement",
            value: function _setActiveIndicatorElement(index) {
                if (!this._indicatorsElement) return;
                var activeIndicator = $fb0d70065cb9c259$var$SelectorEngine.findOne($fb0d70065cb9c259$var$SELECTOR_ACTIVE, this._indicatorsElement);
                activeIndicator.classList.remove($fb0d70065cb9c259$var$CLASS_NAME_ACTIVE$2);
                activeIndicator.removeAttribute('aria-current');
                var newActiveIndicator = $fb0d70065cb9c259$var$SelectorEngine.findOne('[data-bs-slide-to="'.concat(index, '"]'), this._indicatorsElement);
                if (newActiveIndicator) {
                    newActiveIndicator.classList.add($fb0d70065cb9c259$var$CLASS_NAME_ACTIVE$2);
                    newActiveIndicator.setAttribute('aria-current', 'true');
                }
            }
        },
        {
            key: "_updateInterval",
            value: function _updateInterval() {
                var element = this._activeElement || this._getActive();
                if (!element) return;
                var elementInterval = Number.parseInt(element.getAttribute('data-bs-interval'), 10);
                this._config.interval = elementInterval || this._config.defaultInterval;
            }
        },
        {
            key: "_slide",
            value: function _slide(order) {
                var _this = this;
                var element = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
                if (this._isSliding) return;
                var activeElement = this._getActive();
                var isNext = order === $fb0d70065cb9c259$var$ORDER_NEXT;
                var nextElement = element || $fb0d70065cb9c259$var$getNextActiveElement(this._getItems(), activeElement, isNext, this._config.wrap);
                if (nextElement === activeElement) return;
                var nextElementIndex = this._getItemIndex(nextElement);
                var triggerEvent = function(eventName) {
                    return $fb0d70065cb9c259$var$EventHandler.trigger(_this._element, eventName, {
                        relatedTarget: nextElement,
                        direction: _this._orderToDirection(order),
                        from: _this._getItemIndex(activeElement),
                        to: nextElementIndex
                    });
                };
                var slideEvent = triggerEvent($fb0d70065cb9c259$var$EVENT_SLIDE);
                if (slideEvent.defaultPrevented) return;
                if (!activeElement || !nextElement) // Some weirdness is happening, so we bail
                // TODO: change tests that use empty divs to avoid this check
                return;
                var isCycling = Boolean(this._interval);
                this.pause();
                this._isSliding = true;
                this._setActiveIndicatorElement(nextElementIndex);
                this._activeElement = nextElement;
                var directionalClassName = isNext ? $fb0d70065cb9c259$var$CLASS_NAME_START : $fb0d70065cb9c259$var$CLASS_NAME_END;
                var orderClassName = isNext ? $fb0d70065cb9c259$var$CLASS_NAME_NEXT : $fb0d70065cb9c259$var$CLASS_NAME_PREV;
                nextElement.classList.add(orderClassName);
                $fb0d70065cb9c259$var$reflow(nextElement);
                activeElement.classList.add(directionalClassName);
                nextElement.classList.add(directionalClassName);
                var completeCallBack = function() {
                    nextElement.classList.remove(directionalClassName, orderClassName);
                    nextElement.classList.add($fb0d70065cb9c259$var$CLASS_NAME_ACTIVE$2);
                    activeElement.classList.remove($fb0d70065cb9c259$var$CLASS_NAME_ACTIVE$2, orderClassName, directionalClassName);
                    _this._isSliding = false;
                    triggerEvent($fb0d70065cb9c259$var$EVENT_SLID);
                };
                this._queueCallback(completeCallBack, activeElement, this._isAnimated());
                if (isCycling) this.cycle();
            }
        },
        {
            key: "_isAnimated",
            value: function _isAnimated() {
                return this._element.classList.contains($fb0d70065cb9c259$var$CLASS_NAME_SLIDE);
            }
        },
        {
            key: "_getActive",
            value: function _getActive() {
                return $fb0d70065cb9c259$var$SelectorEngine.findOne($fb0d70065cb9c259$var$SELECTOR_ACTIVE_ITEM, this._element);
            }
        },
        {
            key: "_getItems",
            value: function _getItems() {
                return $fb0d70065cb9c259$var$SelectorEngine.find($fb0d70065cb9c259$var$SELECTOR_ITEM, this._element);
            }
        },
        {
            key: "_clearInterval",
            value: function _clearInterval() {
                if (this._interval) {
                    clearInterval(this._interval);
                    this._interval = null;
                }
            }
        },
        {
            key: "_directionToOrder",
            value: function _directionToOrder(direction) {
                if ($fb0d70065cb9c259$var$isRTL()) return direction === $fb0d70065cb9c259$var$DIRECTION_LEFT ? $fb0d70065cb9c259$var$ORDER_PREV : $fb0d70065cb9c259$var$ORDER_NEXT;
                return direction === $fb0d70065cb9c259$var$DIRECTION_LEFT ? $fb0d70065cb9c259$var$ORDER_NEXT : $fb0d70065cb9c259$var$ORDER_PREV;
            }
        },
        {
            key: "_orderToDirection",
            value: function _orderToDirection(order) {
                if ($fb0d70065cb9c259$var$isRTL()) return order === $fb0d70065cb9c259$var$ORDER_PREV ? $fb0d70065cb9c259$var$DIRECTION_LEFT : $fb0d70065cb9c259$var$DIRECTION_RIGHT;
                return order === $fb0d70065cb9c259$var$ORDER_PREV ? $fb0d70065cb9c259$var$DIRECTION_RIGHT : $fb0d70065cb9c259$var$DIRECTION_LEFT;
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return $fb0d70065cb9c259$var$Default$b;
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return $fb0d70065cb9c259$var$DefaultType$b;
            }
        },
        {
            key: "NAME",
            get: function get() {
                return $fb0d70065cb9c259$var$NAME$c;
            }
        },
        {
            key: "jQueryInterface",
            value: // Static
            function jQueryInterface(config) {
                return this.each(function() {
                    var data = Carousel.getOrCreateInstance(this, config);
                    if (typeof config === 'number') {
                        data.to(config);
                        return;
                    }
                    if (typeof config === 'string') {
                        if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError('No method named "'.concat(config, '"'));
                        data[config]();
                    }
                });
            }
        }
    ]);
    return Carousel;
}($fb0d70065cb9c259$var$BaseComponent);
/**
 * Data API implementation
 */ $fb0d70065cb9c259$var$EventHandler.on(document, $fb0d70065cb9c259$var$EVENT_CLICK_DATA_API$5, $fb0d70065cb9c259$var$SELECTOR_DATA_SLIDE, function(event) {
    var target = $fb0d70065cb9c259$var$SelectorEngine.getElementFromSelector(this);
    if (!target || !target.classList.contains($fb0d70065cb9c259$var$CLASS_NAME_CAROUSEL)) return;
    event.preventDefault();
    var carousel = $fb0d70065cb9c259$export$144901db2ea8e967.getOrCreateInstance(target);
    var slideIndex = this.getAttribute('data-bs-slide-to');
    if (slideIndex) {
        carousel.to(slideIndex);
        carousel._maybeEnableCycle();
        return;
    }
    if ($fb0d70065cb9c259$var$Manipulator.getDataAttribute(this, 'slide') === 'next') {
        carousel.next();
        carousel._maybeEnableCycle();
        return;
    }
    carousel.prev();
    carousel._maybeEnableCycle();
});
$fb0d70065cb9c259$var$EventHandler.on(window, $fb0d70065cb9c259$var$EVENT_LOAD_DATA_API$3, function() {
    var carousels = $fb0d70065cb9c259$var$SelectorEngine.find($fb0d70065cb9c259$var$SELECTOR_DATA_RIDE);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = carousels[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var carousel = _step.value;
            $fb0d70065cb9c259$export$144901db2ea8e967.getOrCreateInstance(carousel);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
});
/**
 * jQuery
 */ $fb0d70065cb9c259$var$defineJQueryPlugin($fb0d70065cb9c259$export$144901db2ea8e967);
/**
 * --------------------------------------------------------------------------
 * Bootstrap collapse.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $fb0d70065cb9c259$var$NAME$b = 'collapse';
var $fb0d70065cb9c259$var$DATA_KEY$7 = 'bs.collapse';
var $fb0d70065cb9c259$var$EVENT_KEY$7 = ".".concat($fb0d70065cb9c259$var$DATA_KEY$7);
var $fb0d70065cb9c259$var$DATA_API_KEY$4 = '.data-api';
var $fb0d70065cb9c259$var$EVENT_SHOW$6 = "show".concat($fb0d70065cb9c259$var$EVENT_KEY$7);
var $fb0d70065cb9c259$var$EVENT_SHOWN$6 = "shown".concat($fb0d70065cb9c259$var$EVENT_KEY$7);
var $fb0d70065cb9c259$var$EVENT_HIDE$6 = "hide".concat($fb0d70065cb9c259$var$EVENT_KEY$7);
var $fb0d70065cb9c259$var$EVENT_HIDDEN$6 = "hidden".concat($fb0d70065cb9c259$var$EVENT_KEY$7);
var $fb0d70065cb9c259$var$EVENT_CLICK_DATA_API$4 = "click".concat($fb0d70065cb9c259$var$EVENT_KEY$7).concat($fb0d70065cb9c259$var$DATA_API_KEY$4);
var $fb0d70065cb9c259$var$CLASS_NAME_SHOW$7 = 'show';
var $fb0d70065cb9c259$var$CLASS_NAME_COLLAPSE = 'collapse';
var $fb0d70065cb9c259$var$CLASS_NAME_COLLAPSING = 'collapsing';
var $fb0d70065cb9c259$var$CLASS_NAME_COLLAPSED = 'collapsed';
var $fb0d70065cb9c259$var$CLASS_NAME_DEEPER_CHILDREN = ":scope .".concat($fb0d70065cb9c259$var$CLASS_NAME_COLLAPSE, " .").concat($fb0d70065cb9c259$var$CLASS_NAME_COLLAPSE);
var $fb0d70065cb9c259$var$CLASS_NAME_HORIZONTAL = 'collapse-horizontal';
var $fb0d70065cb9c259$var$WIDTH = 'width';
var $fb0d70065cb9c259$var$HEIGHT = 'height';
var $fb0d70065cb9c259$var$SELECTOR_ACTIVES = '.collapse.show, .collapse.collapsing';
var $fb0d70065cb9c259$var$SELECTOR_DATA_TOGGLE$4 = '[data-bs-toggle="collapse"]';
var $fb0d70065cb9c259$var$Default$a = {
    parent: null,
    toggle: true
};
var $fb0d70065cb9c259$var$DefaultType$a = {
    parent: '(null|element)',
    toggle: 'boolean'
};
/**
 * Class definition
 */ var $fb0d70065cb9c259$export$78768a9af065a7b = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $b4d46f07ff8e4522$export$71511d61b312f219)(Collapse, BaseComponent);
    function Collapse(element, config) {
        (0, $86c0177781495fc1$export$71511d61b312f219)(this, Collapse);
        var _this;
        _this = (0, $ffc84c232c16c006$export$71511d61b312f219)(this, Collapse, [
            element,
            config
        ]);
        _this._isTransitioning = false;
        _this._triggerArray = [];
        var toggleList = $fb0d70065cb9c259$var$SelectorEngine.find($fb0d70065cb9c259$var$SELECTOR_DATA_TOGGLE$4);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = toggleList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var elem = _step.value;
                var selector = $fb0d70065cb9c259$var$SelectorEngine.getSelectorFromElement(elem);
                var filterElement = $fb0d70065cb9c259$var$SelectorEngine.find(selector).filter(function(foundElement) {
                    return foundElement === _this._element;
                });
                if (selector !== null && filterElement.length) _this._triggerArray.push(elem);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        _this._initializeChildren();
        if (!_this._config.parent) _this._addAriaAndCollapsedClass(_this._triggerArray, _this._isShown());
        if (_this._config.toggle) _this.toggle();
        return _this;
    }
    (0, $c2914329721d6e2b$export$71511d61b312f219)(Collapse, [
        {
            // Public
            key: "toggle",
            value: function toggle() {
                if (this._isShown()) this.hide();
                else this.show();
            }
        },
        {
            key: "show",
            value: function show() {
                var _this = this;
                if (this._isTransitioning || this._isShown()) return;
                var activeChildren = [];
                // find active children
                if (this._config.parent) activeChildren = this._getFirstLevelChildren($fb0d70065cb9c259$var$SELECTOR_ACTIVES).filter(function(element) {
                    return element !== _this._element;
                }).map(function(element) {
                    return Collapse.getOrCreateInstance(element, {
                        toggle: false
                    });
                });
                if (activeChildren.length && activeChildren[0]._isTransitioning) return;
                var startEvent = $fb0d70065cb9c259$var$EventHandler.trigger(this._element, $fb0d70065cb9c259$var$EVENT_SHOW$6);
                if (startEvent.defaultPrevented) return;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = activeChildren[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var activeInstance = _step.value;
                        activeInstance.hide();
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var dimension = this._getDimension();
                this._element.classList.remove($fb0d70065cb9c259$var$CLASS_NAME_COLLAPSE);
                this._element.classList.add($fb0d70065cb9c259$var$CLASS_NAME_COLLAPSING);
                this._element.style[dimension] = 0;
                this._addAriaAndCollapsedClass(this._triggerArray, true);
                this._isTransitioning = true;
                var complete = function() {
                    _this._isTransitioning = false;
                    _this._element.classList.remove($fb0d70065cb9c259$var$CLASS_NAME_COLLAPSING);
                    _this._element.classList.add($fb0d70065cb9c259$var$CLASS_NAME_COLLAPSE, $fb0d70065cb9c259$var$CLASS_NAME_SHOW$7);
                    _this._element.style[dimension] = '';
                    $fb0d70065cb9c259$var$EventHandler.trigger(_this._element, $fb0d70065cb9c259$var$EVENT_SHOWN$6);
                };
                var capitalizedDimension = dimension[0].toUpperCase() + dimension.slice(1);
                var scrollSize = "scroll".concat(capitalizedDimension);
                this._queueCallback(complete, this._element, true);
                this._element.style[dimension] = "".concat(this._element[scrollSize], "px");
            }
        },
        {
            key: "hide",
            value: function hide() {
                var _this = this;
                if (this._isTransitioning || !this._isShown()) return;
                var startEvent = $fb0d70065cb9c259$var$EventHandler.trigger(this._element, $fb0d70065cb9c259$var$EVENT_HIDE$6);
                if (startEvent.defaultPrevented) return;
                var dimension = this._getDimension();
                this._element.style[dimension] = "".concat(this._element.getBoundingClientRect()[dimension], "px");
                $fb0d70065cb9c259$var$reflow(this._element);
                this._element.classList.add($fb0d70065cb9c259$var$CLASS_NAME_COLLAPSING);
                this._element.classList.remove($fb0d70065cb9c259$var$CLASS_NAME_COLLAPSE, $fb0d70065cb9c259$var$CLASS_NAME_SHOW$7);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._triggerArray[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var trigger = _step.value;
                        var element = $fb0d70065cb9c259$var$SelectorEngine.getElementFromSelector(trigger);
                        if (element && !this._isShown(element)) this._addAriaAndCollapsedClass([
                            trigger
                        ], false);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                this._isTransitioning = true;
                var complete = function() {
                    _this._isTransitioning = false;
                    _this._element.classList.remove($fb0d70065cb9c259$var$CLASS_NAME_COLLAPSING);
                    _this._element.classList.add($fb0d70065cb9c259$var$CLASS_NAME_COLLAPSE);
                    $fb0d70065cb9c259$var$EventHandler.trigger(_this._element, $fb0d70065cb9c259$var$EVENT_HIDDEN$6);
                };
                this._element.style[dimension] = '';
                this._queueCallback(complete, this._element, true);
            }
        },
        {
            // Private
            key: "_isShown",
            value: function _isShown() {
                var element = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this._element;
                return element.classList.contains($fb0d70065cb9c259$var$CLASS_NAME_SHOW$7);
            }
        },
        {
            key: "_configAfterMerge",
            value: function _configAfterMerge(config) {
                config.toggle = Boolean(config.toggle); // Coerce string values
                config.parent = $fb0d70065cb9c259$var$getElement(config.parent);
                return config;
            }
        },
        {
            key: "_getDimension",
            value: function _getDimension() {
                return this._element.classList.contains($fb0d70065cb9c259$var$CLASS_NAME_HORIZONTAL) ? $fb0d70065cb9c259$var$WIDTH : $fb0d70065cb9c259$var$HEIGHT;
            }
        },
        {
            key: "_initializeChildren",
            value: function _initializeChildren() {
                if (!this._config.parent) return;
                var children = this._getFirstLevelChildren($fb0d70065cb9c259$var$SELECTOR_DATA_TOGGLE$4);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var element = _step.value;
                        var selected = $fb0d70065cb9c259$var$SelectorEngine.getElementFromSelector(element);
                        if (selected) this._addAriaAndCollapsedClass([
                            element
                        ], this._isShown(selected));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "_getFirstLevelChildren",
            value: function _getFirstLevelChildren(selector) {
                var children = $fb0d70065cb9c259$var$SelectorEngine.find($fb0d70065cb9c259$var$CLASS_NAME_DEEPER_CHILDREN, this._config.parent);
                // remove children if greater depth
                return $fb0d70065cb9c259$var$SelectorEngine.find(selector, this._config.parent).filter(function(element) {
                    return !children.includes(element);
                });
            }
        },
        {
            key: "_addAriaAndCollapsedClass",
            value: function _addAriaAndCollapsedClass(triggerArray, isOpen) {
                if (!triggerArray.length) return;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = triggerArray[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var element = _step.value;
                        element.classList.toggle($fb0d70065cb9c259$var$CLASS_NAME_COLLAPSED, !isOpen);
                        element.setAttribute('aria-expanded', isOpen);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return $fb0d70065cb9c259$var$Default$a;
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return $fb0d70065cb9c259$var$DefaultType$a;
            }
        },
        {
            key: "NAME",
            get: function get() {
                return $fb0d70065cb9c259$var$NAME$b;
            }
        },
        {
            key: "jQueryInterface",
            value: // Static
            function jQueryInterface(config) {
                var _config = {};
                if (typeof config === 'string' && /show|hide/.test(config)) _config.toggle = false;
                return this.each(function() {
                    var data = Collapse.getOrCreateInstance(this, _config);
                    if (typeof config === 'string') {
                        if (typeof data[config] === 'undefined') throw new TypeError('No method named "'.concat(config, '"'));
                        data[config]();
                    }
                });
            }
        }
    ]);
    return Collapse;
}($fb0d70065cb9c259$var$BaseComponent);
/**
 * Data API implementation
 */ $fb0d70065cb9c259$var$EventHandler.on(document, $fb0d70065cb9c259$var$EVENT_CLICK_DATA_API$4, $fb0d70065cb9c259$var$SELECTOR_DATA_TOGGLE$4, function(event) {
    // preventDefault only for <a> elements (which change the URL) not inside the collapsible element
    if (event.target.tagName === 'A' || event.delegateTarget && event.delegateTarget.tagName === 'A') event.preventDefault();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $fb0d70065cb9c259$var$SelectorEngine.getMultipleElementsFromSelector(this)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var element = _step.value;
            $fb0d70065cb9c259$export$78768a9af065a7b.getOrCreateInstance(element, {
                toggle: false
            }).toggle();
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
});
/**
 * jQuery
 */ $fb0d70065cb9c259$var$defineJQueryPlugin($fb0d70065cb9c259$export$78768a9af065a7b);
/**
 * --------------------------------------------------------------------------
 * Bootstrap dropdown.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $fb0d70065cb9c259$var$NAME$a = 'dropdown';
var $fb0d70065cb9c259$var$DATA_KEY$6 = 'bs.dropdown';
var $fb0d70065cb9c259$var$EVENT_KEY$6 = ".".concat($fb0d70065cb9c259$var$DATA_KEY$6);
var $fb0d70065cb9c259$var$DATA_API_KEY$3 = '.data-api';
var $fb0d70065cb9c259$var$ESCAPE_KEY$2 = 'Escape';
var $fb0d70065cb9c259$var$TAB_KEY$1 = 'Tab';
var $fb0d70065cb9c259$var$ARROW_UP_KEY$1 = 'ArrowUp';
var $fb0d70065cb9c259$var$ARROW_DOWN_KEY$1 = 'ArrowDown';
var $fb0d70065cb9c259$var$RIGHT_MOUSE_BUTTON = 2; // MouseEvent.button value for the secondary button, usually the right button
var $fb0d70065cb9c259$var$EVENT_HIDE$5 = "hide".concat($fb0d70065cb9c259$var$EVENT_KEY$6);
var $fb0d70065cb9c259$var$EVENT_HIDDEN$5 = "hidden".concat($fb0d70065cb9c259$var$EVENT_KEY$6);
var $fb0d70065cb9c259$var$EVENT_SHOW$5 = "show".concat($fb0d70065cb9c259$var$EVENT_KEY$6);
var $fb0d70065cb9c259$var$EVENT_SHOWN$5 = "shown".concat($fb0d70065cb9c259$var$EVENT_KEY$6);
var $fb0d70065cb9c259$var$EVENT_CLICK_DATA_API$3 = "click".concat($fb0d70065cb9c259$var$EVENT_KEY$6).concat($fb0d70065cb9c259$var$DATA_API_KEY$3);
var $fb0d70065cb9c259$var$EVENT_KEYDOWN_DATA_API = "keydown".concat($fb0d70065cb9c259$var$EVENT_KEY$6).concat($fb0d70065cb9c259$var$DATA_API_KEY$3);
var $fb0d70065cb9c259$var$EVENT_KEYUP_DATA_API = "keyup".concat($fb0d70065cb9c259$var$EVENT_KEY$6).concat($fb0d70065cb9c259$var$DATA_API_KEY$3);
var $fb0d70065cb9c259$var$CLASS_NAME_SHOW$6 = 'show';
var $fb0d70065cb9c259$var$CLASS_NAME_DROPUP = 'dropup';
var $fb0d70065cb9c259$var$CLASS_NAME_DROPEND = 'dropend';
var $fb0d70065cb9c259$var$CLASS_NAME_DROPSTART = 'dropstart';
var $fb0d70065cb9c259$var$CLASS_NAME_DROPUP_CENTER = 'dropup-center';
var $fb0d70065cb9c259$var$CLASS_NAME_DROPDOWN_CENTER = 'dropdown-center';
var $fb0d70065cb9c259$var$SELECTOR_DATA_TOGGLE$3 = '[data-bs-toggle="dropdown"]:not(.disabled):not(:disabled)';
var $fb0d70065cb9c259$var$SELECTOR_DATA_TOGGLE_SHOWN = "".concat($fb0d70065cb9c259$var$SELECTOR_DATA_TOGGLE$3, ".").concat($fb0d70065cb9c259$var$CLASS_NAME_SHOW$6);
var $fb0d70065cb9c259$var$SELECTOR_MENU = '.dropdown-menu';
var $fb0d70065cb9c259$var$SELECTOR_NAVBAR = '.navbar';
var $fb0d70065cb9c259$var$SELECTOR_NAVBAR_NAV = '.navbar-nav';
var $fb0d70065cb9c259$var$SELECTOR_VISIBLE_ITEMS = '.dropdown-menu .dropdown-item:not(.disabled):not(:disabled)';
var $fb0d70065cb9c259$var$PLACEMENT_TOP = $fb0d70065cb9c259$var$isRTL() ? 'top-end' : 'top-start';
var $fb0d70065cb9c259$var$PLACEMENT_TOPEND = $fb0d70065cb9c259$var$isRTL() ? 'top-start' : 'top-end';
var $fb0d70065cb9c259$var$PLACEMENT_BOTTOM = $fb0d70065cb9c259$var$isRTL() ? 'bottom-end' : 'bottom-start';
var $fb0d70065cb9c259$var$PLACEMENT_BOTTOMEND = $fb0d70065cb9c259$var$isRTL() ? 'bottom-start' : 'bottom-end';
var $fb0d70065cb9c259$var$PLACEMENT_RIGHT = $fb0d70065cb9c259$var$isRTL() ? 'left-start' : 'right-start';
var $fb0d70065cb9c259$var$PLACEMENT_LEFT = $fb0d70065cb9c259$var$isRTL() ? 'right-start' : 'left-start';
var $fb0d70065cb9c259$var$PLACEMENT_TOPCENTER = 'top';
var $fb0d70065cb9c259$var$PLACEMENT_BOTTOMCENTER = 'bottom';
var $fb0d70065cb9c259$var$Default$9 = {
    autoClose: true,
    boundary: 'clippingParents',
    display: 'dynamic',
    offset: [
        0,
        2
    ],
    popperConfig: null,
    reference: 'toggle'
};
var $fb0d70065cb9c259$var$DefaultType$9 = {
    autoClose: '(boolean|string)',
    boundary: '(string|element)',
    display: 'string',
    offset: '(array|string|function)',
    popperConfig: '(null|object|function)',
    reference: '(string|element|object)'
};
/**
 * Class definition
 */ var $fb0d70065cb9c259$export$931cbfb6bfb85fc = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $b4d46f07ff8e4522$export$71511d61b312f219)(Dropdown, BaseComponent);
    function Dropdown(element, config) {
        (0, $86c0177781495fc1$export$71511d61b312f219)(this, Dropdown);
        var _this;
        _this = (0, $ffc84c232c16c006$export$71511d61b312f219)(this, Dropdown, [
            element,
            config
        ]);
        _this._popper = null;
        _this._parent = _this._element.parentNode; // dropdown wrapper
        // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
        _this._menu = $fb0d70065cb9c259$var$SelectorEngine.next(_this._element, $fb0d70065cb9c259$var$SELECTOR_MENU)[0] || $fb0d70065cb9c259$var$SelectorEngine.prev(_this._element, $fb0d70065cb9c259$var$SELECTOR_MENU)[0] || $fb0d70065cb9c259$var$SelectorEngine.findOne($fb0d70065cb9c259$var$SELECTOR_MENU, _this._parent);
        _this._inNavbar = _this._detectNavbar();
        return _this;
    }
    (0, $c2914329721d6e2b$export$71511d61b312f219)(Dropdown, [
        {
            // Public
            key: "toggle",
            value: function toggle() {
                return this._isShown() ? this.hide() : this.show();
            }
        },
        {
            key: "show",
            value: function show() {
                var _instance;
                if ($fb0d70065cb9c259$var$isDisabled(this._element) || this._isShown()) return;
                var relatedTarget = {
                    relatedTarget: this._element
                };
                var showEvent = $fb0d70065cb9c259$var$EventHandler.trigger(this._element, $fb0d70065cb9c259$var$EVENT_SHOW$5, relatedTarget);
                if (showEvent.defaultPrevented) return;
                this._createPopper();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                // If this is a touch-enabled device we add extra
                // empty mouseover listeners to the body's immediate children;
                // only needed because of broken event delegation on iOS
                // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
                if ('ontouchstart' in document.documentElement && !this._parent.closest($fb0d70065cb9c259$var$SELECTOR_NAVBAR_NAV)) try {
                    for(var _iterator = (_instance = []).concat.apply(_instance, (0, $2l5av._)(document.body.children))[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var element = _step.value;
                        $fb0d70065cb9c259$var$EventHandler.on(element, 'mouseover', $fb0d70065cb9c259$var$noop);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                this._element.focus();
                this._element.setAttribute('aria-expanded', true);
                this._menu.classList.add($fb0d70065cb9c259$var$CLASS_NAME_SHOW$6);
                this._element.classList.add($fb0d70065cb9c259$var$CLASS_NAME_SHOW$6);
                $fb0d70065cb9c259$var$EventHandler.trigger(this._element, $fb0d70065cb9c259$var$EVENT_SHOWN$5, relatedTarget);
            }
        },
        {
            key: "hide",
            value: function hide() {
                if ($fb0d70065cb9c259$var$isDisabled(this._element) || !this._isShown()) return;
                var relatedTarget = {
                    relatedTarget: this._element
                };
                this._completeHide(relatedTarget);
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                if (this._popper) this._popper.destroy();
                (0, $63451875c32f6bcb$export$71511d61b312f219)((0, $bf96ff342948c5d5$export$71511d61b312f219)(Dropdown.prototype), "dispose", this).call(this);
            }
        },
        {
            key: "update",
            value: function update() {
                this._inNavbar = this._detectNavbar();
                if (this._popper) this._popper.update();
            }
        },
        {
            // Private
            key: "_completeHide",
            value: function _completeHide(relatedTarget) {
                var _instance;
                var hideEvent = $fb0d70065cb9c259$var$EventHandler.trigger(this._element, $fb0d70065cb9c259$var$EVENT_HIDE$5, relatedTarget);
                if (hideEvent.defaultPrevented) return;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                // If this is a touch-enabled device we remove the extra
                // empty mouseover listeners we added for iOS support
                if ('ontouchstart' in document.documentElement) try {
                    for(var _iterator = (_instance = []).concat.apply(_instance, (0, $2l5av._)(document.body.children))[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var element = _step.value;
                        $fb0d70065cb9c259$var$EventHandler.off(element, 'mouseover', $fb0d70065cb9c259$var$noop);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                if (this._popper) this._popper.destroy();
                this._menu.classList.remove($fb0d70065cb9c259$var$CLASS_NAME_SHOW$6);
                this._element.classList.remove($fb0d70065cb9c259$var$CLASS_NAME_SHOW$6);
                this._element.setAttribute('aria-expanded', 'false');
                $fb0d70065cb9c259$var$Manipulator.removeDataAttribute(this._menu, 'popper');
                $fb0d70065cb9c259$var$EventHandler.trigger(this._element, $fb0d70065cb9c259$var$EVENT_HIDDEN$5, relatedTarget);
            }
        },
        {
            key: "_getConfig",
            value: function _getConfig(config) {
                config = (0, $63451875c32f6bcb$export$71511d61b312f219)((0, $bf96ff342948c5d5$export$71511d61b312f219)(Dropdown.prototype), "_getConfig", this).call(this, config);
                if ((0, $aqUTs._)(config.reference) === 'object' && !$fb0d70065cb9c259$var$isElement(config.reference) && typeof config.reference.getBoundingClientRect !== 'function') // Popper virtual elements require a getBoundingClientRect method
                throw new TypeError("".concat($fb0d70065cb9c259$var$NAME$a.toUpperCase(), ': Option "reference" provided type "object" without a required "getBoundingClientRect" method.'));
                return config;
            }
        },
        {
            key: "_createPopper",
            value: function _createPopper() {
                if (typeof $d924a49372bb56ad$exports === 'undefined') throw new TypeError('Bootstrap\'s dropdowns require Popper (https://popper.js.org/docs/v2/)');
                var referenceElement = this._element;
                if (this._config.reference === 'parent') referenceElement = this._parent;
                else if ($fb0d70065cb9c259$var$isElement(this._config.reference)) referenceElement = $fb0d70065cb9c259$var$getElement(this._config.reference);
                else if ((0, $aqUTs._)(this._config.reference) === 'object') referenceElement = this._config.reference;
                var popperConfig = this._getPopperConfig();
                this._popper = $d924a49372bb56ad$exports.createPopper(referenceElement, this._menu, popperConfig);
            }
        },
        {
            key: "_isShown",
            value: function _isShown() {
                return this._menu.classList.contains($fb0d70065cb9c259$var$CLASS_NAME_SHOW$6);
            }
        },
        {
            key: "_getPlacement",
            value: function _getPlacement() {
                var parentDropdown = this._parent;
                if (parentDropdown.classList.contains($fb0d70065cb9c259$var$CLASS_NAME_DROPEND)) return $fb0d70065cb9c259$var$PLACEMENT_RIGHT;
                if (parentDropdown.classList.contains($fb0d70065cb9c259$var$CLASS_NAME_DROPSTART)) return $fb0d70065cb9c259$var$PLACEMENT_LEFT;
                if (parentDropdown.classList.contains($fb0d70065cb9c259$var$CLASS_NAME_DROPUP_CENTER)) return $fb0d70065cb9c259$var$PLACEMENT_TOPCENTER;
                if (parentDropdown.classList.contains($fb0d70065cb9c259$var$CLASS_NAME_DROPDOWN_CENTER)) return $fb0d70065cb9c259$var$PLACEMENT_BOTTOMCENTER;
                // We need to trim the value because custom properties can also include spaces
                var isEnd = getComputedStyle(this._menu).getPropertyValue('--bs-position').trim() === 'end';
                if (parentDropdown.classList.contains($fb0d70065cb9c259$var$CLASS_NAME_DROPUP)) return isEnd ? $fb0d70065cb9c259$var$PLACEMENT_TOPEND : $fb0d70065cb9c259$var$PLACEMENT_TOP;
                return isEnd ? $fb0d70065cb9c259$var$PLACEMENT_BOTTOMEND : $fb0d70065cb9c259$var$PLACEMENT_BOTTOM;
            }
        },
        {
            key: "_detectNavbar",
            value: function _detectNavbar() {
                return this._element.closest($fb0d70065cb9c259$var$SELECTOR_NAVBAR) !== null;
            }
        },
        {
            key: "_getOffset",
            value: function _getOffset() {
                var _this = this;
                var offset = this._config.offset;
                if (typeof offset === 'string') return offset.split(',').map(function(value) {
                    return Number.parseInt(value, 10);
                });
                if (typeof offset === 'function') return function(popperData) {
                    return offset(popperData, _this._element);
                };
                return offset;
            }
        },
        {
            key: "_getPopperConfig",
            value: function _getPopperConfig() {
                var defaultBsPopperConfig = {
                    placement: this._getPlacement(),
                    modifiers: [
                        {
                            name: 'preventOverflow',
                            options: {
                                boundary: this._config.boundary
                            }
                        },
                        {
                            name: 'offset',
                            options: {
                                offset: this._getOffset()
                            }
                        }
                    ]
                };
                // Disable Popper if we have a static display or Dropdown is in Navbar
                if (this._inNavbar || this._config.display === 'static') {
                    $fb0d70065cb9c259$var$Manipulator.setDataAttribute(this._menu, 'popper', 'static'); // TODO: v6 remove
                    defaultBsPopperConfig.modifiers = [
                        {
                            name: 'applyStyles',
                            enabled: false
                        }
                    ];
                }
                return (0, $54f510fc1e3f8947$export$71511d61b312f219)({}, defaultBsPopperConfig, $fb0d70065cb9c259$var$execute(this._config.popperConfig, [
                    undefined,
                    defaultBsPopperConfig
                ]));
            }
        },
        {
            key: "_selectMenuItem",
            value: function _selectMenuItem(param) {
                var key = param.key, target = param.target;
                var items = $fb0d70065cb9c259$var$SelectorEngine.find($fb0d70065cb9c259$var$SELECTOR_VISIBLE_ITEMS, this._menu).filter(function(element) {
                    return $fb0d70065cb9c259$var$isVisible(element);
                });
                if (!items.length) return;
                // if target isn't included in items (e.g. when expanding the dropdown)
                // allow cycling to get the last item in case key equals ARROW_UP_KEY
                $fb0d70065cb9c259$var$getNextActiveElement(items, target, key === $fb0d70065cb9c259$var$ARROW_DOWN_KEY$1, !items.includes(target)).focus();
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return $fb0d70065cb9c259$var$Default$9;
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return $fb0d70065cb9c259$var$DefaultType$9;
            }
        },
        {
            key: "NAME",
            get: function get() {
                return $fb0d70065cb9c259$var$NAME$a;
            }
        },
        {
            key: "jQueryInterface",
            value: // Static
            function jQueryInterface(config) {
                return this.each(function() {
                    var data = Dropdown.getOrCreateInstance(this, config);
                    if (typeof config !== 'string') return;
                    if (typeof data[config] === 'undefined') throw new TypeError('No method named "'.concat(config, '"'));
                    data[config]();
                });
            }
        },
        {
            key: "clearMenus",
            value: function clearMenus(event) {
                if (event.button === $fb0d70065cb9c259$var$RIGHT_MOUSE_BUTTON || event.type === 'keyup' && event.key !== $fb0d70065cb9c259$var$TAB_KEY$1) return;
                var openToggles = $fb0d70065cb9c259$var$SelectorEngine.find($fb0d70065cb9c259$var$SELECTOR_DATA_TOGGLE_SHOWN);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = openToggles[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var toggle = _step.value;
                        var context = Dropdown.getInstance(toggle);
                        if (!context || context._config.autoClose === false) continue;
                        var composedPath = event.composedPath();
                        var isMenuTarget = composedPath.includes(context._menu);
                        if (composedPath.includes(context._element) || context._config.autoClose === 'inside' && !isMenuTarget || context._config.autoClose === 'outside' && isMenuTarget) continue;
                        // Tab navigation through the dropdown menu or events from contained inputs shouldn't close the menu
                        if (context._menu.contains(event.target) && (event.type === 'keyup' && event.key === $fb0d70065cb9c259$var$TAB_KEY$1 || /input|select|option|textarea|form/i.test(event.target.tagName))) continue;
                        var relatedTarget = {
                            relatedTarget: context._element
                        };
                        if (event.type === 'click') relatedTarget.clickEvent = event;
                        context._completeHide(relatedTarget);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "dataApiKeydownHandler",
            value: function dataApiKeydownHandler(event) {
                // If not an UP | DOWN | ESCAPE key => not a dropdown command
                // If input/textarea && if key is other than ESCAPE => not a dropdown command
                var isInput = /input|textarea/i.test(event.target.tagName);
                var isEscapeEvent = event.key === $fb0d70065cb9c259$var$ESCAPE_KEY$2;
                var isUpOrDownEvent = [
                    $fb0d70065cb9c259$var$ARROW_UP_KEY$1,
                    $fb0d70065cb9c259$var$ARROW_DOWN_KEY$1
                ].includes(event.key);
                if (!isUpOrDownEvent && !isEscapeEvent) return;
                if (isInput && !isEscapeEvent) return;
                event.preventDefault();
                // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
                var getToggleButton = this.matches($fb0d70065cb9c259$var$SELECTOR_DATA_TOGGLE$3) ? this : $fb0d70065cb9c259$var$SelectorEngine.prev(this, $fb0d70065cb9c259$var$SELECTOR_DATA_TOGGLE$3)[0] || $fb0d70065cb9c259$var$SelectorEngine.next(this, $fb0d70065cb9c259$var$SELECTOR_DATA_TOGGLE$3)[0] || $fb0d70065cb9c259$var$SelectorEngine.findOne($fb0d70065cb9c259$var$SELECTOR_DATA_TOGGLE$3, event.delegateTarget.parentNode);
                var instance = Dropdown.getOrCreateInstance(getToggleButton);
                if (isUpOrDownEvent) {
                    event.stopPropagation();
                    instance.show();
                    instance._selectMenuItem(event);
                    return;
                }
                if (instance._isShown()) {
                    // else is escape and we check if it is shown
                    event.stopPropagation();
                    instance.hide();
                    getToggleButton.focus();
                }
            }
        }
    ]);
    return Dropdown;
}($fb0d70065cb9c259$var$BaseComponent);
/**
 * Data API implementation
 */ $fb0d70065cb9c259$var$EventHandler.on(document, $fb0d70065cb9c259$var$EVENT_KEYDOWN_DATA_API, $fb0d70065cb9c259$var$SELECTOR_DATA_TOGGLE$3, $fb0d70065cb9c259$export$931cbfb6bfb85fc.dataApiKeydownHandler);
$fb0d70065cb9c259$var$EventHandler.on(document, $fb0d70065cb9c259$var$EVENT_KEYDOWN_DATA_API, $fb0d70065cb9c259$var$SELECTOR_MENU, $fb0d70065cb9c259$export$931cbfb6bfb85fc.dataApiKeydownHandler);
$fb0d70065cb9c259$var$EventHandler.on(document, $fb0d70065cb9c259$var$EVENT_CLICK_DATA_API$3, $fb0d70065cb9c259$export$931cbfb6bfb85fc.clearMenus);
$fb0d70065cb9c259$var$EventHandler.on(document, $fb0d70065cb9c259$var$EVENT_KEYUP_DATA_API, $fb0d70065cb9c259$export$931cbfb6bfb85fc.clearMenus);
$fb0d70065cb9c259$var$EventHandler.on(document, $fb0d70065cb9c259$var$EVENT_CLICK_DATA_API$3, $fb0d70065cb9c259$var$SELECTOR_DATA_TOGGLE$3, function(event) {
    event.preventDefault();
    $fb0d70065cb9c259$export$931cbfb6bfb85fc.getOrCreateInstance(this).toggle();
});
/**
 * jQuery
 */ $fb0d70065cb9c259$var$defineJQueryPlugin($fb0d70065cb9c259$export$931cbfb6bfb85fc);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/backdrop.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $fb0d70065cb9c259$var$NAME$9 = 'backdrop';
var $fb0d70065cb9c259$var$CLASS_NAME_FADE$4 = 'fade';
var $fb0d70065cb9c259$var$CLASS_NAME_SHOW$5 = 'show';
var $fb0d70065cb9c259$var$EVENT_MOUSEDOWN = "mousedown.bs.".concat($fb0d70065cb9c259$var$NAME$9);
var $fb0d70065cb9c259$var$Default$8 = {
    className: 'modal-backdrop',
    clickCallback: null,
    isAnimated: false,
    isVisible: true,
    // if false, we use the backdrop helper without adding any element to the dom
    rootElement: 'body' // give the choice to place backdrop under different elements
};
var $fb0d70065cb9c259$var$DefaultType$8 = {
    className: 'string',
    clickCallback: '(function|null)',
    isAnimated: 'boolean',
    isVisible: 'boolean',
    rootElement: '(element|string)'
};
/**
 * Class definition
 */ var $fb0d70065cb9c259$var$Backdrop = /*#__PURE__*/ function(Config) {
    "use strict";
    (0, $b4d46f07ff8e4522$export$71511d61b312f219)(Backdrop, Config);
    function Backdrop(config) {
        (0, $86c0177781495fc1$export$71511d61b312f219)(this, Backdrop);
        var _this;
        _this = (0, $ffc84c232c16c006$export$71511d61b312f219)(this, Backdrop);
        _this._config = _this._getConfig(config);
        _this._isAppended = false;
        _this._element = null;
        return _this;
    }
    (0, $c2914329721d6e2b$export$71511d61b312f219)(Backdrop, [
        {
            // Public
            key: "show",
            value: function show(callback) {
                if (!this._config.isVisible) {
                    $fb0d70065cb9c259$var$execute(callback);
                    return;
                }
                this._append();
                var element = this._getElement();
                if (this._config.isAnimated) $fb0d70065cb9c259$var$reflow(element);
                element.classList.add($fb0d70065cb9c259$var$CLASS_NAME_SHOW$5);
                this._emulateAnimation(function() {
                    $fb0d70065cb9c259$var$execute(callback);
                });
            }
        },
        {
            key: "hide",
            value: function hide(callback) {
                var _this = this;
                if (!this._config.isVisible) {
                    $fb0d70065cb9c259$var$execute(callback);
                    return;
                }
                this._getElement().classList.remove($fb0d70065cb9c259$var$CLASS_NAME_SHOW$5);
                this._emulateAnimation(function() {
                    _this.dispose();
                    $fb0d70065cb9c259$var$execute(callback);
                });
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                if (!this._isAppended) return;
                $fb0d70065cb9c259$var$EventHandler.off(this._element, $fb0d70065cb9c259$var$EVENT_MOUSEDOWN);
                this._element.remove();
                this._isAppended = false;
            }
        },
        {
            // Private
            key: "_getElement",
            value: function _getElement() {
                if (!this._element) {
                    var backdrop = document.createElement('div');
                    backdrop.className = this._config.className;
                    if (this._config.isAnimated) backdrop.classList.add($fb0d70065cb9c259$var$CLASS_NAME_FADE$4);
                    this._element = backdrop;
                }
                return this._element;
            }
        },
        {
            key: "_configAfterMerge",
            value: function _configAfterMerge(config) {
                // use getElement() with the default "body" to get a fresh Element on each instantiation
                config.rootElement = $fb0d70065cb9c259$var$getElement(config.rootElement);
                return config;
            }
        },
        {
            key: "_append",
            value: function _append() {
                var _this = this;
                if (this._isAppended) return;
                var element = this._getElement();
                this._config.rootElement.append(element);
                $fb0d70065cb9c259$var$EventHandler.on(element, $fb0d70065cb9c259$var$EVENT_MOUSEDOWN, function() {
                    $fb0d70065cb9c259$var$execute(_this._config.clickCallback);
                });
                this._isAppended = true;
            }
        },
        {
            key: "_emulateAnimation",
            value: function _emulateAnimation(callback) {
                $fb0d70065cb9c259$var$executeAfterTransition(callback, this._getElement(), this._config.isAnimated);
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return $fb0d70065cb9c259$var$Default$8;
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return $fb0d70065cb9c259$var$DefaultType$8;
            }
        },
        {
            key: "NAME",
            get: function get() {
                return $fb0d70065cb9c259$var$NAME$9;
            }
        }
    ]);
    return Backdrop;
}($fb0d70065cb9c259$var$Config);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/focustrap.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $fb0d70065cb9c259$var$NAME$8 = 'focustrap';
var $fb0d70065cb9c259$var$DATA_KEY$5 = 'bs.focustrap';
var $fb0d70065cb9c259$var$EVENT_KEY$5 = ".".concat($fb0d70065cb9c259$var$DATA_KEY$5);
var $fb0d70065cb9c259$var$EVENT_FOCUSIN$2 = "focusin".concat($fb0d70065cb9c259$var$EVENT_KEY$5);
var $fb0d70065cb9c259$var$EVENT_KEYDOWN_TAB = "keydown.tab".concat($fb0d70065cb9c259$var$EVENT_KEY$5);
var $fb0d70065cb9c259$var$TAB_KEY = 'Tab';
var $fb0d70065cb9c259$var$TAB_NAV_FORWARD = 'forward';
var $fb0d70065cb9c259$var$TAB_NAV_BACKWARD = 'backward';
var $fb0d70065cb9c259$var$Default$7 = {
    autofocus: true,
    trapElement: null // The element to trap focus inside of
};
var $fb0d70065cb9c259$var$DefaultType$7 = {
    autofocus: 'boolean',
    trapElement: 'element'
};
/**
 * Class definition
 */ var $fb0d70065cb9c259$var$FocusTrap = /*#__PURE__*/ function(Config) {
    "use strict";
    (0, $b4d46f07ff8e4522$export$71511d61b312f219)(FocusTrap, Config);
    function FocusTrap(config) {
        (0, $86c0177781495fc1$export$71511d61b312f219)(this, FocusTrap);
        var _this;
        _this = (0, $ffc84c232c16c006$export$71511d61b312f219)(this, FocusTrap);
        _this._config = _this._getConfig(config);
        _this._isActive = false;
        _this._lastTabNavDirection = null;
        return _this;
    }
    (0, $c2914329721d6e2b$export$71511d61b312f219)(FocusTrap, [
        {
            // Public
            key: "activate",
            value: function activate() {
                var _this = this;
                if (this._isActive) return;
                if (this._config.autofocus) this._config.trapElement.focus();
                $fb0d70065cb9c259$var$EventHandler.off(document, $fb0d70065cb9c259$var$EVENT_KEY$5); // guard against infinite focus loop
                $fb0d70065cb9c259$var$EventHandler.on(document, $fb0d70065cb9c259$var$EVENT_FOCUSIN$2, function(event) {
                    return _this._handleFocusin(event);
                });
                $fb0d70065cb9c259$var$EventHandler.on(document, $fb0d70065cb9c259$var$EVENT_KEYDOWN_TAB, function(event) {
                    return _this._handleKeydown(event);
                });
                this._isActive = true;
            }
        },
        {
            key: "deactivate",
            value: function deactivate() {
                if (!this._isActive) return;
                this._isActive = false;
                $fb0d70065cb9c259$var$EventHandler.off(document, $fb0d70065cb9c259$var$EVENT_KEY$5);
            }
        },
        {
            // Private
            key: "_handleFocusin",
            value: function _handleFocusin(event) {
                var trapElement = this._config.trapElement;
                if (event.target === document || event.target === trapElement || trapElement.contains(event.target)) return;
                var elements = $fb0d70065cb9c259$var$SelectorEngine.focusableChildren(trapElement);
                if (elements.length === 0) trapElement.focus();
                else if (this._lastTabNavDirection === $fb0d70065cb9c259$var$TAB_NAV_BACKWARD) elements[elements.length - 1].focus();
                else elements[0].focus();
            }
        },
        {
            key: "_handleKeydown",
            value: function _handleKeydown(event) {
                if (event.key !== $fb0d70065cb9c259$var$TAB_KEY) return;
                this._lastTabNavDirection = event.shiftKey ? $fb0d70065cb9c259$var$TAB_NAV_BACKWARD : $fb0d70065cb9c259$var$TAB_NAV_FORWARD;
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return $fb0d70065cb9c259$var$Default$7;
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return $fb0d70065cb9c259$var$DefaultType$7;
            }
        },
        {
            key: "NAME",
            get: function get() {
                return $fb0d70065cb9c259$var$NAME$8;
            }
        }
    ]);
    return FocusTrap;
}($fb0d70065cb9c259$var$Config);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/scrollBar.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $fb0d70065cb9c259$var$SELECTOR_FIXED_CONTENT = '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top';
var $fb0d70065cb9c259$var$SELECTOR_STICKY_CONTENT = '.sticky-top';
var $fb0d70065cb9c259$var$PROPERTY_PADDING = 'padding-right';
var $fb0d70065cb9c259$var$PROPERTY_MARGIN = 'margin-right';
/**
 * Class definition
 */ var $fb0d70065cb9c259$var$ScrollBarHelper = /*#__PURE__*/ function() {
    "use strict";
    function ScrollBarHelper() {
        (0, $86c0177781495fc1$export$71511d61b312f219)(this, ScrollBarHelper);
        this._element = document.body;
    }
    (0, $c2914329721d6e2b$export$71511d61b312f219)(ScrollBarHelper, [
        {
            // Public
            key: "getWidth",
            value: function getWidth() {
                // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
                var documentWidth = document.documentElement.clientWidth;
                return Math.abs(window.innerWidth - documentWidth);
            }
        },
        {
            key: "hide",
            value: function hide() {
                var width = this.getWidth();
                this._disableOverFlow();
                // give padding to element to balance the hidden scrollbar width
                this._setElementAttributes(this._element, $fb0d70065cb9c259$var$PROPERTY_PADDING, function(calculatedValue) {
                    return calculatedValue + width;
                });
                // trick: We adjust positive paddingRight and negative marginRight to sticky-top elements to keep showing fullwidth
                this._setElementAttributes($fb0d70065cb9c259$var$SELECTOR_FIXED_CONTENT, $fb0d70065cb9c259$var$PROPERTY_PADDING, function(calculatedValue) {
                    return calculatedValue + width;
                });
                this._setElementAttributes($fb0d70065cb9c259$var$SELECTOR_STICKY_CONTENT, $fb0d70065cb9c259$var$PROPERTY_MARGIN, function(calculatedValue) {
                    return calculatedValue - width;
                });
            }
        },
        {
            key: "reset",
            value: function reset() {
                this._resetElementAttributes(this._element, 'overflow');
                this._resetElementAttributes(this._element, $fb0d70065cb9c259$var$PROPERTY_PADDING);
                this._resetElementAttributes($fb0d70065cb9c259$var$SELECTOR_FIXED_CONTENT, $fb0d70065cb9c259$var$PROPERTY_PADDING);
                this._resetElementAttributes($fb0d70065cb9c259$var$SELECTOR_STICKY_CONTENT, $fb0d70065cb9c259$var$PROPERTY_MARGIN);
            }
        },
        {
            key: "isOverflowing",
            value: function isOverflowing() {
                return this.getWidth() > 0;
            }
        },
        {
            // Private
            key: "_disableOverFlow",
            value: function _disableOverFlow() {
                this._saveInitialAttribute(this._element, 'overflow');
                this._element.style.overflow = 'hidden';
            }
        },
        {
            key: "_setElementAttributes",
            value: function _setElementAttributes(selector, styleProperty, callback) {
                var _this = this;
                var scrollbarWidth = this.getWidth();
                var manipulationCallBack = function(element) {
                    if (element !== _this._element && window.innerWidth > element.clientWidth + scrollbarWidth) return;
                    _this._saveInitialAttribute(element, styleProperty);
                    var calculatedValue = window.getComputedStyle(element).getPropertyValue(styleProperty);
                    element.style.setProperty(styleProperty, "".concat(callback(Number.parseFloat(calculatedValue)), "px"));
                };
                this._applyManipulationCallback(selector, manipulationCallBack);
            }
        },
        {
            key: "_saveInitialAttribute",
            value: function _saveInitialAttribute(element, styleProperty) {
                var actualValue = element.style.getPropertyValue(styleProperty);
                if (actualValue) $fb0d70065cb9c259$var$Manipulator.setDataAttribute(element, styleProperty, actualValue);
            }
        },
        {
            key: "_resetElementAttributes",
            value: function _resetElementAttributes(selector, styleProperty) {
                var manipulationCallBack = function(element) {
                    var value = $fb0d70065cb9c259$var$Manipulator.getDataAttribute(element, styleProperty);
                    // We only want to remove the property if the value is `null`; the value can also be zero
                    if (value === null) {
                        element.style.removeProperty(styleProperty);
                        return;
                    }
                    $fb0d70065cb9c259$var$Manipulator.removeDataAttribute(element, styleProperty);
                    element.style.setProperty(styleProperty, value);
                };
                this._applyManipulationCallback(selector, manipulationCallBack);
            }
        },
        {
            key: "_applyManipulationCallback",
            value: function _applyManipulationCallback(selector, callBack) {
                if ($fb0d70065cb9c259$var$isElement(selector)) {
                    callBack(selector);
                    return;
                }
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = $fb0d70065cb9c259$var$SelectorEngine.find(selector, this._element)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var sel = _step.value;
                        callBack(sel);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        }
    ]);
    return ScrollBarHelper;
}();
/**
 * --------------------------------------------------------------------------
 * Bootstrap modal.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $fb0d70065cb9c259$var$NAME$7 = 'modal';
var $fb0d70065cb9c259$var$DATA_KEY$4 = 'bs.modal';
var $fb0d70065cb9c259$var$EVENT_KEY$4 = ".".concat($fb0d70065cb9c259$var$DATA_KEY$4);
var $fb0d70065cb9c259$var$DATA_API_KEY$2 = '.data-api';
var $fb0d70065cb9c259$var$ESCAPE_KEY$1 = 'Escape';
var $fb0d70065cb9c259$var$EVENT_HIDE$4 = "hide".concat($fb0d70065cb9c259$var$EVENT_KEY$4);
var $fb0d70065cb9c259$var$EVENT_HIDE_PREVENTED$1 = "hidePrevented".concat($fb0d70065cb9c259$var$EVENT_KEY$4);
var $fb0d70065cb9c259$var$EVENT_HIDDEN$4 = "hidden".concat($fb0d70065cb9c259$var$EVENT_KEY$4);
var $fb0d70065cb9c259$var$EVENT_SHOW$4 = "show".concat($fb0d70065cb9c259$var$EVENT_KEY$4);
var $fb0d70065cb9c259$var$EVENT_SHOWN$4 = "shown".concat($fb0d70065cb9c259$var$EVENT_KEY$4);
var $fb0d70065cb9c259$var$EVENT_RESIZE$1 = "resize".concat($fb0d70065cb9c259$var$EVENT_KEY$4);
var $fb0d70065cb9c259$var$EVENT_CLICK_DISMISS = "click.dismiss".concat($fb0d70065cb9c259$var$EVENT_KEY$4);
var $fb0d70065cb9c259$var$EVENT_MOUSEDOWN_DISMISS = "mousedown.dismiss".concat($fb0d70065cb9c259$var$EVENT_KEY$4);
var $fb0d70065cb9c259$var$EVENT_KEYDOWN_DISMISS$1 = "keydown.dismiss".concat($fb0d70065cb9c259$var$EVENT_KEY$4);
var $fb0d70065cb9c259$var$EVENT_CLICK_DATA_API$2 = "click".concat($fb0d70065cb9c259$var$EVENT_KEY$4).concat($fb0d70065cb9c259$var$DATA_API_KEY$2);
var $fb0d70065cb9c259$var$CLASS_NAME_OPEN = 'modal-open';
var $fb0d70065cb9c259$var$CLASS_NAME_FADE$3 = 'fade';
var $fb0d70065cb9c259$var$CLASS_NAME_SHOW$4 = 'show';
var $fb0d70065cb9c259$var$CLASS_NAME_STATIC = 'modal-static';
var $fb0d70065cb9c259$var$OPEN_SELECTOR$1 = '.modal.show';
var $fb0d70065cb9c259$var$SELECTOR_DIALOG = '.modal-dialog';
var $fb0d70065cb9c259$var$SELECTOR_MODAL_BODY = '.modal-body';
var $fb0d70065cb9c259$var$SELECTOR_DATA_TOGGLE$2 = '[data-bs-toggle="modal"]';
var $fb0d70065cb9c259$var$Default$6 = {
    backdrop: true,
    focus: true,
    keyboard: true
};
var $fb0d70065cb9c259$var$DefaultType$6 = {
    backdrop: '(boolean|string)',
    focus: 'boolean',
    keyboard: 'boolean'
};
/**
 * Class definition
 */ var $fb0d70065cb9c259$export$2b77a92f1a5ad772 = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $b4d46f07ff8e4522$export$71511d61b312f219)(Modal, BaseComponent);
    function Modal(element, config) {
        (0, $86c0177781495fc1$export$71511d61b312f219)(this, Modal);
        var _this;
        _this = (0, $ffc84c232c16c006$export$71511d61b312f219)(this, Modal, [
            element,
            config
        ]);
        _this._dialog = $fb0d70065cb9c259$var$SelectorEngine.findOne($fb0d70065cb9c259$var$SELECTOR_DIALOG, _this._element);
        _this._backdrop = _this._initializeBackDrop();
        _this._focustrap = _this._initializeFocusTrap();
        _this._isShown = false;
        _this._isTransitioning = false;
        _this._scrollBar = new $fb0d70065cb9c259$var$ScrollBarHelper();
        _this._addEventListeners();
        return _this;
    }
    (0, $c2914329721d6e2b$export$71511d61b312f219)(Modal, [
        {
            // Public
            key: "toggle",
            value: function toggle(relatedTarget) {
                return this._isShown ? this.hide() : this.show(relatedTarget);
            }
        },
        {
            key: "show",
            value: function show(relatedTarget) {
                var _this = this;
                if (this._isShown || this._isTransitioning) return;
                var showEvent = $fb0d70065cb9c259$var$EventHandler.trigger(this._element, $fb0d70065cb9c259$var$EVENT_SHOW$4, {
                    relatedTarget: relatedTarget
                });
                if (showEvent.defaultPrevented) return;
                this._isShown = true;
                this._isTransitioning = true;
                this._scrollBar.hide();
                document.body.classList.add($fb0d70065cb9c259$var$CLASS_NAME_OPEN);
                this._adjustDialog();
                this._backdrop.show(function() {
                    return _this._showElement(relatedTarget);
                });
            }
        },
        {
            key: "hide",
            value: function hide() {
                var _this = this;
                if (!this._isShown || this._isTransitioning) return;
                var hideEvent = $fb0d70065cb9c259$var$EventHandler.trigger(this._element, $fb0d70065cb9c259$var$EVENT_HIDE$4);
                if (hideEvent.defaultPrevented) return;
                this._isShown = false;
                this._isTransitioning = true;
                this._focustrap.deactivate();
                this._element.classList.remove($fb0d70065cb9c259$var$CLASS_NAME_SHOW$4);
                this._queueCallback(function() {
                    return _this._hideModal();
                }, this._element, this._isAnimated());
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                $fb0d70065cb9c259$var$EventHandler.off(window, $fb0d70065cb9c259$var$EVENT_KEY$4);
                $fb0d70065cb9c259$var$EventHandler.off(this._dialog, $fb0d70065cb9c259$var$EVENT_KEY$4);
                this._backdrop.dispose();
                this._focustrap.deactivate();
                (0, $63451875c32f6bcb$export$71511d61b312f219)((0, $bf96ff342948c5d5$export$71511d61b312f219)(Modal.prototype), "dispose", this).call(this);
            }
        },
        {
            key: "handleUpdate",
            value: function handleUpdate() {
                this._adjustDialog();
            }
        },
        {
            // Private
            key: "_initializeBackDrop",
            value: function _initializeBackDrop() {
                return new $fb0d70065cb9c259$var$Backdrop({
                    isVisible: Boolean(this._config.backdrop),
                    // 'static' option will be translated to true, and booleans will keep their value,
                    isAnimated: this._isAnimated()
                });
            }
        },
        {
            key: "_initializeFocusTrap",
            value: function _initializeFocusTrap() {
                return new $fb0d70065cb9c259$var$FocusTrap({
                    trapElement: this._element
                });
            }
        },
        {
            key: "_showElement",
            value: function _showElement(relatedTarget) {
                var _this = this;
                // try to append dynamic modal
                if (!document.body.contains(this._element)) document.body.append(this._element);
                this._element.style.display = 'block';
                this._element.removeAttribute('aria-hidden');
                this._element.setAttribute('aria-modal', true);
                this._element.setAttribute('role', 'dialog');
                this._element.scrollTop = 0;
                var modalBody = $fb0d70065cb9c259$var$SelectorEngine.findOne($fb0d70065cb9c259$var$SELECTOR_MODAL_BODY, this._dialog);
                if (modalBody) modalBody.scrollTop = 0;
                $fb0d70065cb9c259$var$reflow(this._element);
                this._element.classList.add($fb0d70065cb9c259$var$CLASS_NAME_SHOW$4);
                var transitionComplete = function() {
                    if (_this._config.focus) _this._focustrap.activate();
                    _this._isTransitioning = false;
                    $fb0d70065cb9c259$var$EventHandler.trigger(_this._element, $fb0d70065cb9c259$var$EVENT_SHOWN$4, {
                        relatedTarget: relatedTarget
                    });
                };
                this._queueCallback(transitionComplete, this._dialog, this._isAnimated());
            }
        },
        {
            key: "_addEventListeners",
            value: function _addEventListeners() {
                var _this = this;
                $fb0d70065cb9c259$var$EventHandler.on(this._element, $fb0d70065cb9c259$var$EVENT_KEYDOWN_DISMISS$1, function(event) {
                    if (event.key !== $fb0d70065cb9c259$var$ESCAPE_KEY$1) return;
                    if (_this._config.keyboard) {
                        _this.hide();
                        return;
                    }
                    _this._triggerBackdropTransition();
                });
                $fb0d70065cb9c259$var$EventHandler.on(window, $fb0d70065cb9c259$var$EVENT_RESIZE$1, function() {
                    if (_this._isShown && !_this._isTransitioning) _this._adjustDialog();
                });
                $fb0d70065cb9c259$var$EventHandler.on(this._element, $fb0d70065cb9c259$var$EVENT_MOUSEDOWN_DISMISS, function(event) {
                    // a bad trick to segregate clicks that may start inside dialog but end outside, and avoid listen to scrollbar clicks
                    $fb0d70065cb9c259$var$EventHandler.one(_this._element, $fb0d70065cb9c259$var$EVENT_CLICK_DISMISS, function(event2) {
                        if (_this._element !== event.target || _this._element !== event2.target) return;
                        if (_this._config.backdrop === 'static') {
                            _this._triggerBackdropTransition();
                            return;
                        }
                        if (_this._config.backdrop) _this.hide();
                    });
                });
            }
        },
        {
            key: "_hideModal",
            value: function _hideModal() {
                var _this = this;
                this._element.style.display = 'none';
                this._element.setAttribute('aria-hidden', true);
                this._element.removeAttribute('aria-modal');
                this._element.removeAttribute('role');
                this._isTransitioning = false;
                this._backdrop.hide(function() {
                    document.body.classList.remove($fb0d70065cb9c259$var$CLASS_NAME_OPEN);
                    _this._resetAdjustments();
                    _this._scrollBar.reset();
                    $fb0d70065cb9c259$var$EventHandler.trigger(_this._element, $fb0d70065cb9c259$var$EVENT_HIDDEN$4);
                });
            }
        },
        {
            key: "_isAnimated",
            value: function _isAnimated() {
                return this._element.classList.contains($fb0d70065cb9c259$var$CLASS_NAME_FADE$3);
            }
        },
        {
            key: "_triggerBackdropTransition",
            value: function _triggerBackdropTransition() {
                var _this = this;
                var hideEvent = $fb0d70065cb9c259$var$EventHandler.trigger(this._element, $fb0d70065cb9c259$var$EVENT_HIDE_PREVENTED$1);
                if (hideEvent.defaultPrevented) return;
                var isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
                var initialOverflowY = this._element.style.overflowY;
                // return if the following background transition hasn't yet completed
                if (initialOverflowY === 'hidden' || this._element.classList.contains($fb0d70065cb9c259$var$CLASS_NAME_STATIC)) return;
                if (!isModalOverflowing) this._element.style.overflowY = 'hidden';
                this._element.classList.add($fb0d70065cb9c259$var$CLASS_NAME_STATIC);
                this._queueCallback(function() {
                    _this._element.classList.remove($fb0d70065cb9c259$var$CLASS_NAME_STATIC);
                    _this._queueCallback(function() {
                        _this._element.style.overflowY = initialOverflowY;
                    }, _this._dialog);
                }, this._dialog);
                this._element.focus();
            }
        },
        {
            /**
   * The following methods are used to handle overflowing modals
   */ key: "_adjustDialog",
            value: function _adjustDialog() {
                var isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
                var scrollbarWidth = this._scrollBar.getWidth();
                var isBodyOverflowing = scrollbarWidth > 0;
                if (isBodyOverflowing && !isModalOverflowing) {
                    var property = $fb0d70065cb9c259$var$isRTL() ? 'paddingLeft' : 'paddingRight';
                    this._element.style[property] = "".concat(scrollbarWidth, "px");
                }
                if (!isBodyOverflowing && isModalOverflowing) {
                    var property1 = $fb0d70065cb9c259$var$isRTL() ? 'paddingRight' : 'paddingLeft';
                    this._element.style[property1] = "".concat(scrollbarWidth, "px");
                }
            }
        },
        {
            key: "_resetAdjustments",
            value: function _resetAdjustments() {
                this._element.style.paddingLeft = '';
                this._element.style.paddingRight = '';
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return $fb0d70065cb9c259$var$Default$6;
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return $fb0d70065cb9c259$var$DefaultType$6;
            }
        },
        {
            key: "NAME",
            get: function get() {
                return $fb0d70065cb9c259$var$NAME$7;
            }
        },
        {
            key: "jQueryInterface",
            value: // Static
            function jQueryInterface(config, relatedTarget) {
                return this.each(function() {
                    var data = Modal.getOrCreateInstance(this, config);
                    if (typeof config !== 'string') return;
                    if (typeof data[config] === 'undefined') throw new TypeError('No method named "'.concat(config, '"'));
                    data[config](relatedTarget);
                });
            }
        }
    ]);
    return Modal;
}($fb0d70065cb9c259$var$BaseComponent);
/**
 * Data API implementation
 */ $fb0d70065cb9c259$var$EventHandler.on(document, $fb0d70065cb9c259$var$EVENT_CLICK_DATA_API$2, $fb0d70065cb9c259$var$SELECTOR_DATA_TOGGLE$2, function(event) {
    var _this = this;
    var target = $fb0d70065cb9c259$var$SelectorEngine.getElementFromSelector(this);
    if ([
        'A',
        'AREA'
    ].includes(this.tagName)) event.preventDefault();
    $fb0d70065cb9c259$var$EventHandler.one(target, $fb0d70065cb9c259$var$EVENT_SHOW$4, function(showEvent) {
        if (showEvent.defaultPrevented) // only register focus restorer if modal will actually get shown
        return;
        $fb0d70065cb9c259$var$EventHandler.one(target, $fb0d70065cb9c259$var$EVENT_HIDDEN$4, function() {
            if ($fb0d70065cb9c259$var$isVisible(_this)) _this.focus();
        });
    });
    // avoid conflict when clicking modal toggler while another one is open
    var alreadyOpen = $fb0d70065cb9c259$var$SelectorEngine.findOne($fb0d70065cb9c259$var$OPEN_SELECTOR$1);
    if (alreadyOpen) $fb0d70065cb9c259$export$2b77a92f1a5ad772.getInstance(alreadyOpen).hide();
    var data = $fb0d70065cb9c259$export$2b77a92f1a5ad772.getOrCreateInstance(target);
    data.toggle(this);
});
$fb0d70065cb9c259$var$enableDismissTrigger($fb0d70065cb9c259$export$2b77a92f1a5ad772);
/**
 * jQuery
 */ $fb0d70065cb9c259$var$defineJQueryPlugin($fb0d70065cb9c259$export$2b77a92f1a5ad772);
/**
 * --------------------------------------------------------------------------
 * Bootstrap offcanvas.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $fb0d70065cb9c259$var$NAME$6 = 'offcanvas';
var $fb0d70065cb9c259$var$DATA_KEY$3 = 'bs.offcanvas';
var $fb0d70065cb9c259$var$EVENT_KEY$3 = ".".concat($fb0d70065cb9c259$var$DATA_KEY$3);
var $fb0d70065cb9c259$var$DATA_API_KEY$1 = '.data-api';
var $fb0d70065cb9c259$var$EVENT_LOAD_DATA_API$2 = "load".concat($fb0d70065cb9c259$var$EVENT_KEY$3).concat($fb0d70065cb9c259$var$DATA_API_KEY$1);
var $fb0d70065cb9c259$var$ESCAPE_KEY = 'Escape';
var $fb0d70065cb9c259$var$CLASS_NAME_SHOW$3 = 'show';
var $fb0d70065cb9c259$var$CLASS_NAME_SHOWING$1 = 'showing';
var $fb0d70065cb9c259$var$CLASS_NAME_HIDING = 'hiding';
var $fb0d70065cb9c259$var$CLASS_NAME_BACKDROP = 'offcanvas-backdrop';
var $fb0d70065cb9c259$var$OPEN_SELECTOR = '.offcanvas.show';
var $fb0d70065cb9c259$var$EVENT_SHOW$3 = "show".concat($fb0d70065cb9c259$var$EVENT_KEY$3);
var $fb0d70065cb9c259$var$EVENT_SHOWN$3 = "shown".concat($fb0d70065cb9c259$var$EVENT_KEY$3);
var $fb0d70065cb9c259$var$EVENT_HIDE$3 = "hide".concat($fb0d70065cb9c259$var$EVENT_KEY$3);
var $fb0d70065cb9c259$var$EVENT_HIDE_PREVENTED = "hidePrevented".concat($fb0d70065cb9c259$var$EVENT_KEY$3);
var $fb0d70065cb9c259$var$EVENT_HIDDEN$3 = "hidden".concat($fb0d70065cb9c259$var$EVENT_KEY$3);
var $fb0d70065cb9c259$var$EVENT_RESIZE = "resize".concat($fb0d70065cb9c259$var$EVENT_KEY$3);
var $fb0d70065cb9c259$var$EVENT_CLICK_DATA_API$1 = "click".concat($fb0d70065cb9c259$var$EVENT_KEY$3).concat($fb0d70065cb9c259$var$DATA_API_KEY$1);
var $fb0d70065cb9c259$var$EVENT_KEYDOWN_DISMISS = "keydown.dismiss".concat($fb0d70065cb9c259$var$EVENT_KEY$3);
var $fb0d70065cb9c259$var$SELECTOR_DATA_TOGGLE$1 = '[data-bs-toggle="offcanvas"]';
var $fb0d70065cb9c259$var$Default$5 = {
    backdrop: true,
    keyboard: true,
    scroll: false
};
var $fb0d70065cb9c259$var$DefaultType$5 = {
    backdrop: '(boolean|string)',
    keyboard: 'boolean',
    scroll: 'boolean'
};
/**
 * Class definition
 */ var $fb0d70065cb9c259$export$591ca0244c9dfcd4 = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $b4d46f07ff8e4522$export$71511d61b312f219)(Offcanvas, BaseComponent);
    function Offcanvas(element, config) {
        (0, $86c0177781495fc1$export$71511d61b312f219)(this, Offcanvas);
        var _this;
        _this = (0, $ffc84c232c16c006$export$71511d61b312f219)(this, Offcanvas, [
            element,
            config
        ]);
        _this._isShown = false;
        _this._backdrop = _this._initializeBackDrop();
        _this._focustrap = _this._initializeFocusTrap();
        _this._addEventListeners();
        return _this;
    }
    (0, $c2914329721d6e2b$export$71511d61b312f219)(Offcanvas, [
        {
            // Public
            key: "toggle",
            value: function toggle(relatedTarget) {
                return this._isShown ? this.hide() : this.show(relatedTarget);
            }
        },
        {
            key: "show",
            value: function show(relatedTarget) {
                var _this = this;
                if (this._isShown) return;
                var showEvent = $fb0d70065cb9c259$var$EventHandler.trigger(this._element, $fb0d70065cb9c259$var$EVENT_SHOW$3, {
                    relatedTarget: relatedTarget
                });
                if (showEvent.defaultPrevented) return;
                this._isShown = true;
                this._backdrop.show();
                if (!this._config.scroll) new $fb0d70065cb9c259$var$ScrollBarHelper().hide();
                this._element.setAttribute('aria-modal', true);
                this._element.setAttribute('role', 'dialog');
                this._element.classList.add($fb0d70065cb9c259$var$CLASS_NAME_SHOWING$1);
                var completeCallBack = function() {
                    if (!_this._config.scroll || _this._config.backdrop) _this._focustrap.activate();
                    _this._element.classList.add($fb0d70065cb9c259$var$CLASS_NAME_SHOW$3);
                    _this._element.classList.remove($fb0d70065cb9c259$var$CLASS_NAME_SHOWING$1);
                    $fb0d70065cb9c259$var$EventHandler.trigger(_this._element, $fb0d70065cb9c259$var$EVENT_SHOWN$3, {
                        relatedTarget: relatedTarget
                    });
                };
                this._queueCallback(completeCallBack, this._element, true);
            }
        },
        {
            key: "hide",
            value: function hide() {
                var _this = this;
                if (!this._isShown) return;
                var hideEvent = $fb0d70065cb9c259$var$EventHandler.trigger(this._element, $fb0d70065cb9c259$var$EVENT_HIDE$3);
                if (hideEvent.defaultPrevented) return;
                this._focustrap.deactivate();
                this._element.blur();
                this._isShown = false;
                this._element.classList.add($fb0d70065cb9c259$var$CLASS_NAME_HIDING);
                this._backdrop.hide();
                var completeCallback = function() {
                    _this._element.classList.remove($fb0d70065cb9c259$var$CLASS_NAME_SHOW$3, $fb0d70065cb9c259$var$CLASS_NAME_HIDING);
                    _this._element.removeAttribute('aria-modal');
                    _this._element.removeAttribute('role');
                    if (!_this._config.scroll) new $fb0d70065cb9c259$var$ScrollBarHelper().reset();
                    $fb0d70065cb9c259$var$EventHandler.trigger(_this._element, $fb0d70065cb9c259$var$EVENT_HIDDEN$3);
                };
                this._queueCallback(completeCallback, this._element, true);
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                this._backdrop.dispose();
                this._focustrap.deactivate();
                (0, $63451875c32f6bcb$export$71511d61b312f219)((0, $bf96ff342948c5d5$export$71511d61b312f219)(Offcanvas.prototype), "dispose", this).call(this);
            }
        },
        {
            // Private
            key: "_initializeBackDrop",
            value: function _initializeBackDrop() {
                var _this = this;
                var clickCallback = function() {
                    if (_this._config.backdrop === 'static') {
                        $fb0d70065cb9c259$var$EventHandler.trigger(_this._element, $fb0d70065cb9c259$var$EVENT_HIDE_PREVENTED);
                        return;
                    }
                    _this.hide();
                };
                // 'static' option will be translated to true, and booleans will keep their value
                var isVisible = Boolean(this._config.backdrop);
                return new $fb0d70065cb9c259$var$Backdrop({
                    className: $fb0d70065cb9c259$var$CLASS_NAME_BACKDROP,
                    isVisible: isVisible,
                    isAnimated: true,
                    rootElement: this._element.parentNode,
                    clickCallback: isVisible ? clickCallback : null
                });
            }
        },
        {
            key: "_initializeFocusTrap",
            value: function _initializeFocusTrap() {
                return new $fb0d70065cb9c259$var$FocusTrap({
                    trapElement: this._element
                });
            }
        },
        {
            key: "_addEventListeners",
            value: function _addEventListeners() {
                var _this = this;
                $fb0d70065cb9c259$var$EventHandler.on(this._element, $fb0d70065cb9c259$var$EVENT_KEYDOWN_DISMISS, function(event) {
                    if (event.key !== $fb0d70065cb9c259$var$ESCAPE_KEY) return;
                    if (_this._config.keyboard) {
                        _this.hide();
                        return;
                    }
                    $fb0d70065cb9c259$var$EventHandler.trigger(_this._element, $fb0d70065cb9c259$var$EVENT_HIDE_PREVENTED);
                });
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return $fb0d70065cb9c259$var$Default$5;
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return $fb0d70065cb9c259$var$DefaultType$5;
            }
        },
        {
            key: "NAME",
            get: function get() {
                return $fb0d70065cb9c259$var$NAME$6;
            }
        },
        {
            key: "jQueryInterface",
            value: // Static
            function jQueryInterface(config) {
                return this.each(function() {
                    var data = Offcanvas.getOrCreateInstance(this, config);
                    if (typeof config !== 'string') return;
                    if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError('No method named "'.concat(config, '"'));
                    data[config](this);
                });
            }
        }
    ]);
    return Offcanvas;
}($fb0d70065cb9c259$var$BaseComponent);
/**
 * Data API implementation
 */ $fb0d70065cb9c259$var$EventHandler.on(document, $fb0d70065cb9c259$var$EVENT_CLICK_DATA_API$1, $fb0d70065cb9c259$var$SELECTOR_DATA_TOGGLE$1, function(event) {
    var _this = this;
    var target = $fb0d70065cb9c259$var$SelectorEngine.getElementFromSelector(this);
    if ([
        'A',
        'AREA'
    ].includes(this.tagName)) event.preventDefault();
    if ($fb0d70065cb9c259$var$isDisabled(this)) return;
    $fb0d70065cb9c259$var$EventHandler.one(target, $fb0d70065cb9c259$var$EVENT_HIDDEN$3, function() {
        // focus on trigger when it is closed
        if ($fb0d70065cb9c259$var$isVisible(_this)) _this.focus();
    });
    // avoid conflict when clicking a toggler of an offcanvas, while another is open
    var alreadyOpen = $fb0d70065cb9c259$var$SelectorEngine.findOne($fb0d70065cb9c259$var$OPEN_SELECTOR);
    if (alreadyOpen && alreadyOpen !== target) $fb0d70065cb9c259$export$591ca0244c9dfcd4.getInstance(alreadyOpen).hide();
    var data = $fb0d70065cb9c259$export$591ca0244c9dfcd4.getOrCreateInstance(target);
    data.toggle(this);
});
$fb0d70065cb9c259$var$EventHandler.on(window, $fb0d70065cb9c259$var$EVENT_LOAD_DATA_API$2, function() {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $fb0d70065cb9c259$var$SelectorEngine.find($fb0d70065cb9c259$var$OPEN_SELECTOR)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var selector = _step.value;
            $fb0d70065cb9c259$export$591ca0244c9dfcd4.getOrCreateInstance(selector).show();
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
});
$fb0d70065cb9c259$var$EventHandler.on(window, $fb0d70065cb9c259$var$EVENT_RESIZE, function() {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $fb0d70065cb9c259$var$SelectorEngine.find('[aria-modal][class*=show][class*=offcanvas-]')[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var element = _step.value;
            if (getComputedStyle(element).position !== 'fixed') $fb0d70065cb9c259$export$591ca0244c9dfcd4.getOrCreateInstance(element).hide();
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
});
$fb0d70065cb9c259$var$enableDismissTrigger($fb0d70065cb9c259$export$591ca0244c9dfcd4);
/**
 * jQuery
 */ $fb0d70065cb9c259$var$defineJQueryPlugin($fb0d70065cb9c259$export$591ca0244c9dfcd4);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/sanitizer.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ // js-docs-start allow-list
var $fb0d70065cb9c259$var$ARIA_ATTRIBUTE_PATTERN = /^aria-[\w-]*$/i;
var $fb0d70065cb9c259$var$DefaultAllowlist = {
    // Global attributes allowed on any supplied element below.
    '*': [
        'class',
        'dir',
        'id',
        'lang',
        'role',
        $fb0d70065cb9c259$var$ARIA_ATTRIBUTE_PATTERN
    ],
    a: [
        'target',
        'href',
        'title',
        'rel'
    ],
    area: [],
    b: [],
    br: [],
    col: [],
    code: [],
    dd: [],
    div: [],
    dl: [],
    dt: [],
    em: [],
    hr: [],
    h1: [],
    h2: [],
    h3: [],
    h4: [],
    h5: [],
    h6: [],
    i: [],
    img: [
        'src',
        'srcset',
        'alt',
        'title',
        'width',
        'height'
    ],
    li: [],
    ol: [],
    p: [],
    pre: [],
    s: [],
    small: [],
    span: [],
    sub: [],
    sup: [],
    strong: [],
    u: [],
    ul: []
};
// js-docs-end allow-list
var $fb0d70065cb9c259$var$uriAttributes = new Set([
    'background',
    'cite',
    'href',
    'itemtype',
    'longdesc',
    'poster',
    'src',
    'xlink:href'
]);
/**
 * A pattern that recognizes URLs that are safe wrt. XSS in URL navigation
 * contexts.
 *
 * Shout-out to Angular https://github.com/angular/angular/blob/15.2.8/packages/core/src/sanitization/url_sanitizer.ts#L38
 */ var $fb0d70065cb9c259$var$SAFE_URL_PATTERN = /^(?!javascript:)(?:[a-z0-9+.-]+:|[^&:/?#]*(?:[/?#]|$))/i;
var $fb0d70065cb9c259$var$allowedAttribute = function(attribute, allowedAttributeList) {
    var attributeName = attribute.nodeName.toLowerCase();
    if (allowedAttributeList.includes(attributeName)) {
        if ($fb0d70065cb9c259$var$uriAttributes.has(attributeName)) return Boolean($fb0d70065cb9c259$var$SAFE_URL_PATTERN.test(attribute.nodeValue));
        return true;
    }
    // Check if a regular expression validates the attribute.
    return allowedAttributeList.filter(function(attributeRegex) {
        return attributeRegex instanceof RegExp;
    }).some(function(regex) {
        return regex.test(attributeName);
    });
};
function $fb0d70065cb9c259$var$sanitizeHtml(unsafeHtml, allowList, sanitizeFunction) {
    var _instance;
    if (!unsafeHtml.length) return unsafeHtml;
    if (sanitizeFunction && typeof sanitizeFunction === 'function') return sanitizeFunction(unsafeHtml);
    var domParser = new window.DOMParser();
    var createdDocument = domParser.parseFromString(unsafeHtml, 'text/html');
    var elements = (_instance = []).concat.apply(_instance, (0, $2l5av._)(createdDocument.body.querySelectorAll('*')));
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = elements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var element = _step.value;
            var _instance1;
            var elementName = element.nodeName.toLowerCase();
            if (!Object.keys(allowList).includes(elementName)) {
                element.remove();
                continue;
            }
            var attributeList = (_instance1 = []).concat.apply(_instance1, (0, $2l5av._)(element.attributes));
            var allowedAttributes = [].concat(allowList['*'] || [], allowList[elementName] || []);
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = attributeList[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var attribute = _step1.value;
                    if (!$fb0d70065cb9c259$var$allowedAttribute(attribute, allowedAttributes)) element.removeAttribute(attribute.nodeName);
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return createdDocument.body.innerHTML;
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/template-factory.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $fb0d70065cb9c259$var$NAME$5 = 'TemplateFactory';
var $fb0d70065cb9c259$var$Default$4 = {
    allowList: $fb0d70065cb9c259$var$DefaultAllowlist,
    content: {},
    // { selector : text ,  selector2 : text2 , }
    extraClass: '',
    html: false,
    sanitize: true,
    sanitizeFn: null,
    template: '<div></div>'
};
var $fb0d70065cb9c259$var$DefaultType$4 = {
    allowList: 'object',
    content: 'object',
    extraClass: '(string|function)',
    html: 'boolean',
    sanitize: 'boolean',
    sanitizeFn: '(null|function)',
    template: 'string'
};
var $fb0d70065cb9c259$var$DefaultContentType = {
    entry: '(string|element|function|null)',
    selector: '(string|element)'
};
/**
 * Class definition
 */ var $fb0d70065cb9c259$var$TemplateFactory = /*#__PURE__*/ function(Config) {
    "use strict";
    (0, $b4d46f07ff8e4522$export$71511d61b312f219)(TemplateFactory, Config);
    function TemplateFactory(config) {
        (0, $86c0177781495fc1$export$71511d61b312f219)(this, TemplateFactory);
        var _this;
        _this = (0, $ffc84c232c16c006$export$71511d61b312f219)(this, TemplateFactory);
        _this._config = _this._getConfig(config);
        return _this;
    }
    (0, $c2914329721d6e2b$export$71511d61b312f219)(TemplateFactory, [
        {
            // Public
            key: "getContent",
            value: function getContent() {
                var _this = this;
                return Object.values(this._config.content).map(function(config) {
                    return _this._resolvePossibleFunction(config);
                }).filter(Boolean);
            }
        },
        {
            key: "hasContent",
            value: function hasContent() {
                return this.getContent().length > 0;
            }
        },
        {
            key: "changeContent",
            value: function changeContent(content) {
                this._checkContent(content);
                this._config.content = (0, $54f510fc1e3f8947$export$71511d61b312f219)({}, this._config.content, content);
                return this;
            }
        },
        {
            key: "toHtml",
            value: function toHtml() {
                var _template_classList;
                var templateWrapper = document.createElement('div');
                templateWrapper.innerHTML = this._maybeSanitize(this._config.template);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.entries(this._config.content)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $6557624075f14dc6$export$71511d61b312f219)(_step.value, 2), selector = _step_value[0], text = _step_value[1];
                        this._setContent(templateWrapper, text, selector);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var template = templateWrapper.children[0];
                var extraClass = this._resolvePossibleFunction(this._config.extraClass);
                if (extraClass) (_template_classList = template.classList).add.apply(_template_classList, (0, $2l5av._)(extraClass.split(' ')));
                return template;
            }
        },
        {
            // Private
            key: "_typeCheckConfig",
            value: function _typeCheckConfig(config) {
                (0, $63451875c32f6bcb$export$71511d61b312f219)((0, $bf96ff342948c5d5$export$71511d61b312f219)(TemplateFactory.prototype), "_typeCheckConfig", this).call(this, config);
                this._checkContent(config.content);
            }
        },
        {
            key: "_checkContent",
            value: function _checkContent(arg) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.entries(arg)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $6557624075f14dc6$export$71511d61b312f219)(_step.value, 2), selector = _step_value[0], content = _step_value[1];
                        (0, $63451875c32f6bcb$export$71511d61b312f219)((0, $bf96ff342948c5d5$export$71511d61b312f219)(TemplateFactory.prototype), "_typeCheckConfig", this).call(this, {
                            selector: selector,
                            entry: content
                        }, $fb0d70065cb9c259$var$DefaultContentType);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "_setContent",
            value: function _setContent(template, content, selector) {
                var templateElement = $fb0d70065cb9c259$var$SelectorEngine.findOne(selector, template);
                if (!templateElement) return;
                content = this._resolvePossibleFunction(content);
                if (!content) {
                    templateElement.remove();
                    return;
                }
                if ($fb0d70065cb9c259$var$isElement(content)) {
                    this._putElementInTemplate($fb0d70065cb9c259$var$getElement(content), templateElement);
                    return;
                }
                if (this._config.html) {
                    templateElement.innerHTML = this._maybeSanitize(content);
                    return;
                }
                templateElement.textContent = content;
            }
        },
        {
            key: "_maybeSanitize",
            value: function _maybeSanitize(arg) {
                return this._config.sanitize ? $fb0d70065cb9c259$var$sanitizeHtml(arg, this._config.allowList, this._config.sanitizeFn) : arg;
            }
        },
        {
            key: "_resolvePossibleFunction",
            value: function _resolvePossibleFunction(arg) {
                return $fb0d70065cb9c259$var$execute(arg, [
                    undefined,
                    this
                ]);
            }
        },
        {
            key: "_putElementInTemplate",
            value: function _putElementInTemplate(element, templateElement) {
                if (this._config.html) {
                    templateElement.innerHTML = '';
                    templateElement.append(element);
                    return;
                }
                templateElement.textContent = element.textContent;
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return $fb0d70065cb9c259$var$Default$4;
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return $fb0d70065cb9c259$var$DefaultType$4;
            }
        },
        {
            key: "NAME",
            get: function get() {
                return $fb0d70065cb9c259$var$NAME$5;
            }
        }
    ]);
    return TemplateFactory;
}($fb0d70065cb9c259$var$Config);
/**
 * --------------------------------------------------------------------------
 * Bootstrap tooltip.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $fb0d70065cb9c259$var$NAME$4 = 'tooltip';
var $fb0d70065cb9c259$var$DISALLOWED_ATTRIBUTES = new Set([
    'sanitize',
    'allowList',
    'sanitizeFn'
]);
var $fb0d70065cb9c259$var$CLASS_NAME_FADE$2 = 'fade';
var $fb0d70065cb9c259$var$CLASS_NAME_MODAL = 'modal';
var $fb0d70065cb9c259$var$CLASS_NAME_SHOW$2 = 'show';
var $fb0d70065cb9c259$var$SELECTOR_TOOLTIP_INNER = '.tooltip-inner';
var $fb0d70065cb9c259$var$SELECTOR_MODAL = ".".concat($fb0d70065cb9c259$var$CLASS_NAME_MODAL);
var $fb0d70065cb9c259$var$EVENT_MODAL_HIDE = 'hide.bs.modal';
var $fb0d70065cb9c259$var$TRIGGER_HOVER = 'hover';
var $fb0d70065cb9c259$var$TRIGGER_FOCUS = 'focus';
var $fb0d70065cb9c259$var$TRIGGER_CLICK = 'click';
var $fb0d70065cb9c259$var$TRIGGER_MANUAL = 'manual';
var $fb0d70065cb9c259$var$EVENT_HIDE$2 = 'hide';
var $fb0d70065cb9c259$var$EVENT_HIDDEN$2 = 'hidden';
var $fb0d70065cb9c259$var$EVENT_SHOW$2 = 'show';
var $fb0d70065cb9c259$var$EVENT_SHOWN$2 = 'shown';
var $fb0d70065cb9c259$var$EVENT_INSERTED = 'inserted';
var $fb0d70065cb9c259$var$EVENT_CLICK$1 = 'click';
var $fb0d70065cb9c259$var$EVENT_FOCUSIN$1 = 'focusin';
var $fb0d70065cb9c259$var$EVENT_FOCUSOUT$1 = 'focusout';
var $fb0d70065cb9c259$var$EVENT_MOUSEENTER = 'mouseenter';
var $fb0d70065cb9c259$var$EVENT_MOUSELEAVE = 'mouseleave';
var $fb0d70065cb9c259$var$AttachmentMap = {
    AUTO: 'auto',
    TOP: 'top',
    RIGHT: $fb0d70065cb9c259$var$isRTL() ? 'left' : 'right',
    BOTTOM: 'bottom',
    LEFT: $fb0d70065cb9c259$var$isRTL() ? 'right' : 'left'
};
var $fb0d70065cb9c259$var$Default$3 = {
    allowList: $fb0d70065cb9c259$var$DefaultAllowlist,
    animation: true,
    boundary: 'clippingParents',
    container: false,
    customClass: '',
    delay: 0,
    fallbackPlacements: [
        'top',
        'right',
        'bottom',
        'left'
    ],
    html: false,
    offset: [
        0,
        6
    ],
    placement: 'top',
    popperConfig: null,
    sanitize: true,
    sanitizeFn: null,
    selector: false,
    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
    title: '',
    trigger: 'hover focus'
};
var $fb0d70065cb9c259$var$DefaultType$3 = {
    allowList: 'object',
    animation: 'boolean',
    boundary: '(string|element)',
    container: '(string|element|boolean)',
    customClass: '(string|function)',
    delay: '(number|object)',
    fallbackPlacements: 'array',
    html: 'boolean',
    offset: '(array|string|function)',
    placement: '(string|function)',
    popperConfig: '(null|object|function)',
    sanitize: 'boolean',
    sanitizeFn: '(null|function)',
    selector: '(string|boolean)',
    template: 'string',
    title: '(string|element|function)',
    trigger: 'string'
};
/**
 * Class definition
 */ var $fb0d70065cb9c259$export$28c660c63b792dea = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $b4d46f07ff8e4522$export$71511d61b312f219)(Tooltip, BaseComponent);
    function Tooltip(element, config) {
        (0, $86c0177781495fc1$export$71511d61b312f219)(this, Tooltip);
        var _this;
        if (typeof $d924a49372bb56ad$exports === 'undefined') throw new TypeError('Bootstrap\'s tooltips require Popper (https://popper.js.org/docs/v2/)');
        _this = (0, $ffc84c232c16c006$export$71511d61b312f219)(this, Tooltip, [
            element,
            config
        ]);
        // Private
        _this._isEnabled = true;
        _this._timeout = 0;
        _this._isHovered = null;
        _this._activeTrigger = {};
        _this._popper = null;
        _this._templateFactory = null;
        _this._newContent = null;
        // Protected
        _this.tip = null;
        _this._setListeners();
        if (!_this._config.selector) _this._fixTitle();
        return _this;
    }
    (0, $c2914329721d6e2b$export$71511d61b312f219)(Tooltip, [
        {
            // Public
            key: "enable",
            value: function enable() {
                this._isEnabled = true;
            }
        },
        {
            key: "disable",
            value: function disable() {
                this._isEnabled = false;
            }
        },
        {
            key: "toggleEnabled",
            value: function toggleEnabled() {
                this._isEnabled = !this._isEnabled;
            }
        },
        {
            key: "toggle",
            value: function toggle() {
                if (!this._isEnabled) return;
                if (this._isShown()) {
                    this._leave();
                    return;
                }
                this._enter();
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                clearTimeout(this._timeout);
                $fb0d70065cb9c259$var$EventHandler.off(this._element.closest($fb0d70065cb9c259$var$SELECTOR_MODAL), $fb0d70065cb9c259$var$EVENT_MODAL_HIDE, this._hideModalHandler);
                if (this._element.getAttribute('data-bs-original-title')) this._element.setAttribute('title', this._element.getAttribute('data-bs-original-title'));
                this._disposePopper();
                (0, $63451875c32f6bcb$export$71511d61b312f219)((0, $bf96ff342948c5d5$export$71511d61b312f219)(Tooltip.prototype), "dispose", this).call(this);
            }
        },
        {
            key: "show",
            value: function show() {
                var _this = this;
                var _instance;
                if (this._element.style.display === 'none') throw new Error('Please use show on visible elements');
                if (!(this._isWithContent() && this._isEnabled)) return;
                var showEvent = $fb0d70065cb9c259$var$EventHandler.trigger(this._element, this.constructor.eventName($fb0d70065cb9c259$var$EVENT_SHOW$2));
                var shadowRoot = $fb0d70065cb9c259$var$findShadowRoot(this._element);
                var isInTheDom = (shadowRoot || this._element.ownerDocument.documentElement).contains(this._element);
                if (showEvent.defaultPrevented || !isInTheDom) return;
                // TODO: v6 remove this or make it optional
                this._disposePopper();
                var tip = this._getTipElement();
                this._element.setAttribute('aria-describedby', tip.getAttribute('id'));
                var container = this._config.container;
                if (!this._element.ownerDocument.documentElement.contains(this.tip)) {
                    container.append(tip);
                    $fb0d70065cb9c259$var$EventHandler.trigger(this._element, this.constructor.eventName($fb0d70065cb9c259$var$EVENT_INSERTED));
                }
                this._popper = this._createPopper(tip);
                tip.classList.add($fb0d70065cb9c259$var$CLASS_NAME_SHOW$2);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                // If this is a touch-enabled device we add extra
                // empty mouseover listeners to the body's immediate children;
                // only needed because of broken event delegation on iOS
                // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
                if ('ontouchstart' in document.documentElement) try {
                    for(var _iterator = (_instance = []).concat.apply(_instance, (0, $2l5av._)(document.body.children))[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var element = _step.value;
                        $fb0d70065cb9c259$var$EventHandler.on(element, 'mouseover', $fb0d70065cb9c259$var$noop);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var complete = function() {
                    $fb0d70065cb9c259$var$EventHandler.trigger(_this._element, _this.constructor.eventName($fb0d70065cb9c259$var$EVENT_SHOWN$2));
                    if (_this._isHovered === false) _this._leave();
                    _this._isHovered = false;
                };
                this._queueCallback(complete, this.tip, this._isAnimated());
            }
        },
        {
            key: "hide",
            value: function hide() {
                var _this = this;
                var _instance;
                if (!this._isShown()) return;
                var hideEvent = $fb0d70065cb9c259$var$EventHandler.trigger(this._element, this.constructor.eventName($fb0d70065cb9c259$var$EVENT_HIDE$2));
                if (hideEvent.defaultPrevented) return;
                var tip = this._getTipElement();
                tip.classList.remove($fb0d70065cb9c259$var$CLASS_NAME_SHOW$2);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                // If this is a touch-enabled device we remove the extra
                // empty mouseover listeners we added for iOS support
                if ('ontouchstart' in document.documentElement) try {
                    for(var _iterator = (_instance = []).concat.apply(_instance, (0, $2l5av._)(document.body.children))[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var element = _step.value;
                        $fb0d70065cb9c259$var$EventHandler.off(element, 'mouseover', $fb0d70065cb9c259$var$noop);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                this._activeTrigger[$fb0d70065cb9c259$var$TRIGGER_CLICK] = false;
                this._activeTrigger[$fb0d70065cb9c259$var$TRIGGER_FOCUS] = false;
                this._activeTrigger[$fb0d70065cb9c259$var$TRIGGER_HOVER] = false;
                this._isHovered = null; // it is a trick to support manual triggering
                var complete = function() {
                    if (_this._isWithActiveTrigger()) return;
                    if (!_this._isHovered) _this._disposePopper();
                    _this._element.removeAttribute('aria-describedby');
                    $fb0d70065cb9c259$var$EventHandler.trigger(_this._element, _this.constructor.eventName($fb0d70065cb9c259$var$EVENT_HIDDEN$2));
                };
                this._queueCallback(complete, this.tip, this._isAnimated());
            }
        },
        {
            key: "update",
            value: function update() {
                if (this._popper) this._popper.update();
            }
        },
        {
            // Protected
            key: "_isWithContent",
            value: function _isWithContent() {
                return Boolean(this._getTitle());
            }
        },
        {
            key: "_getTipElement",
            value: function _getTipElement() {
                if (!this.tip) this.tip = this._createTipElement(this._newContent || this._getContentForTemplate());
                return this.tip;
            }
        },
        {
            key: "_createTipElement",
            value: function _createTipElement(content) {
                var tip = this._getTemplateFactory(content).toHtml();
                // TODO: remove this check in v6
                if (!tip) return null;
                tip.classList.remove($fb0d70065cb9c259$var$CLASS_NAME_FADE$2, $fb0d70065cb9c259$var$CLASS_NAME_SHOW$2);
                // TODO: v6 the following can be achieved with CSS only
                tip.classList.add("bs-".concat(this.constructor.NAME, "-auto"));
                var tipId = $fb0d70065cb9c259$var$getUID(this.constructor.NAME).toString();
                tip.setAttribute('id', tipId);
                if (this._isAnimated()) tip.classList.add($fb0d70065cb9c259$var$CLASS_NAME_FADE$2);
                return tip;
            }
        },
        {
            key: "setContent",
            value: function setContent(content) {
                this._newContent = content;
                if (this._isShown()) {
                    this._disposePopper();
                    this.show();
                }
            }
        },
        {
            key: "_getTemplateFactory",
            value: function _getTemplateFactory(content) {
                if (this._templateFactory) this._templateFactory.changeContent(content);
                else this._templateFactory = new $fb0d70065cb9c259$var$TemplateFactory((0, $b436c975fcff02ae$export$71511d61b312f219)((0, $54f510fc1e3f8947$export$71511d61b312f219)({}, this._config), {
                    // the `content` var has to be after `this._config`
                    // to override config.content in case of popover
                    content: content,
                    extraClass: this._resolvePossibleFunction(this._config.customClass)
                }));
                return this._templateFactory;
            }
        },
        {
            key: "_getContentForTemplate",
            value: function _getContentForTemplate() {
                return (0, $eac6a0488bea45ee$export$71511d61b312f219)({}, $fb0d70065cb9c259$var$SELECTOR_TOOLTIP_INNER, this._getTitle());
            }
        },
        {
            key: "_getTitle",
            value: function _getTitle() {
                return this._resolvePossibleFunction(this._config.title) || this._element.getAttribute('data-bs-original-title');
            }
        },
        {
            // Private
            key: "_initializeOnDelegatedTarget",
            value: function _initializeOnDelegatedTarget(event) {
                return this.constructor.getOrCreateInstance(event.delegateTarget, this._getDelegateConfig());
            }
        },
        {
            key: "_isAnimated",
            value: function _isAnimated() {
                return this._config.animation || this.tip && this.tip.classList.contains($fb0d70065cb9c259$var$CLASS_NAME_FADE$2);
            }
        },
        {
            key: "_isShown",
            value: function _isShown() {
                return this.tip && this.tip.classList.contains($fb0d70065cb9c259$var$CLASS_NAME_SHOW$2);
            }
        },
        {
            key: "_createPopper",
            value: function _createPopper(tip) {
                var placement = $fb0d70065cb9c259$var$execute(this._config.placement, [
                    this,
                    tip,
                    this._element
                ]);
                var attachment = $fb0d70065cb9c259$var$AttachmentMap[placement.toUpperCase()];
                return $d924a49372bb56ad$exports.createPopper(this._element, tip, this._getPopperConfig(attachment));
            }
        },
        {
            key: "_getOffset",
            value: function _getOffset() {
                var _this = this;
                var offset = this._config.offset;
                if (typeof offset === 'string') return offset.split(',').map(function(value) {
                    return Number.parseInt(value, 10);
                });
                if (typeof offset === 'function') return function(popperData) {
                    return offset(popperData, _this._element);
                };
                return offset;
            }
        },
        {
            key: "_resolvePossibleFunction",
            value: function _resolvePossibleFunction(arg) {
                return $fb0d70065cb9c259$var$execute(arg, [
                    this._element,
                    this._element
                ]);
            }
        },
        {
            key: "_getPopperConfig",
            value: function _getPopperConfig(attachment) {
                var _this = this;
                var defaultBsPopperConfig = {
                    placement: attachment,
                    modifiers: [
                        {
                            name: 'flip',
                            options: {
                                fallbackPlacements: this._config.fallbackPlacements
                            }
                        },
                        {
                            name: 'offset',
                            options: {
                                offset: this._getOffset()
                            }
                        },
                        {
                            name: 'preventOverflow',
                            options: {
                                boundary: this._config.boundary
                            }
                        },
                        {
                            name: 'arrow',
                            options: {
                                element: ".".concat(this.constructor.NAME, "-arrow")
                            }
                        },
                        {
                            name: 'preSetPlacement',
                            enabled: true,
                            phase: 'beforeMain',
                            fn: function(data) {
                                // Pre-set Popper's placement attribute in order to read the arrow sizes properly.
                                // Otherwise, Popper mixes up the width and height dimensions since the initial arrow style is for top placement
                                _this._getTipElement().setAttribute('data-popper-placement', data.state.placement);
                            }
                        }
                    ]
                };
                return (0, $54f510fc1e3f8947$export$71511d61b312f219)({}, defaultBsPopperConfig, $fb0d70065cb9c259$var$execute(this._config.popperConfig, [
                    undefined,
                    defaultBsPopperConfig
                ]));
            }
        },
        {
            key: "_setListeners",
            value: function _setListeners() {
                var _this = this;
                var triggers = this._config.trigger.split(' ');
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = triggers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var trigger = _step.value;
                        if (trigger === 'click') $fb0d70065cb9c259$var$EventHandler.on(this._element, this.constructor.eventName($fb0d70065cb9c259$var$EVENT_CLICK$1), this._config.selector, function(event) {
                            var context = _this._initializeOnDelegatedTarget(event);
                            context._activeTrigger[$fb0d70065cb9c259$var$TRIGGER_CLICK] = !(context._isShown() && context._activeTrigger[$fb0d70065cb9c259$var$TRIGGER_CLICK]);
                            context.toggle();
                        });
                        else if (trigger !== $fb0d70065cb9c259$var$TRIGGER_MANUAL) {
                            var eventIn = trigger === $fb0d70065cb9c259$var$TRIGGER_HOVER ? this.constructor.eventName($fb0d70065cb9c259$var$EVENT_MOUSEENTER) : this.constructor.eventName($fb0d70065cb9c259$var$EVENT_FOCUSIN$1);
                            var eventOut = trigger === $fb0d70065cb9c259$var$TRIGGER_HOVER ? this.constructor.eventName($fb0d70065cb9c259$var$EVENT_MOUSELEAVE) : this.constructor.eventName($fb0d70065cb9c259$var$EVENT_FOCUSOUT$1);
                            $fb0d70065cb9c259$var$EventHandler.on(this._element, eventIn, this._config.selector, function(event) {
                                var context = _this._initializeOnDelegatedTarget(event);
                                context._activeTrigger[event.type === 'focusin' ? $fb0d70065cb9c259$var$TRIGGER_FOCUS : $fb0d70065cb9c259$var$TRIGGER_HOVER] = true;
                                context._enter();
                            });
                            $fb0d70065cb9c259$var$EventHandler.on(this._element, eventOut, this._config.selector, function(event) {
                                var context = _this._initializeOnDelegatedTarget(event);
                                context._activeTrigger[event.type === 'focusout' ? $fb0d70065cb9c259$var$TRIGGER_FOCUS : $fb0d70065cb9c259$var$TRIGGER_HOVER] = context._element.contains(event.relatedTarget);
                                context._leave();
                            });
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                this._hideModalHandler = function() {
                    if (_this._element) _this.hide();
                };
                $fb0d70065cb9c259$var$EventHandler.on(this._element.closest($fb0d70065cb9c259$var$SELECTOR_MODAL), $fb0d70065cb9c259$var$EVENT_MODAL_HIDE, this._hideModalHandler);
            }
        },
        {
            key: "_fixTitle",
            value: function _fixTitle() {
                var title = this._element.getAttribute('title');
                if (!title) return;
                if (!this._element.getAttribute('aria-label') && !this._element.textContent.trim()) this._element.setAttribute('aria-label', title);
                this._element.setAttribute('data-bs-original-title', title); // DO NOT USE IT. Is only for backwards compatibility
                this._element.removeAttribute('title');
            }
        },
        {
            key: "_enter",
            value: function _enter() {
                var _this = this;
                if (this._isShown() || this._isHovered) {
                    this._isHovered = true;
                    return;
                }
                this._isHovered = true;
                this._setTimeout(function() {
                    if (_this._isHovered) _this.show();
                }, this._config.delay.show);
            }
        },
        {
            key: "_leave",
            value: function _leave() {
                var _this = this;
                if (this._isWithActiveTrigger()) return;
                this._isHovered = false;
                this._setTimeout(function() {
                    if (!_this._isHovered) _this.hide();
                }, this._config.delay.hide);
            }
        },
        {
            key: "_setTimeout",
            value: function _setTimeout(handler, timeout) {
                clearTimeout(this._timeout);
                this._timeout = setTimeout(handler, timeout);
            }
        },
        {
            key: "_isWithActiveTrigger",
            value: function _isWithActiveTrigger() {
                return Object.values(this._activeTrigger).includes(true);
            }
        },
        {
            key: "_getConfig",
            value: function _getConfig(config) {
                var dataAttributes = $fb0d70065cb9c259$var$Manipulator.getDataAttributes(this._element);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.keys(dataAttributes)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var dataAttribute = _step.value;
                        if ($fb0d70065cb9c259$var$DISALLOWED_ATTRIBUTES.has(dataAttribute)) delete dataAttributes[dataAttribute];
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                config = (0, $54f510fc1e3f8947$export$71511d61b312f219)({}, dataAttributes, (typeof config === "undefined" ? "undefined" : (0, $aqUTs._)(config)) === 'object' && config ? config : {});
                config = this._mergeConfigObj(config);
                config = this._configAfterMerge(config);
                this._typeCheckConfig(config);
                return config;
            }
        },
        {
            key: "_configAfterMerge",
            value: function _configAfterMerge(config) {
                config.container = config.container === false ? document.body : $fb0d70065cb9c259$var$getElement(config.container);
                if (typeof config.delay === 'number') config.delay = {
                    show: config.delay,
                    hide: config.delay
                };
                if (typeof config.title === 'number') config.title = config.title.toString();
                if (typeof config.content === 'number') config.content = config.content.toString();
                return config;
            }
        },
        {
            key: "_getDelegateConfig",
            value: function _getDelegateConfig() {
                var config = {};
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.entries(this._config)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $6557624075f14dc6$export$71511d61b312f219)(_step.value, 2), key = _step_value[0], value = _step_value[1];
                        if (this.constructor.Default[key] !== value) config[key] = value;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                config.selector = false;
                config.trigger = 'manual';
                // In the future can be replaced with:
                // const keysWithDifferentValues = Object.entries(this._config).filter(entry => this.constructor.Default[entry[0]] !== this._config[entry[0]])
                // `Object.fromEntries(keysWithDifferentValues)`
                return config;
            }
        },
        {
            key: "_disposePopper",
            value: function _disposePopper() {
                if (this._popper) {
                    this._popper.destroy();
                    this._popper = null;
                }
                if (this.tip) {
                    this.tip.remove();
                    this.tip = null;
                }
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return $fb0d70065cb9c259$var$Default$3;
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return $fb0d70065cb9c259$var$DefaultType$3;
            }
        },
        {
            key: "NAME",
            get: function get() {
                return $fb0d70065cb9c259$var$NAME$4;
            }
        },
        {
            key: "jQueryInterface",
            value: // Static
            function jQueryInterface(config) {
                return this.each(function() {
                    var data = Tooltip.getOrCreateInstance(this, config);
                    if (typeof config !== 'string') return;
                    if (typeof data[config] === 'undefined') throw new TypeError('No method named "'.concat(config, '"'));
                    data[config]();
                });
            }
        }
    ]);
    return Tooltip;
}($fb0d70065cb9c259$var$BaseComponent);
/**
 * jQuery
 */ $fb0d70065cb9c259$var$defineJQueryPlugin($fb0d70065cb9c259$export$28c660c63b792dea);
/**
 * --------------------------------------------------------------------------
 * Bootstrap popover.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $fb0d70065cb9c259$var$NAME$3 = 'popover';
var $fb0d70065cb9c259$var$SELECTOR_TITLE = '.popover-header';
var $fb0d70065cb9c259$var$SELECTOR_CONTENT = '.popover-body';
var $fb0d70065cb9c259$var$Default$2 = (0, $b436c975fcff02ae$export$71511d61b312f219)((0, $54f510fc1e3f8947$export$71511d61b312f219)({}, $fb0d70065cb9c259$export$28c660c63b792dea.Default), {
    content: '',
    offset: [
        0,
        8
    ],
    placement: 'right',
    template: '<div class="popover" role="tooltip"><div class="popover-arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>',
    trigger: 'click'
});
var $fb0d70065cb9c259$var$DefaultType$2 = (0, $b436c975fcff02ae$export$71511d61b312f219)((0, $54f510fc1e3f8947$export$71511d61b312f219)({}, $fb0d70065cb9c259$export$28c660c63b792dea.DefaultType), {
    content: '(null|string|element|function)'
});
/**
 * Class definition
 */ var $fb0d70065cb9c259$export$5b6b19405a83ff9d = /*#__PURE__*/ function(Tooltip) {
    "use strict";
    (0, $b4d46f07ff8e4522$export$71511d61b312f219)(Popover, Tooltip);
    function Popover() {
        (0, $86c0177781495fc1$export$71511d61b312f219)(this, Popover);
        return (0, $ffc84c232c16c006$export$71511d61b312f219)(this, Popover, arguments);
    }
    (0, $c2914329721d6e2b$export$71511d61b312f219)(Popover, [
        {
            // Overrides
            key: "_isWithContent",
            value: function _isWithContent() {
                return this._getTitle() || this._getContent();
            }
        },
        {
            // Private
            key: "_getContentForTemplate",
            value: function _getContentForTemplate() {
                var _obj;
                return _obj = {}, (0, $eac6a0488bea45ee$export$71511d61b312f219)(_obj, $fb0d70065cb9c259$var$SELECTOR_TITLE, this._getTitle()), (0, $eac6a0488bea45ee$export$71511d61b312f219)(_obj, $fb0d70065cb9c259$var$SELECTOR_CONTENT, this._getContent()), _obj;
            }
        },
        {
            key: "_getContent",
            value: function _getContent() {
                return this._resolvePossibleFunction(this._config.content);
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return $fb0d70065cb9c259$var$Default$2;
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return $fb0d70065cb9c259$var$DefaultType$2;
            }
        },
        {
            key: "NAME",
            get: function get() {
                return $fb0d70065cb9c259$var$NAME$3;
            }
        },
        {
            key: "jQueryInterface",
            value: // Static
            function jQueryInterface(config) {
                return this.each(function() {
                    var data = Popover.getOrCreateInstance(this, config);
                    if (typeof config !== 'string') return;
                    if (typeof data[config] === 'undefined') throw new TypeError('No method named "'.concat(config, '"'));
                    data[config]();
                });
            }
        }
    ]);
    return Popover;
}($fb0d70065cb9c259$export$28c660c63b792dea);
/**
 * jQuery
 */ $fb0d70065cb9c259$var$defineJQueryPlugin($fb0d70065cb9c259$export$5b6b19405a83ff9d);
/**
 * --------------------------------------------------------------------------
 * Bootstrap scrollspy.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $fb0d70065cb9c259$var$NAME$2 = 'scrollspy';
var $fb0d70065cb9c259$var$DATA_KEY$2 = 'bs.scrollspy';
var $fb0d70065cb9c259$var$EVENT_KEY$2 = ".".concat($fb0d70065cb9c259$var$DATA_KEY$2);
var $fb0d70065cb9c259$var$DATA_API_KEY = '.data-api';
var $fb0d70065cb9c259$var$EVENT_ACTIVATE = "activate".concat($fb0d70065cb9c259$var$EVENT_KEY$2);
var $fb0d70065cb9c259$var$EVENT_CLICK = "click".concat($fb0d70065cb9c259$var$EVENT_KEY$2);
var $fb0d70065cb9c259$var$EVENT_LOAD_DATA_API$1 = "load".concat($fb0d70065cb9c259$var$EVENT_KEY$2).concat($fb0d70065cb9c259$var$DATA_API_KEY);
var $fb0d70065cb9c259$var$CLASS_NAME_DROPDOWN_ITEM = 'dropdown-item';
var $fb0d70065cb9c259$var$CLASS_NAME_ACTIVE$1 = 'active';
var $fb0d70065cb9c259$var$SELECTOR_DATA_SPY = '[data-bs-spy="scroll"]';
var $fb0d70065cb9c259$var$SELECTOR_TARGET_LINKS = '[href]';
var $fb0d70065cb9c259$var$SELECTOR_NAV_LIST_GROUP = '.nav, .list-group';
var $fb0d70065cb9c259$var$SELECTOR_NAV_LINKS = '.nav-link';
var $fb0d70065cb9c259$var$SELECTOR_NAV_ITEMS = '.nav-item';
var $fb0d70065cb9c259$var$SELECTOR_LIST_ITEMS = '.list-group-item';
var $fb0d70065cb9c259$var$SELECTOR_LINK_ITEMS = "".concat($fb0d70065cb9c259$var$SELECTOR_NAV_LINKS, ", ").concat($fb0d70065cb9c259$var$SELECTOR_NAV_ITEMS, " > ").concat($fb0d70065cb9c259$var$SELECTOR_NAV_LINKS, ", ").concat($fb0d70065cb9c259$var$SELECTOR_LIST_ITEMS);
var $fb0d70065cb9c259$var$SELECTOR_DROPDOWN = '.dropdown';
var $fb0d70065cb9c259$var$SELECTOR_DROPDOWN_TOGGLE$1 = '.dropdown-toggle';
var $fb0d70065cb9c259$var$Default$1 = {
    offset: null,
    // TODO: v6 @deprecated, keep it for backwards compatibility reasons
    rootMargin: '0px 0px -25%',
    smoothScroll: false,
    target: null,
    threshold: [
        0.1,
        0.5,
        1
    ]
};
var $fb0d70065cb9c259$var$DefaultType$1 = {
    offset: '(number|null)',
    // TODO v6 @deprecated, keep it for backwards compatibility reasons
    rootMargin: 'string',
    smoothScroll: 'boolean',
    target: 'element',
    threshold: 'array'
};
/**
 * Class definition
 */ var $fb0d70065cb9c259$export$a6472a5298a374be = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $b4d46f07ff8e4522$export$71511d61b312f219)(ScrollSpy, BaseComponent);
    function ScrollSpy(element, config) {
        (0, $86c0177781495fc1$export$71511d61b312f219)(this, ScrollSpy);
        var _this;
        _this = (0, $ffc84c232c16c006$export$71511d61b312f219)(this, ScrollSpy, [
            element,
            config
        ]);
        // this._element is the observablesContainer and config.target the menu links wrapper
        _this._targetLinks = new Map();
        _this._observableSections = new Map();
        _this._rootElement = getComputedStyle(_this._element).overflowY === 'visible' ? null : _this._element;
        _this._activeTarget = null;
        _this._observer = null;
        _this._previousScrollData = {
            visibleEntryTop: 0,
            parentScrollTop: 0
        };
        _this.refresh(); // initialize
        return _this;
    }
    (0, $c2914329721d6e2b$export$71511d61b312f219)(ScrollSpy, [
        {
            // Public
            key: "refresh",
            value: function refresh() {
                this._initializeTargetsAndObservables();
                this._maybeEnableSmoothScroll();
                if (this._observer) this._observer.disconnect();
                else this._observer = this._getNewObserver();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._observableSections.values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var section = _step.value;
                        this._observer.observe(section);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                this._observer.disconnect();
                (0, $63451875c32f6bcb$export$71511d61b312f219)((0, $bf96ff342948c5d5$export$71511d61b312f219)(ScrollSpy.prototype), "dispose", this).call(this);
            }
        },
        {
            // Private
            key: "_configAfterMerge",
            value: function _configAfterMerge(config) {
                // TODO: on v6 target should be given explicitly & remove the {target: 'ss-target'} case
                config.target = $fb0d70065cb9c259$var$getElement(config.target) || document.body;
                // TODO: v6 Only for backwards compatibility reasons. Use rootMargin only
                config.rootMargin = config.offset ? "".concat(config.offset, "px 0px -30%") : config.rootMargin;
                if (typeof config.threshold === 'string') config.threshold = config.threshold.split(',').map(function(value) {
                    return Number.parseFloat(value);
                });
                return config;
            }
        },
        {
            key: "_maybeEnableSmoothScroll",
            value: function _maybeEnableSmoothScroll() {
                var _this = this;
                if (!this._config.smoothScroll) return;
                // unregister any previous listeners
                $fb0d70065cb9c259$var$EventHandler.off(this._config.target, $fb0d70065cb9c259$var$EVENT_CLICK);
                $fb0d70065cb9c259$var$EventHandler.on(this._config.target, $fb0d70065cb9c259$var$EVENT_CLICK, $fb0d70065cb9c259$var$SELECTOR_TARGET_LINKS, function(event) {
                    var observableSection = _this._observableSections.get(event.target.hash);
                    if (observableSection) {
                        event.preventDefault();
                        var root = _this._rootElement || window;
                        var height = observableSection.offsetTop - _this._element.offsetTop;
                        if (root.scrollTo) {
                            root.scrollTo({
                                top: height,
                                behavior: 'smooth'
                            });
                            return;
                        }
                        // Chrome 60 doesn't support `scrollTo`
                        root.scrollTop = height;
                    }
                });
            }
        },
        {
            key: "_getNewObserver",
            value: function _getNewObserver() {
                var _this = this;
                var options = {
                    root: this._rootElement,
                    threshold: this._config.threshold,
                    rootMargin: this._config.rootMargin
                };
                return new IntersectionObserver(function(entries) {
                    return _this._observerCallback(entries);
                }, options);
            }
        },
        {
            // The logic of selection
            key: "_observerCallback",
            value: function _observerCallback(entries) {
                var _this = this;
                var targetElement = function(entry) {
                    return _this._targetLinks.get("#".concat(entry.target.id));
                };
                var activate = function(entry) {
                    _this._previousScrollData.visibleEntryTop = entry.target.offsetTop;
                    _this._process(targetElement(entry));
                };
                var parentScrollTop = (this._rootElement || document.documentElement).scrollTop;
                var userScrollsDown = parentScrollTop >= this._previousScrollData.parentScrollTop;
                this._previousScrollData.parentScrollTop = parentScrollTop;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var entry = _step.value;
                        if (!entry.isIntersecting) {
                            this._activeTarget = null;
                            this._clearActiveClass(targetElement(entry));
                            continue;
                        }
                        var entryIsLowerThanPrevious = entry.target.offsetTop >= this._previousScrollData.visibleEntryTop;
                        // if we are scrolling down, pick the bigger offsetTop
                        if (userScrollsDown && entryIsLowerThanPrevious) {
                            activate(entry);
                            // if parent isn't scrolled, let's keep the first visible item, breaking the iteration
                            if (!parentScrollTop) return;
                            continue;
                        }
                        // if we are scrolling up, pick the smallest offsetTop
                        if (!userScrollsDown && !entryIsLowerThanPrevious) activate(entry);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "_initializeTargetsAndObservables",
            value: function _initializeTargetsAndObservables() {
                this._targetLinks = new Map();
                this._observableSections = new Map();
                var targetLinks = $fb0d70065cb9c259$var$SelectorEngine.find($fb0d70065cb9c259$var$SELECTOR_TARGET_LINKS, this._config.target);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = targetLinks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var anchor = _step.value;
                        // ensure that the anchor has an id and is not disabled
                        if (!anchor.hash || $fb0d70065cb9c259$var$isDisabled(anchor)) continue;
                        var observableSection = $fb0d70065cb9c259$var$SelectorEngine.findOne(decodeURI(anchor.hash), this._element);
                        // ensure that the observableSection exists & is visible
                        if ($fb0d70065cb9c259$var$isVisible(observableSection)) {
                            this._targetLinks.set(decodeURI(anchor.hash), anchor);
                            this._observableSections.set(anchor.hash, observableSection);
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "_process",
            value: function _process(target) {
                if (this._activeTarget === target) return;
                this._clearActiveClass(this._config.target);
                this._activeTarget = target;
                target.classList.add($fb0d70065cb9c259$var$CLASS_NAME_ACTIVE$1);
                this._activateParents(target);
                $fb0d70065cb9c259$var$EventHandler.trigger(this._element, $fb0d70065cb9c259$var$EVENT_ACTIVATE, {
                    relatedTarget: target
                });
            }
        },
        {
            key: "_activateParents",
            value: function _activateParents(target) {
                // Activate dropdown parents
                if (target.classList.contains($fb0d70065cb9c259$var$CLASS_NAME_DROPDOWN_ITEM)) {
                    $fb0d70065cb9c259$var$SelectorEngine.findOne($fb0d70065cb9c259$var$SELECTOR_DROPDOWN_TOGGLE$1, target.closest($fb0d70065cb9c259$var$SELECTOR_DROPDOWN)).classList.add($fb0d70065cb9c259$var$CLASS_NAME_ACTIVE$1);
                    return;
                }
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator = $fb0d70065cb9c259$var$SelectorEngine.parents(target, $fb0d70065cb9c259$var$SELECTOR_NAV_LIST_GROUP)[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
                        var listGroup = _step.value;
                        try {
                            // Set triggered links parents as active
                            // With both <ul> and <nav> markup a parent is the previous sibling of any nav ancestor
                            for(var _iterator1 = $fb0d70065cb9c259$var$SelectorEngine.prev(listGroup, $fb0d70065cb9c259$var$SELECTOR_LINK_ITEMS)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                                var item = _step1.value;
                                item.classList.add($fb0d70065cb9c259$var$CLASS_NAME_ACTIVE$1);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
            }
        },
        {
            key: "_clearActiveClass",
            value: function _clearActiveClass(parent) {
                parent.classList.remove($fb0d70065cb9c259$var$CLASS_NAME_ACTIVE$1);
                var activeNodes = $fb0d70065cb9c259$var$SelectorEngine.find("".concat($fb0d70065cb9c259$var$SELECTOR_TARGET_LINKS, ".").concat($fb0d70065cb9c259$var$CLASS_NAME_ACTIVE$1), parent);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = activeNodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var node = _step.value;
                        node.classList.remove($fb0d70065cb9c259$var$CLASS_NAME_ACTIVE$1);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return $fb0d70065cb9c259$var$Default$1;
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return $fb0d70065cb9c259$var$DefaultType$1;
            }
        },
        {
            key: "NAME",
            get: function get() {
                return $fb0d70065cb9c259$var$NAME$2;
            }
        },
        {
            key: "jQueryInterface",
            value: // Static
            function jQueryInterface(config) {
                return this.each(function() {
                    var data = ScrollSpy.getOrCreateInstance(this, config);
                    if (typeof config !== 'string') return;
                    if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError('No method named "'.concat(config, '"'));
                    data[config]();
                });
            }
        }
    ]);
    return ScrollSpy;
}($fb0d70065cb9c259$var$BaseComponent);
/**
 * Data API implementation
 */ $fb0d70065cb9c259$var$EventHandler.on(window, $fb0d70065cb9c259$var$EVENT_LOAD_DATA_API$1, function() {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $fb0d70065cb9c259$var$SelectorEngine.find($fb0d70065cb9c259$var$SELECTOR_DATA_SPY)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var spy = _step.value;
            $fb0d70065cb9c259$export$a6472a5298a374be.getOrCreateInstance(spy);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
});
/**
 * jQuery
 */ $fb0d70065cb9c259$var$defineJQueryPlugin($fb0d70065cb9c259$export$a6472a5298a374be);
/**
 * --------------------------------------------------------------------------
 * Bootstrap tab.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $fb0d70065cb9c259$var$NAME$1 = 'tab';
var $fb0d70065cb9c259$var$DATA_KEY$1 = 'bs.tab';
var $fb0d70065cb9c259$var$EVENT_KEY$1 = ".".concat($fb0d70065cb9c259$var$DATA_KEY$1);
var $fb0d70065cb9c259$var$EVENT_HIDE$1 = "hide".concat($fb0d70065cb9c259$var$EVENT_KEY$1);
var $fb0d70065cb9c259$var$EVENT_HIDDEN$1 = "hidden".concat($fb0d70065cb9c259$var$EVENT_KEY$1);
var $fb0d70065cb9c259$var$EVENT_SHOW$1 = "show".concat($fb0d70065cb9c259$var$EVENT_KEY$1);
var $fb0d70065cb9c259$var$EVENT_SHOWN$1 = "shown".concat($fb0d70065cb9c259$var$EVENT_KEY$1);
var $fb0d70065cb9c259$var$EVENT_CLICK_DATA_API = "click".concat($fb0d70065cb9c259$var$EVENT_KEY$1);
var $fb0d70065cb9c259$var$EVENT_KEYDOWN = "keydown".concat($fb0d70065cb9c259$var$EVENT_KEY$1);
var $fb0d70065cb9c259$var$EVENT_LOAD_DATA_API = "load".concat($fb0d70065cb9c259$var$EVENT_KEY$1);
var $fb0d70065cb9c259$var$ARROW_LEFT_KEY = 'ArrowLeft';
var $fb0d70065cb9c259$var$ARROW_RIGHT_KEY = 'ArrowRight';
var $fb0d70065cb9c259$var$ARROW_UP_KEY = 'ArrowUp';
var $fb0d70065cb9c259$var$ARROW_DOWN_KEY = 'ArrowDown';
var $fb0d70065cb9c259$var$HOME_KEY = 'Home';
var $fb0d70065cb9c259$var$END_KEY = 'End';
var $fb0d70065cb9c259$var$CLASS_NAME_ACTIVE = 'active';
var $fb0d70065cb9c259$var$CLASS_NAME_FADE$1 = 'fade';
var $fb0d70065cb9c259$var$CLASS_NAME_SHOW$1 = 'show';
var $fb0d70065cb9c259$var$CLASS_DROPDOWN = 'dropdown';
var $fb0d70065cb9c259$var$SELECTOR_DROPDOWN_TOGGLE = '.dropdown-toggle';
var $fb0d70065cb9c259$var$SELECTOR_DROPDOWN_MENU = '.dropdown-menu';
var $fb0d70065cb9c259$var$NOT_SELECTOR_DROPDOWN_TOGGLE = ":not(".concat($fb0d70065cb9c259$var$SELECTOR_DROPDOWN_TOGGLE, ")");
var $fb0d70065cb9c259$var$SELECTOR_TAB_PANEL = '.list-group, .nav, [role="tablist"]';
var $fb0d70065cb9c259$var$SELECTOR_OUTER = '.nav-item, .list-group-item';
var $fb0d70065cb9c259$var$SELECTOR_INNER = ".nav-link".concat($fb0d70065cb9c259$var$NOT_SELECTOR_DROPDOWN_TOGGLE, ", .list-group-item").concat($fb0d70065cb9c259$var$NOT_SELECTOR_DROPDOWN_TOGGLE, ', [role="tab"]').concat($fb0d70065cb9c259$var$NOT_SELECTOR_DROPDOWN_TOGGLE);
var $fb0d70065cb9c259$var$SELECTOR_DATA_TOGGLE = '[data-bs-toggle="tab"], [data-bs-toggle="pill"], [data-bs-toggle="list"]'; // TODO: could only be `tab` in v6
var $fb0d70065cb9c259$var$SELECTOR_INNER_ELEM = "".concat($fb0d70065cb9c259$var$SELECTOR_INNER, ", ").concat($fb0d70065cb9c259$var$SELECTOR_DATA_TOGGLE);
var $fb0d70065cb9c259$var$SELECTOR_DATA_TOGGLE_ACTIVE = ".".concat($fb0d70065cb9c259$var$CLASS_NAME_ACTIVE, '[data-bs-toggle="tab"], .').concat($fb0d70065cb9c259$var$CLASS_NAME_ACTIVE, '[data-bs-toggle="pill"], .').concat($fb0d70065cb9c259$var$CLASS_NAME_ACTIVE, '[data-bs-toggle="list"]');
/**
 * Class definition
 */ var $fb0d70065cb9c259$export$3e41faf802a29e71 = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $b4d46f07ff8e4522$export$71511d61b312f219)(Tab, BaseComponent);
    function Tab(element) {
        (0, $86c0177781495fc1$export$71511d61b312f219)(this, Tab);
        var _this;
        _this = (0, $ffc84c232c16c006$export$71511d61b312f219)(this, Tab, [
            element
        ]);
        _this._parent = _this._element.closest($fb0d70065cb9c259$var$SELECTOR_TAB_PANEL);
        if (!_this._parent) return (0, $f42b3052967027bf$export$71511d61b312f219)(_this);
        // Set up initial aria attributes
        _this._setInitialAttributes(_this._parent, _this._getChildren());
        $fb0d70065cb9c259$var$EventHandler.on(_this._element, $fb0d70065cb9c259$var$EVENT_KEYDOWN, function(event) {
            return _this._keydown(event);
        });
        return _this;
    }
    (0, $c2914329721d6e2b$export$71511d61b312f219)(Tab, [
        {
            // Public
            key: "show",
            value: function show() {
                // Shows this elem and deactivate the active sibling if exists
                var innerElem = this._element;
                if (this._elemIsActive(innerElem)) return;
                // Search for active tab on same parent to deactivate it
                var active = this._getActiveElem();
                var hideEvent = active ? $fb0d70065cb9c259$var$EventHandler.trigger(active, $fb0d70065cb9c259$var$EVENT_HIDE$1, {
                    relatedTarget: innerElem
                }) : null;
                var showEvent = $fb0d70065cb9c259$var$EventHandler.trigger(innerElem, $fb0d70065cb9c259$var$EVENT_SHOW$1, {
                    relatedTarget: active
                });
                if (showEvent.defaultPrevented || hideEvent && hideEvent.defaultPrevented) return;
                this._deactivate(active, innerElem);
                this._activate(innerElem, active);
            }
        },
        {
            // Private
            key: "_activate",
            value: function _activate(element, relatedElem) {
                var _this = this;
                if (!element) return;
                element.classList.add($fb0d70065cb9c259$var$CLASS_NAME_ACTIVE);
                this._activate($fb0d70065cb9c259$var$SelectorEngine.getElementFromSelector(element)); // Search and activate/show the proper section
                var complete = function() {
                    if (element.getAttribute('role') !== 'tab') {
                        element.classList.add($fb0d70065cb9c259$var$CLASS_NAME_SHOW$1);
                        return;
                    }
                    element.removeAttribute('tabindex');
                    element.setAttribute('aria-selected', true);
                    _this._toggleDropDown(element, true);
                    $fb0d70065cb9c259$var$EventHandler.trigger(element, $fb0d70065cb9c259$var$EVENT_SHOWN$1, {
                        relatedTarget: relatedElem
                    });
                };
                this._queueCallback(complete, element, element.classList.contains($fb0d70065cb9c259$var$CLASS_NAME_FADE$1));
            }
        },
        {
            key: "_deactivate",
            value: function _deactivate(element, relatedElem) {
                var _this = this;
                if (!element) return;
                element.classList.remove($fb0d70065cb9c259$var$CLASS_NAME_ACTIVE);
                element.blur();
                this._deactivate($fb0d70065cb9c259$var$SelectorEngine.getElementFromSelector(element)); // Search and deactivate the shown section too
                var complete = function() {
                    if (element.getAttribute('role') !== 'tab') {
                        element.classList.remove($fb0d70065cb9c259$var$CLASS_NAME_SHOW$1);
                        return;
                    }
                    element.setAttribute('aria-selected', false);
                    element.setAttribute('tabindex', '-1');
                    _this._toggleDropDown(element, false);
                    $fb0d70065cb9c259$var$EventHandler.trigger(element, $fb0d70065cb9c259$var$EVENT_HIDDEN$1, {
                        relatedTarget: relatedElem
                    });
                };
                this._queueCallback(complete, element, element.classList.contains($fb0d70065cb9c259$var$CLASS_NAME_FADE$1));
            }
        },
        {
            key: "_keydown",
            value: function _keydown(event) {
                if (![
                    $fb0d70065cb9c259$var$ARROW_LEFT_KEY,
                    $fb0d70065cb9c259$var$ARROW_RIGHT_KEY,
                    $fb0d70065cb9c259$var$ARROW_UP_KEY,
                    $fb0d70065cb9c259$var$ARROW_DOWN_KEY,
                    $fb0d70065cb9c259$var$HOME_KEY,
                    $fb0d70065cb9c259$var$END_KEY
                ].includes(event.key)) return;
                event.stopPropagation(); // stopPropagation/preventDefault both added to support up/down keys without scrolling the page
                event.preventDefault();
                var children = this._getChildren().filter(function(element) {
                    return !$fb0d70065cb9c259$var$isDisabled(element);
                });
                var nextActiveElement;
                if ([
                    $fb0d70065cb9c259$var$HOME_KEY,
                    $fb0d70065cb9c259$var$END_KEY
                ].includes(event.key)) nextActiveElement = children[event.key === $fb0d70065cb9c259$var$HOME_KEY ? 0 : children.length - 1];
                else {
                    var isNext = [
                        $fb0d70065cb9c259$var$ARROW_RIGHT_KEY,
                        $fb0d70065cb9c259$var$ARROW_DOWN_KEY
                    ].includes(event.key);
                    nextActiveElement = $fb0d70065cb9c259$var$getNextActiveElement(children, event.target, isNext, true);
                }
                if (nextActiveElement) {
                    nextActiveElement.focus({
                        preventScroll: true
                    });
                    Tab.getOrCreateInstance(nextActiveElement).show();
                }
            }
        },
        {
            key: "_getChildren",
            value: function _getChildren() {
                // collection of inner elements
                return $fb0d70065cb9c259$var$SelectorEngine.find($fb0d70065cb9c259$var$SELECTOR_INNER_ELEM, this._parent);
            }
        },
        {
            key: "_getActiveElem",
            value: function _getActiveElem() {
                var _this = this;
                return this._getChildren().find(function(child) {
                    return _this._elemIsActive(child);
                }) || null;
            }
        },
        {
            key: "_setInitialAttributes",
            value: function _setInitialAttributes(parent, children) {
                this._setAttributeIfNotExists(parent, 'role', 'tablist');
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var child = _step.value;
                        this._setInitialAttributesOnChild(child);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "_setInitialAttributesOnChild",
            value: function _setInitialAttributesOnChild(child) {
                child = this._getInnerElement(child);
                var isActive = this._elemIsActive(child);
                var outerElem = this._getOuterElement(child);
                child.setAttribute('aria-selected', isActive);
                if (outerElem !== child) this._setAttributeIfNotExists(outerElem, 'role', 'presentation');
                if (!isActive) child.setAttribute('tabindex', '-1');
                this._setAttributeIfNotExists(child, 'role', 'tab');
                // set attributes to the related panel too
                this._setInitialAttributesOnTargetPanel(child);
            }
        },
        {
            key: "_setInitialAttributesOnTargetPanel",
            value: function _setInitialAttributesOnTargetPanel(child) {
                var target = $fb0d70065cb9c259$var$SelectorEngine.getElementFromSelector(child);
                if (!target) return;
                this._setAttributeIfNotExists(target, 'role', 'tabpanel');
                if (child.id) this._setAttributeIfNotExists(target, 'aria-labelledby', "".concat(child.id));
            }
        },
        {
            key: "_toggleDropDown",
            value: function _toggleDropDown(element, open) {
                var outerElem = this._getOuterElement(element);
                if (!outerElem.classList.contains($fb0d70065cb9c259$var$CLASS_DROPDOWN)) return;
                var toggle = function(selector, className) {
                    var _$element = $fb0d70065cb9c259$var$SelectorEngine.findOne(selector, outerElem);
                    if (_$element) _$element.classList.toggle(className, open);
                };
                toggle($fb0d70065cb9c259$var$SELECTOR_DROPDOWN_TOGGLE, $fb0d70065cb9c259$var$CLASS_NAME_ACTIVE);
                toggle($fb0d70065cb9c259$var$SELECTOR_DROPDOWN_MENU, $fb0d70065cb9c259$var$CLASS_NAME_SHOW$1);
                outerElem.setAttribute('aria-expanded', open);
            }
        },
        {
            key: "_setAttributeIfNotExists",
            value: function _setAttributeIfNotExists(element, attribute, value) {
                if (!element.hasAttribute(attribute)) element.setAttribute(attribute, value);
            }
        },
        {
            key: "_elemIsActive",
            value: function _elemIsActive(elem) {
                return elem.classList.contains($fb0d70065cb9c259$var$CLASS_NAME_ACTIVE);
            }
        },
        {
            // Try to get the inner element (usually the .nav-link)
            key: "_getInnerElement",
            value: function _getInnerElement(elem) {
                return elem.matches($fb0d70065cb9c259$var$SELECTOR_INNER_ELEM) ? elem : $fb0d70065cb9c259$var$SelectorEngine.findOne($fb0d70065cb9c259$var$SELECTOR_INNER_ELEM, elem);
            }
        },
        {
            // Try to get the outer element (usually the .nav-item)
            key: "_getOuterElement",
            value: function _getOuterElement(elem) {
                return elem.closest($fb0d70065cb9c259$var$SELECTOR_OUTER) || elem;
            }
        }
    ], [
        {
            key: "NAME",
            get: // Getters
            function get() {
                return $fb0d70065cb9c259$var$NAME$1;
            }
        },
        {
            key: "jQueryInterface",
            value: // Static
            function jQueryInterface(config) {
                return this.each(function() {
                    var data = Tab.getOrCreateInstance(this);
                    if (typeof config !== 'string') return;
                    if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError('No method named "'.concat(config, '"'));
                    data[config]();
                });
            }
        }
    ]);
    return Tab;
}($fb0d70065cb9c259$var$BaseComponent);
/**
 * Data API implementation
 */ $fb0d70065cb9c259$var$EventHandler.on(document, $fb0d70065cb9c259$var$EVENT_CLICK_DATA_API, $fb0d70065cb9c259$var$SELECTOR_DATA_TOGGLE, function(event) {
    if ([
        'A',
        'AREA'
    ].includes(this.tagName)) event.preventDefault();
    if ($fb0d70065cb9c259$var$isDisabled(this)) return;
    $fb0d70065cb9c259$export$3e41faf802a29e71.getOrCreateInstance(this).show();
});
/**
 * Initialize on focus
 */ $fb0d70065cb9c259$var$EventHandler.on(window, $fb0d70065cb9c259$var$EVENT_LOAD_DATA_API, function() {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $fb0d70065cb9c259$var$SelectorEngine.find($fb0d70065cb9c259$var$SELECTOR_DATA_TOGGLE_ACTIVE)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var element = _step.value;
            $fb0d70065cb9c259$export$3e41faf802a29e71.getOrCreateInstance(element);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
});
/**
 * jQuery
 */ $fb0d70065cb9c259$var$defineJQueryPlugin($fb0d70065cb9c259$export$3e41faf802a29e71);
/**
 * --------------------------------------------------------------------------
 * Bootstrap toast.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $fb0d70065cb9c259$var$NAME = 'toast';
var $fb0d70065cb9c259$var$DATA_KEY = 'bs.toast';
var $fb0d70065cb9c259$var$EVENT_KEY = ".".concat($fb0d70065cb9c259$var$DATA_KEY);
var $fb0d70065cb9c259$var$EVENT_MOUSEOVER = "mouseover".concat($fb0d70065cb9c259$var$EVENT_KEY);
var $fb0d70065cb9c259$var$EVENT_MOUSEOUT = "mouseout".concat($fb0d70065cb9c259$var$EVENT_KEY);
var $fb0d70065cb9c259$var$EVENT_FOCUSIN = "focusin".concat($fb0d70065cb9c259$var$EVENT_KEY);
var $fb0d70065cb9c259$var$EVENT_FOCUSOUT = "focusout".concat($fb0d70065cb9c259$var$EVENT_KEY);
var $fb0d70065cb9c259$var$EVENT_HIDE = "hide".concat($fb0d70065cb9c259$var$EVENT_KEY);
var $fb0d70065cb9c259$var$EVENT_HIDDEN = "hidden".concat($fb0d70065cb9c259$var$EVENT_KEY);
var $fb0d70065cb9c259$var$EVENT_SHOW = "show".concat($fb0d70065cb9c259$var$EVENT_KEY);
var $fb0d70065cb9c259$var$EVENT_SHOWN = "shown".concat($fb0d70065cb9c259$var$EVENT_KEY);
var $fb0d70065cb9c259$var$CLASS_NAME_FADE = 'fade';
var $fb0d70065cb9c259$var$CLASS_NAME_HIDE = 'hide'; // @deprecated - kept here only for backwards compatibility
var $fb0d70065cb9c259$var$CLASS_NAME_SHOW = 'show';
var $fb0d70065cb9c259$var$CLASS_NAME_SHOWING = 'showing';
var $fb0d70065cb9c259$var$DefaultType = {
    animation: 'boolean',
    autohide: 'boolean',
    delay: 'number'
};
var $fb0d70065cb9c259$var$Default = {
    animation: true,
    autohide: true,
    delay: 5000
};
/**
 * Class definition
 */ var $fb0d70065cb9c259$export$8d8dc7d5f743331b = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $b4d46f07ff8e4522$export$71511d61b312f219)(Toast, BaseComponent);
    function Toast(element, config) {
        (0, $86c0177781495fc1$export$71511d61b312f219)(this, Toast);
        var _this;
        _this = (0, $ffc84c232c16c006$export$71511d61b312f219)(this, Toast, [
            element,
            config
        ]);
        _this._timeout = null;
        _this._hasMouseInteraction = false;
        _this._hasKeyboardInteraction = false;
        _this._setListeners();
        return _this;
    }
    (0, $c2914329721d6e2b$export$71511d61b312f219)(Toast, [
        {
            // Public
            key: "show",
            value: function show() {
                var _this = this;
                var showEvent = $fb0d70065cb9c259$var$EventHandler.trigger(this._element, $fb0d70065cb9c259$var$EVENT_SHOW);
                if (showEvent.defaultPrevented) return;
                this._clearTimeout();
                if (this._config.animation) this._element.classList.add($fb0d70065cb9c259$var$CLASS_NAME_FADE);
                var complete = function() {
                    _this._element.classList.remove($fb0d70065cb9c259$var$CLASS_NAME_SHOWING);
                    $fb0d70065cb9c259$var$EventHandler.trigger(_this._element, $fb0d70065cb9c259$var$EVENT_SHOWN);
                    _this._maybeScheduleHide();
                };
                this._element.classList.remove($fb0d70065cb9c259$var$CLASS_NAME_HIDE); // @deprecated
                $fb0d70065cb9c259$var$reflow(this._element);
                this._element.classList.add($fb0d70065cb9c259$var$CLASS_NAME_SHOW, $fb0d70065cb9c259$var$CLASS_NAME_SHOWING);
                this._queueCallback(complete, this._element, this._config.animation);
            }
        },
        {
            key: "hide",
            value: function hide() {
                var _this = this;
                if (!this.isShown()) return;
                var hideEvent = $fb0d70065cb9c259$var$EventHandler.trigger(this._element, $fb0d70065cb9c259$var$EVENT_HIDE);
                if (hideEvent.defaultPrevented) return;
                var complete = function() {
                    _this._element.classList.add($fb0d70065cb9c259$var$CLASS_NAME_HIDE); // @deprecated
                    _this._element.classList.remove($fb0d70065cb9c259$var$CLASS_NAME_SHOWING, $fb0d70065cb9c259$var$CLASS_NAME_SHOW);
                    $fb0d70065cb9c259$var$EventHandler.trigger(_this._element, $fb0d70065cb9c259$var$EVENT_HIDDEN);
                };
                this._element.classList.add($fb0d70065cb9c259$var$CLASS_NAME_SHOWING);
                this._queueCallback(complete, this._element, this._config.animation);
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                this._clearTimeout();
                if (this.isShown()) this._element.classList.remove($fb0d70065cb9c259$var$CLASS_NAME_SHOW);
                (0, $63451875c32f6bcb$export$71511d61b312f219)((0, $bf96ff342948c5d5$export$71511d61b312f219)(Toast.prototype), "dispose", this).call(this);
            }
        },
        {
            key: "isShown",
            value: function isShown() {
                return this._element.classList.contains($fb0d70065cb9c259$var$CLASS_NAME_SHOW);
            }
        },
        {
            // Private
            key: "_maybeScheduleHide",
            value: function _maybeScheduleHide() {
                var _this = this;
                if (!this._config.autohide) return;
                if (this._hasMouseInteraction || this._hasKeyboardInteraction) return;
                this._timeout = setTimeout(function() {
                    _this.hide();
                }, this._config.delay);
            }
        },
        {
            key: "_onInteraction",
            value: function _onInteraction(event, isInteracting) {
                switch(event.type){
                    case 'mouseover':
                    case 'mouseout':
                        this._hasMouseInteraction = isInteracting;
                        break;
                    case 'focusin':
                    case 'focusout':
                        this._hasKeyboardInteraction = isInteracting;
                        break;
                }
                if (isInteracting) {
                    this._clearTimeout();
                    return;
                }
                var nextElement = event.relatedTarget;
                if (this._element === nextElement || this._element.contains(nextElement)) return;
                this._maybeScheduleHide();
            }
        },
        {
            key: "_setListeners",
            value: function _setListeners() {
                var _this = this;
                $fb0d70065cb9c259$var$EventHandler.on(this._element, $fb0d70065cb9c259$var$EVENT_MOUSEOVER, function(event) {
                    return _this._onInteraction(event, true);
                });
                $fb0d70065cb9c259$var$EventHandler.on(this._element, $fb0d70065cb9c259$var$EVENT_MOUSEOUT, function(event) {
                    return _this._onInteraction(event, false);
                });
                $fb0d70065cb9c259$var$EventHandler.on(this._element, $fb0d70065cb9c259$var$EVENT_FOCUSIN, function(event) {
                    return _this._onInteraction(event, true);
                });
                $fb0d70065cb9c259$var$EventHandler.on(this._element, $fb0d70065cb9c259$var$EVENT_FOCUSOUT, function(event) {
                    return _this._onInteraction(event, false);
                });
            }
        },
        {
            key: "_clearTimeout",
            value: function _clearTimeout() {
                clearTimeout(this._timeout);
                this._timeout = null;
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return $fb0d70065cb9c259$var$Default;
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return $fb0d70065cb9c259$var$DefaultType;
            }
        },
        {
            key: "NAME",
            get: function get() {
                return $fb0d70065cb9c259$var$NAME;
            }
        },
        {
            key: "jQueryInterface",
            value: // Static
            function jQueryInterface(config) {
                return this.each(function() {
                    var data = Toast.getOrCreateInstance(this, config);
                    if (typeof config === 'string') {
                        if (typeof data[config] === 'undefined') throw new TypeError('No method named "'.concat(config, '"'));
                        data[config](this);
                    }
                });
            }
        }
    ]);
    return Toast;
}($fb0d70065cb9c259$var$BaseComponent);
/**
 * Data API implementation
 */ $fb0d70065cb9c259$var$enableDismissTrigger($fb0d70065cb9c259$export$8d8dc7d5f743331b);
/**
 * jQuery
 */ $fb0d70065cb9c259$var$defineJQueryPlugin($fb0d70065cb9c259$export$8d8dc7d5f743331b);


// ...or individually as
//import Alert from 'bootstrap/js/dist/alert'
// ...or, specify which plugins you need:
//import { Alert, Tooltip, Toast, Popover } from 'bootstrap';
/**
 * Example exports for testing via Jest
 */ $443abc400d22a160$exports = {
    exampleSum: function exampleSum(a, b) {
        return a + b;
    },
    isJqueryLoaded: typeof jQuery === 'function' || typeof $ === 'function',
    isBootstrapLoaded: typeof jQuery().modal === 'function'
};
/**
 * Document Ready Functions
 */ jQuery(document).ready(function($1) {
    /**
   * Enable Bootstrap tooltips
   */ var tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
    var tooltipList = (0, $2l5av._)(tooltipTriggerList).map(function(tooltipTriggerEl) {
        return new $fb0d70065cb9c259$export$28c660c63b792dea(tooltipTriggerEl, {
            container: 'body'
        });
    });
    /**
   * Determine "opened" height of FW Slider slide description (fallback for unsupported calc-size in Firefox/Safari)
   */ if (!CSS.supports('height', 'calc-size(auto, size)')) {
        console.info('Browser support for css calc-size() not detected: FW Slider slide description height fallback enabled.');
        $1('.fw_slider-slide').on('mouseenter', function(ev) {
            var blurContent = $1(ev.target).closest('.splide__slide').find('.fw_slider-slide-description')[0], blurContentHeight = blurContent.scrollHeight;
            $1(ev.target).find('.fw_slider-slide-description').height(blurContentHeight);
        }).on('mouseleave', function(ev) {
            $1(ev.target).find('.fw_slider-slide-description').height(0);
        });
    }
    /**
   * Social Media New Window Pop-Ups (e.g. Twitter)
   */ $1('a.social-share').on('click', function(e) {
        e.preventDefault();
        var url = $1(this).attr('href');
        window.open(url, '_blank', 'toolbar=yes, scrollbars=yes, resizable=no, top=200, left=200, width=570, height=400');
    });
    /**
   * Open External Links in a new tab automatically
   */ $1('#content').on('click', 'a', function(ev) {
        var thisHost = new RegExp('/' + window.location.host + '/'), isExternalLink = this.href && !thisHost.test(this.href) && !$1(this).hasClass('social-share');
        if (isExternalLink) {
            event.preventDefault();
            event.stopPropagation();
            window.open(this.href, '_blank');
        }
    });
    /**
   * Sticky header compact logo on scroll (header-ai)
   */ var $stickyNav = $1('#header');
    var scrollWatcher = document.querySelector('.scroll-watcher');
    var observer = new IntersectionObserver(function(entries) {
        // If the sentinel is intersecting (above the viewport), unstick the nav
        $stickyNav.toggleClass('is-scrolled', !entries[0].isIntersecting);
    });
    observer.observe(scrollWatcher);
    /**
   * Mobile Menu Toggler
   */ $1('#mobile-menu-button').on('click', function(e) {
        e.preventDefault();
        // Toggle the active class
        $1('body').toggleClass('mobile-menu-active');
        $1(this).toggleClass('is-active');
        // Aria toggles
        $1(this).attr('aria-expanded', function(i, attr) {
            return attr == 'true' ? 'false' : 'true';
        });
        // Text Toggler
        var text = $1('#mobile-menu-button .hamburger-text').text();
        $1('#mobile-menu-button .hamburger-text').text(text == 'Menu' ? 'Close' : 'Menu');
    });
    /**
   * Force GF required mark into <sup>
   */ $1('.gform_wrapper .gfield_required').each(function() {
        var content = $1(this).html();
        // Check if it's not already wrapped
        if (!$1(this).find('sup').length) $1(this).html('<sup class="grc-gfield_required">' + content + '</sup>');
    });
    /**
   * Post Index dropdown selected style
   */ $1('.grc-category-dropdown select, .grc-post_tag-dropdown select').on('change', function() {
        if (parseInt($1(this).val()) > 0) $1(this).parent('.grc-dropdown').addClass('grc-dropdown__selected');
        else $1(this).parent('.grc-dropdown').removeClass('grc-dropdown__selected');
    });
    $1('.grc-orderby-dropdown select').on('change', function() {
        if ($1(this).val().length && $1(this).val() !== 'newest') $1(this).parent('.grc-dropdown').addClass('grc-dropdown__selected');
        else $1(this).parent('.grc-dropdown').removeClass('grc-dropdown__selected');
    });
});
/**
 * Window Resize Functions
 */ jQuery(window).on('resize', function($1) {});

})();
//# sourceMappingURL=global.js.map
